import React, { useState, useEffect, useRef } from 'react';
import {
  Package, MapPin, Clock, DollarSign, Truck, FileText, Eye, CheckCircle, Plus, X, Star, Phone, Award, AlertCircle, ArrowRight, Scale,
  Share2, Facebook, Twitter, MessageCircle, Link2, CreditCard, Lock, ShieldCheck, Gift, Heart, ThumbsUp, Send, Copy, Check,
  FileCheck, Download, QrCode, Building, Building2, Users, Printer, Shield, Hash, LogOut, Bell, ChevronDown, Navigation, User, Edit2, Save, Trash2,
  RotateCcw, Zap, Pencil, Settings, Upload,
  XCircle, Menu, ChevronRight, TrendingUp, BarChart3, Activity
} from 'lucide-react';
import L from 'leaflet';
import { useStore, getStore, expirarSolicitudesVencidas, crearSolicitud as storeCrearSolicitud, cancelarSolicitud as storeCancelarSolicitud, aceptarCotizacion, confirmarEntregaCliente, calificarServicio, getNotificacionesPendientes, marcarNotificacionesLeidas, limpiarNotificaciones, CATALOGO_INSIGNIAS, CATALOGO_INSIGNIAS_CLIENTE, actualizarFotoUsuario, actualizarPerfilCliente, hacerOfertaRetorno, aceptarContraofertaRetorno, confirmarDireccionesRetorno, confirmarPagoRetorno, actualizarCoordsOferta, confirmarEntregaRetorno, rechazarContraofertaCliente, guardarPlantillaRuta, eliminarPlantillaRuta, generarCodigoReferido, getResumenReferidos, getSaldoRedUsuario, getArbolReferidos, vincularPersonaFisicaRed, solicitarRetiroFondos } from '../store';
import { useApiStore } from '../hooks/useApiStore';
import { apiCrearSolicitud, apiCancelarSolicitud, apiEditarSolicitud, apiAceptarCotizacion, apiConfirmarEntrega, apiCancelarViaje, apiCalificar, apiOfertarRetorno, apiClienteResponderContraoferta, apiCancelarOfertaRetorno, apiMarcarLeidas, apiEliminarTodasNotificaciones, apiEliminarNotificacion, apiConfirmarEntregaRetorno, apiCrearPreferenciaRetorno, apiPagarRetorno, apiActualizarPerfil, guardarUsuario, apiGuardarCartaPorte, apiGuardarContactoDestino, apiSolicitarRetiro, apiGetMisRetiros, apiGetMisPagos, apiGetArbolReferidos, apiCrearPreferenciaMercadoPago, apiResendVerification, apiSolicitarFactura, apiSubirFacturaTransportista, apiGetDownloadUrl, apiEnviarMensaje, apiGetCalificacionesUsuario, apiGetMisMetricas, apiCrearPreferenciaContraEntrega, apiReclamarContraEntrega } from '../api';
import ChatModal from '../components/ChatModal';
import FeedbackButton from '../components/FeedbackButton';
import TipoUnidadBadge from '../components/TruckTypeIcon';
import { solicitarPermisoNotif, fireNotifBrowser, playNotifSound } from '../notifHelper';
import { phCapture } from '../posthog';

// Fix Leaflet default icon broken by webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// ========== CIUDADES BAJA CALIFORNIA ==========
const CIUDADES_BC = [
  // Baja California (BC) — Zona Tijuana/Rosarito
  'Tijuana, BC', 'Rosarito, BC', 'Playas de Rosarito, BC', 'La Misión, BC',
  'El Descanso, BC', 'Primo Tapia, BC', 'Popotla, BC', 'Puerto Nuevo, BC',
  // BC — Ensenada y costa noroeste
  'Ensenada, BC', 'Maneadero, BC', 'El Sauzal, BC', 'Punta Banda, BC',
  'Santo Tomás, BC', 'Eréndira, BC', 'San Quintín, BC', 'Camalu, BC',
  'Colonet, BC', 'San Vicente, BC', 'El Rosario, BC', 'Vicente Guerrero, BC',
  'Valle de Guadalupe, BC',
  // BC — Tecate y sierra
  'Tecate, BC', 'El Hongo, BC', 'La Rumorosa, BC', 'Valle de las Palmas, BC',
  'Ojos Negros, BC',
  // BC — Mexicali y valle
  'Mexicali, BC', 'Algodones, BC', 'San Felipe, BC', 'Guadalupe Victoria, BC',
  'Ejido Nuevo León, BC', 'Ejido Sonora, BC', 'Ciudad Morelos, BC',
  // BC — Bahía de los Ángeles / costa del golfo
  'Bahía de los Ángeles, BC', 'El Mármol, BC', 'Punta Prieta, BC',
  // Baja California Sur (BCS) — Frontera norte BCS
  'Guerrero Negro, BCS', 'Bahía Asunción, BCS', 'Punta Abreojos, BCS',
  'San Ignacio, BCS', 'Vizcaíno, BCS', 'Villa Alberto Andrés Alvarado, BCS',
  // BCS — Santa Rosalía / Mulegé
  'Santa Rosalía, BCS', 'Mulegé, BCS', 'San Carlos, BCS',
  'Bahía Concepción, BCS', 'Loreto, BCS', 'Puerto Escondido, BCS',
  // BCS — La Paz y alrededores
  'La Paz, BCS', 'El Centenario, BCS', 'La Ventana, BCS', 'Los Planes, BCS',
  'Todos Santos, BCS', 'El Pescadero, BCS', 'Ciudad Constitución, BCS',
  'Ciudad Insurgentes, BCS', 'Comondú, BCS',
  // BCS — Los Cabos y Corredor
  'Cabo San Lucas, BCS', 'San José del Cabo, BCS', 'Los Barriles, BCS',
  'Buena Vista, BCS', 'La Ribera, BCS', 'Miraflores, BCS', 'Santiago, BCS',
  'El Triunfo, BCS', 'San Antonio, BCS',
];

// ========== COORDENADAS FIJAS PENINSULA BAJA CALIFORNIA ==========
// Evita geocoding externo que puede encontrar ciudades homónimas fuera de la península
const COORDS_BC = {
  'Tijuana, BC':              { lat: 32.5149, lng: -117.0382 },
  'Rosarito, BC':             { lat: 32.3632, lng: -117.0600 },
  'Playas de Rosarito, BC':   { lat: 32.3632, lng: -117.0600 },
  'La Misión, BC':            { lat: 32.0900, lng: -116.8700 },
  'El Descanso, BC':          { lat: 32.1500, lng: -116.8800 },
  'Primo Tapia, BC':          { lat: 32.2800, lng: -116.9400 },
  'Popotla, BC':              { lat: 32.0200, lng: -116.8400 },
  'Puerto Nuevo, BC':         { lat: 32.0600, lng: -116.8800 },
  'Ensenada, BC':             { lat: 31.8667, lng: -116.5967 },
  'Maneadero, BC':            { lat: 31.7167, lng: -116.6000 },
  'El Sauzal, BC':            { lat: 31.9000, lng: -116.6500 },
  'Punta Banda, BC':          { lat: 31.7333, lng: -116.7000 },
  'Santo Tomás, BC':          { lat: 31.5500, lng: -116.4000 },
  'Eréndira, BC':             { lat: 31.3700, lng: -116.2500 },
  'San Quintín, BC':          { lat: 30.5333, lng: -115.9500 },
  'Camalu, BC':               { lat: 30.8500, lng: -116.0500 },
  'Colonet, BC':              { lat: 30.9833, lng: -116.0833 },
  'San Vicente, BC':          { lat: 31.3333, lng: -116.2500 },
  'El Rosario, BC':           { lat: 30.0667, lng: -115.7167 },
  'Vicente Guerrero, BC':     { lat: 30.7333, lng: -116.0333 },
  'Valle de Guadalupe, BC':   { lat: 32.0167, lng: -116.6500 },
  'Tecate, BC':               { lat: 32.5750, lng: -116.6278 },
  'El Hongo, BC':             { lat: 32.4500, lng: -116.4200 },
  'La Rumorosa, BC':          { lat: 32.5500, lng: -116.0667 },
  'Valle de las Palmas, BC':  { lat: 32.3833, lng: -116.5000 },
  'Ojos Negros, BC':          { lat: 31.9167, lng: -116.2667 },
  'Mexicali, BC':             { lat: 32.6636, lng: -115.4678 },
  'Algodones, BC':            { lat: 32.7167, lng: -114.7167 },
  'San Felipe, BC':           { lat: 31.0167, lng: -114.8333 },
  'Guadalupe Victoria, BC':   { lat: 32.3000, lng: -115.2000 },
  'Ejido Nuevo León, BC':     { lat: 32.1500, lng: -115.3000 },
  'Ejido Sonora, BC':         { lat: 32.2000, lng: -115.1500 },
  'Ciudad Morelos, BC':       { lat: 32.5833, lng: -114.9167 },
  'Bahía de los Ángeles, BC': { lat: 28.9500, lng: -113.5667 },
  'El Mármol, BC':            { lat: 29.8000, lng: -114.0000 },
  'Punta Prieta, BC':         { lat: 28.9333, lng: -114.1667 },
  'Guerrero Negro, BCS':      { lat: 27.9667, lng: -114.0500 },
  'Bahía Asunción, BCS':      { lat: 27.1333, lng: -114.2833 },
  'Punta Abreojos, BCS':      { lat: 26.7167, lng: -113.5500 },
  'San Ignacio, BCS':         { lat: 27.2958, lng: -112.8942 },
  'Vizcaíno, BCS':            { lat: 27.9000, lng: -113.7833 },
  'Villa Alberto Andrés Alvarado, BCS': { lat: 27.6500, lng: -113.3800 },
  'Santa Rosalía, BCS':       { lat: 27.3333, lng: -112.2667 },
  'Mulegé, BCS':              { lat: 26.8833, lng: -111.9833 },
  'San Carlos, BCS':          { lat: 24.7867, lng: -112.1083 },
  'Bahía Concepción, BCS':    { lat: 26.6833, lng: -111.8667 },
  'Loreto, BCS':              { lat: 26.0117, lng: -111.3439 },
  'Puerto Escondido, BCS':    { lat: 25.8333, lng: -111.3333 },
  'La Paz, BCS':              { lat: 24.1426, lng: -110.3128 },
  'El Centenario, BCS':       { lat: 24.0833, lng: -110.4000 },
  'La Ventana, BCS':          { lat: 24.0333, lng: -109.9667 },
  'Los Planes, BCS':          { lat: 23.9000, lng: -109.9000 },
  'Todos Santos, BCS':        { lat: 23.4483, lng: -110.2228 },
  'El Pescadero, BCS':        { lat: 23.3667, lng: -110.1667 },
  'Ciudad Constitución, BCS': { lat: 25.0333, lng: -111.7000 },
  'Ciudad Insurgentes, BCS':  { lat: 25.2833, lng: -111.7667 },
  'Comondú, BCS':             { lat: 26.0800, lng: -111.8167 },
  'Cabo San Lucas, BCS':      { lat: 22.8897, lng: -109.9167 },
  'San José del Cabo, BCS':   { lat: 23.0631, lng: -109.6906 },
  'Los Barriles, BCS':        { lat: 23.6667, lng: -109.6833 },
  'Buena Vista, BCS':         { lat: 23.6500, lng: -109.7167 },
  'La Ribera, BCS':           { lat: 23.6167, lng: -109.6500 },
  'Miraflores, BCS':          { lat: 23.3667, lng: -109.7667 },
  'Santiago, BCS':            { lat: 23.4667, lng: -109.7500 },
  'El Triunfo, BCS':          { lat: 23.7833, lng: -110.0833 },
  'San Antonio, BCS':         { lat: 23.7333, lng: -109.9167 },
};
// Fallback: centro de la península
const CENTRO_PENINSULA = { lat: 28.5, lng: -113.5 };
const getCoordsBC = (ciudadTexto) => {
  if (!ciudadTexto) return CENTRO_PENINSULA;
  return COORDS_BC[ciudadTexto] || CENTRO_PENINSULA;
};
// Calcula ciudades intermedias en ruta (mismo algoritmo que store.js)
const calcCiudadesEnRuta = (origen, destino) => {
  const A = COORDS_BC[origen]; const B = COORDS_BC[destino];
  if (!A || !B) return [];
  const dx = B.lat - A.lat; const dy = B.lng - A.lng;
  const len2 = dx * dx + dy * dy;
  const resultado = [];
  for (const [ciudad, C] of Object.entries(COORDS_BC)) {
    if (ciudad === origen || ciudad === destino) continue;
    const cx = C.lat - A.lat; const cy = C.lng - A.lng;
    const t = len2 > 0 ? (cx * dx + cy * dy) / len2 : 0;
    if (t < 0.05 || t > 0.95) continue;
    const px = A.lat + t * dx - C.lat; const py = A.lng + t * dy - C.lng;
    if (Math.sqrt(px * px + py * py) < 0.72) resultado.push({ ciudad, t });
  }
  return resultado.sort((a, b) => a.t - b.t).map(x => x.ciudad);
};

// ========== MAPA SELECTOR DE PIN ==========
function MapPickerModal({ titulo, coordInicial, onConfirm, onClose }) {
  const [pos, setPos] = React.useState(coordInicial || null);
  const [direccion, setDireccion] = React.useState(coordInicial?.direccion || '');
  const [cargando, setCargando] = React.useState(false);
  const mapDivRef = React.useRef(null);
  const mapInstanceRef = React.useRef(null);
  const markerRef = React.useRef(null);
  const posRef = React.useRef(pos);

  React.useEffect(() => { posRef.current = pos; }, [pos]);

  React.useEffect(() => {
    if (!mapDivRef.current || mapInstanceRef.current) return;

    const center = coordInicial ? [coordInicial.lat, coordInicial.lng] : [28.5, -113.5];
    const zoom = coordInicial ? 14 : 7;

    const map = L.map(mapDivRef.current).setView(center, zoom);
    mapInstanceRef.current = map;

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
    }).addTo(map);

    if (coordInicial) {
      markerRef.current = L.marker([coordInicial.lat, coordInicial.lng]).addTo(map);
    }

    map.on('click', (e) => {
      const { lat, lng } = e.latlng;
      setPos({ lat, lng });
      if (markerRef.current) {
        markerRef.current.setLatLng([lat, lng]);
      } else {
        markerRef.current = L.marker([lat, lng]).addTo(map);
      }
      setCargando(true);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`, {
        headers: { 'Accept-Language': 'es' },
        signal: controller.signal
      })
        .then(r => r.json())
        .then(data => {
          setDireccion(data.display_name || `${lat.toFixed(5)}, ${lng.toFixed(5)}`);
          setCargando(false);
        })
        .catch(() => {
          setDireccion(`${lat.toFixed(5)}, ${lng.toFixed(5)}`);
          setCargando(false);
        })
        .finally(() => clearTimeout(timeout));
    });

    return () => { try { map.remove(); } catch (_) {} mapInstanceRef.current = null; };
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-end md:items-center justify-center z-[9999] md:p-4">
      <div className="bg-white shadow-2xl rounded-t-2xl md:rounded-2xl w-full md:max-w-2xl flex flex-col" style={{ maxHeight: '92vh' }}>
        <div className="px-6 py-4 border-b flex justify-between items-center flex-shrink-0">
          <div>
            <h3 className="text-lg font-bold text-gray-800">{titulo}</h3>
            <p className="text-sm text-gray-500">Haz clic en el mapa para marcar el punto exacto</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-50">
            <X size={18} />
          </button>
        </div>

        <div ref={mapDivRef} style={{ height: 'clamp(180px, 42vh, 380px)', width: '100%', isolation: 'isolate' }} />

        <div className="px-6 py-4 flex-shrink-0">
          <div className={`rounded-xl p-3 mb-4 min-h-[52px] flex items-center ${pos ? 'bg-blue-50 border border-blue-200' : 'bg-gray-50 border border-gray-200'}`}>
            <MapPin size={16} className={`mr-2 flex-shrink-0 ${pos ? 'text-blue-600' : 'text-gray-400'}`} />
            <p className={`text-sm ${pos ? 'text-blue-800 font-medium' : 'text-gray-400 italic'}`}>
              {!pos ? 'Haz clic en el mapa para seleccionar' : cargando ? 'Obteniendo dirección...' : direccion}
            </p>
          </div>
          <div className="flex space-x-3">
            <button onClick={onClose} className="flex-1 py-3 border border-gray-300 rounded-xl bg-white text-gray-700 hover:bg-gray-50 font-medium">
              Cancelar
            </button>
            <button
              onClick={() => pos && onConfirm({ lat: pos.lat, lng: pos.lng, direccion })}
              disabled={!pos || cargando}
              className="flex-1 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 font-semibold disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
            >
              <CheckCircle size={18} />
              <span>Confirmar Ubicación</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ========== COMBOBOX DE CIUDADES ==========
function CiudadCombobox({ name, placeholder, required: isRequired, onChange, defaultValue, strictList = false }) {
  const [valor, setValor] = React.useState(defaultValue || '');
  const [abierto, setAbierto] = React.useState(false);
  const [cursor, setCursor] = React.useState(-1);
  const listaRef = React.useRef(null);

  const opciones = valor
    ? CIUDADES_BC.filter(c => c.toLowerCase().includes(valor.toLowerCase()))
    : CIUDADES_BC;

  const seleccionar = (ciudad) => {
    setValor(ciudad);
    setAbierto(false);
    setCursor(-1);
    if (onChange) onChange(ciudad);
  };

  const handleKeyDown = (e) => {
    if (!abierto) { setAbierto(true); return; }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setCursor(prev => {
        const next = prev < opciones.length - 1 ? prev + 1 : 0;
        setTimeout(() => listaRef.current?.children[next]?.scrollIntoView({ block: 'nearest' }), 0);
        return next;
      });
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setCursor(prev => {
        const next = prev > 0 ? prev - 1 : opciones.length - 1;
        setTimeout(() => listaRef.current?.children[next]?.scrollIntoView({ block: 'nearest' }), 0);
        return next;
      });
    } else if (e.key === 'Enter') {
      if (cursor >= 0 && opciones[cursor]) { e.preventDefault(); seleccionar(opciones[cursor]); }
    } else if (e.key === 'Escape') {
      setAbierto(false); setCursor(-1);
    }
  };

  return (
    <div className="relative">
      <input
        type="text"
        name={name}
        value={valor}
        onChange={e => { setValor(e.target.value); setAbierto(true); setCursor(-1); if (onChange) onChange(e.target.value); }}
        onFocus={() => setAbierto(true)}
        onBlur={() => setTimeout(() => {
          setAbierto(false); setCursor(-1);
          if (strictList && valor && !CIUDADES_BC.includes(valor)) { setValor(''); if (onChange) onChange(''); }
        }, 150)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        required={isRequired}
        autoComplete="off"
        className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
      {abierto && (
        <div ref={listaRef} className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-52 overflow-y-auto">
          {opciones.length > 0 ? opciones.map((ciudad, i) => (
            <div
              key={ciudad}
              onMouseDown={() => seleccionar(ciudad)}
              className={`px-4 py-2 cursor-pointer text-sm ${i === cursor ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-gray-700 hover:bg-blue-50'}`}
            >
              {ciudad}
            </div>
          )) : (
            <div className="px-4 py-3 text-sm text-gray-500 italic">
              Ciudad no encontrada — se usará lo que escribiste
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ========== MAPA GPS DEL CHOFER (VISTA CLIENTE — TIEMPO REAL) ==========
function ViajeMapView({ origenCoords, destinoCoords, progreso = 0, choferGps = null, choferNombre = 'Tu chofer' }) {
  const mapDivRef = React.useRef(null);
  const mapInstanceRef = React.useRef(null);
  const camionMarkerRef = React.useRef(null);
  const [ultimaActualizacion, setUltimaActualizacion] = React.useState(new Date());

  // Inicializar mapa una sola vez
  React.useEffect(() => {
    if (!mapDivRef.current || mapInstanceRef.current) return;
    const puntos = [origenCoords, destinoCoords].filter(Boolean);
    const centroInicial = choferGps
      ? [choferGps.lat, choferGps.lng]
      : puntos.length === 2
        ? [(puntos[0].lat + puntos[1].lat) / 2, (puntos[0].lng + puntos[1].lng) / 2]
        : puntos.length === 1
          ? [puntos[0].lat, puntos[0].lng]
          : null;
    if (!centroInicial) return;
    const centro = centroInicial;
    const map = L.map(mapDivRef.current, {
      zoomControl: true, dragging: true, scrollWheelZoom: false, doubleClickZoom: false
    }).setView(centro, puntos.length === 2 ? 8 : 12);
    mapInstanceRef.current = map;
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '© OpenStreetMap' }).addTo(map);
    if (origenCoords) {
      L.marker([origenCoords.lat, origenCoords.lng], {
        icon: L.divIcon({ className: '', html: '<div style="background:#16a34a;color:white;border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:14px;border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4)">📦</div>', iconSize: [28, 28], iconAnchor: [14, 14] })
      }).addTo(map).bindPopup('Punto de recogida');
    }
    if (destinoCoords) {
      L.marker([destinoCoords.lat, destinoCoords.lng], {
        icon: L.divIcon({ className: '', html: '<div style="background:#dc2626;color:white;border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:14px;border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4)">🏁</div>', iconSize: [28, 28], iconAnchor: [14, 14] })
      }).addTo(map).bindPopup('Tu destino de entrega');
    }
    if (origenCoords && destinoCoords) {
      L.polyline([[origenCoords.lat, origenCoords.lng], [destinoCoords.lat, destinoCoords.lng]], {
        color: '#2563eb', weight: 3, dashArray: '8 6', opacity: 0.6
      }).addTo(map);
    }
    // Marcador inicial del camión
    const p = Math.min(Math.max(progreso, 0), 100) / 100;
    let lat, lng;
    if (choferGps?.lat && choferGps?.lng) {
      lat = choferGps.lat; lng = choferGps.lng;
    } else if (origenCoords && destinoCoords) {
      lat = origenCoords.lat + (destinoCoords.lat - origenCoords.lat) * p;
      lng = origenCoords.lng + (destinoCoords.lng - origenCoords.lng) * p;
    }
    if (lat !== undefined) {
      camionMarkerRef.current = L.marker([lat, lng], {
        icon: L.divIcon({ className: '', html: '<div style="background:#f97316;color:white;border-radius:50%;width:36px;height:36px;display:flex;align-items:center;justify-content:center;font-size:20px;border:3px solid white;box-shadow:0 2px 10px rgba(0,0,0,0.5);animation:chofer-ping 1.5s ease-in-out infinite">🚛</div>', iconSize: [36, 36], iconAnchor: [18, 18] })
      }).addTo(map).bindPopup(`${choferNombre} — progreso ${progreso}%`);
    }
    return () => { try { map.remove(); } catch (_) {} mapInstanceRef.current = null; camionMarkerRef.current = null; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Actualizar posición del camión en tiempo real cuando cambia progreso o GPS
  React.useEffect(() => {
    if (!mapInstanceRef.current || !camionMarkerRef.current) return;
    const p = Math.min(Math.max(progreso, 0), 100) / 100;
    let lat, lng;
    if (choferGps?.lat && choferGps?.lng) {
      lat = choferGps.lat; lng = choferGps.lng;
    } else if (origenCoords && destinoCoords) {
      lat = origenCoords.lat + (destinoCoords.lat - origenCoords.lat) * p;
      lng = origenCoords.lng + (destinoCoords.lng - origenCoords.lng) * p;
    }
    if (lat !== undefined) {
      camionMarkerRef.current.setLatLng([lat, lng]);
      camionMarkerRef.current.setPopupContent(`${choferNombre} — progreso ${progreso}%`);
      setUltimaActualizacion(new Date());
    }
  }, [progreso, choferGps, origenCoords, destinoCoords, choferNombre]);

  // Polling cada 15s para refrescar desde store (simula tiempo real)
  React.useEffect(() => {
    const interval = setInterval(() => setUltimaActualizacion(new Date()), 15000);
    return () => clearInterval(interval);
  }, []);

  const horaActualizacion = ultimaActualizacion.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

  return (
    <div>
      <div ref={mapDivRef} style={{ height: '280px', width: '100%', isolation: 'isolate' }} />
      <div className="bg-blue-600 text-white px-4 py-2 flex items-center justify-between text-xs">
        <span className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse inline-block" />
          Seguimiento en vivo · {choferGps ? 'GPS real' : 'Posición estimada'}
        </span>
        <span className="opacity-80">Actualizado: {horaActualizacion}</span>
      </div>
    </div>
  );
}

function FormularioSolicitudModal({ onClose, onSubmit, onAbrirMapa, origenCoords, destinoCoords, fotosFormulario, setFotosFormulario, setOrigenCoords, setDestinoCoords, solicitudBase, modoEditar }) {
  const [origenCiudad, setOrigenCiudad] = React.useState(solicitudBase?.origen || '');
  const [destinoCiudad, setDestinoCiudad] = React.useState(solicitudBase?.destino || '');
  const [prioridad, setPrioridad] = React.useState(solicitudBase?.prioridad || 'normal');
  const [guardarPlantillaCheck, setGuardarPlantillaCheck] = React.useState(false);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
      <div className="bg-white shadow-2xl rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h3 className="text-2xl font-bold text-gray-800">{modoEditar ? 'Editar Solicitud' : solicitudBase ? 'Repetir Solicitud' : 'Nueva Solicitud de Flete'}</h3>
              <p className="text-gray-500 text-sm">{modoEditar ? 'Actualiza los datos — las cotizaciones anteriores se eliminarán' : solicitudBase ? 'Misma ruta y mercancía — solo elige una nueva fecha de recogida' : 'Completa los datos y recibe cotizaciones de transportistas verificados'}</p>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 p-2">
              <X size={24} />
            </button>
          </div>

          <form onSubmit={onSubmit} className="space-y-5">
            {/* Origen y Destino */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  <MapPin size={16} className="inline mr-1" /> Origen *
                </label>
                <CiudadCombobox name="origen" placeholder="Buscar o escribir ciudad..." required onChange={setOrigenCiudad} defaultValue={solicitudBase?.origen || ''} />
                <button
                  type="button"
                  onClick={() => onAbrirMapa('origen', origenCiudad)}
                  className={`mt-2 w-full px-3 py-2 rounded-lg border text-sm font-medium flex items-center justify-center space-x-2 transition-colors ${origenCoords ? 'bg-green-50 border-green-400 text-green-700 hover:bg-green-100' : 'bg-red-50 border-red-300 text-red-600 hover:bg-red-100 hover:border-red-400'}`}
                >
                  <MapPin size={15} />
                  <span>{origenCoords ? '📍 Pin de origen confirmado' : '* Obligatorio: Marcar punto exacto en mapa'}</span>
                </button>
                {origenCoords && (
                  <p className="text-xs text-green-600 mt-1 truncate" title={origenCoords.direccion}>{origenCoords.direccion}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  <MapPin size={16} className="inline mr-1" /> Destino *
                </label>
                <CiudadCombobox name="destino" placeholder="Buscar o escribir ciudad..." required onChange={setDestinoCiudad} defaultValue={solicitudBase?.destino || ''} />
                <button
                  type="button"
                  onClick={() => onAbrirMapa('destino', destinoCiudad)}
                  className={`mt-2 w-full px-3 py-2 rounded-lg border text-sm font-medium flex items-center justify-center space-x-2 transition-colors ${destinoCoords ? 'bg-green-50 border-green-400 text-green-700 hover:bg-green-100' : 'bg-red-50 border-red-300 text-red-600 hover:bg-red-100 hover:border-red-400'}`}
                >
                  <MapPin size={15} />
                  <span>{destinoCoords ? '📍 Pin de destino confirmado' : '* Obligatorio: Marcar punto exacto en mapa'}</span>
                </button>
                {destinoCoords && (
                  <p className="text-xs text-green-600 mt-1 truncate" title={destinoCoords.direccion}>{destinoCoords.direccion}</p>
                )}
              </div>
            </div>

            {/* Descripción de Carga */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Package size={16} className="inline mr-1" /> Descripción de la Carga *
              </label>
              <input
                type="text"
                name="carga"
                required
                placeholder="Ej: Componentes electrónicos, Muebles, Maquinaria..."
                defaultValue={solicitudBase?.carga || ''}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Peso */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Peso Aproximado (toneladas) *</label>
              <input
                type="number"
                name="peso"
                required
                min="0.1"
                step="0.1"
                placeholder="Ej: 5"
                defaultValue={solicitudBase?.peso || ''}
                onWheel={e => e.target.blur()}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Fecha y ventana de tiempo */}
            <div>
              <div className="flex items-center gap-2 mb-2">
                <Clock size={16} className="text-blue-500 flex-shrink-0" />
                <span className="text-sm font-semibold text-gray-700">Fecha y horario de recogida *</span>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-xl px-4 py-2.5 mb-3">
                <p className="text-xs text-blue-700">
                  <strong>¿Qué es el horario?</strong> Es la ventana de tiempo en la que <strong>estarás disponible para que llegue el camión</strong>.
                  Por ejemplo: si pones de 9:00 a.m. a 1:00 p.m., el transportista sabe que debe llegar en ese horario.
                </p>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                <div className="col-span-2 md:col-span-1">
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Fecha *</label>
                  <input
                    type="date"
                    name="fecha"
                    required
                    min={new Date().toISOString().split('T')[0]}
                    max={new Date(Date.now() + 15 * 86400000).toISOString().split('T')[0]}
                    defaultValue={modoEditar && solicitudBase?.fechaRecogida ? solicitudBase.fechaRecogida.split('T')[0] : ''}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  <p className="text-xs text-gray-400 mt-1">Máximo 15 días a partir de hoy</p>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Disponible desde *</label>
                  <input
                    type="time"
                    name="horaRecogida"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  <p className="text-xs text-gray-400 mt-1">Hora más temprana de llegada</p>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Disponible hasta *</label>
                  <input
                    type="time"
                    name="horaFinCarga"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  <p className="text-xs text-gray-400 mt-1">Hora límite de llegada</p>
                </div>
              </div>
            </div>

            {/* Prioridad */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Prioridad del Servicio</label>
              <input type="hidden" name="prioridad" value={prioridad} />
              <div className="grid grid-cols-3 gap-3">
                {[
                  { value: 'normal', label: 'Normal', desc: 'Sin urgencia', sel: 'bg-gray-100 border-gray-500 ring-2 ring-gray-400 text-gray-800', unsel: 'bg-gray-50 border-gray-300 text-gray-600' },
                  { value: 'alta', label: 'Alta', desc: 'Prioritario', sel: 'bg-amber-100 border-amber-500 ring-2 ring-amber-400 text-amber-800', unsel: 'bg-amber-50 border-amber-300 text-amber-600' },
                  { value: 'urgente', label: 'Urgente', desc: 'Inmediato', sel: 'bg-red-100 border-red-500 ring-2 ring-red-400 text-red-800', unsel: 'bg-red-50 border-red-300 text-red-600' },
                ].map(opt => (
                  <button
                    key={opt.value}
                    type="button"
                    onClick={() => setPrioridad(opt.value)}
                    className={`border rounded-lg p-3 text-center transition-all ${prioridad === opt.value ? opt.sel : opt.unsel}`}
                  >
                    <p className="font-semibold text-sm">{opt.label}</p>
                    <p className="text-xs opacity-70">{opt.desc}</p>
                  </button>
                ))}
              </div>
            </div>

            {/* Notas Adicionales */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Notas Adicionales (Opcional)</label>
              <textarea
                name="notas"
                rows="3"
                placeholder="Requisitos especiales, horarios de entrega, instrucciones de carga/descarga..."
                defaultValue={solicitudBase?.notas || ''}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              ></textarea>
            </div>

            {/* Fotos del flete */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Fotografías del Flete (Opcional)
              </label>
              <p className="text-xs text-gray-500 mb-3">Ayuda a los transportistas a cotizar con mayor precisión. Máximo 5 fotos.</p>
              <div className="flex flex-wrap gap-3 mb-3">
                {fotosFormulario.map((foto, idx) => (
                  <div key={idx} className="relative w-24 h-24 rounded-lg overflow-hidden border border-gray-200 group">
                    <img src={foto} alt={`Foto ${idx + 1}`} className="w-full h-full object-cover" />
                    <button
                      type="button"
                      onClick={() => setFotosFormulario(prev => prev.filter((_, i) => i !== idx))}
                      className="absolute top-1 right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                    >
                      <X size={12} />
                    </button>
                  </div>
                ))}
                {fotosFormulario.length < 5 && (
                  <label className="w-24 h-24 border-2 border-dashed border-blue-300 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-blue-500 hover:bg-blue-50 transition-colors">
                    <Plus size={20} className="text-blue-400 mb-1" />
                    <span className="text-xs text-blue-500 font-medium">Agregar</span>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="hidden"
                      onChange={(e) => {
                        const archivos = Array.from(e.target.files);
                        const disponibles = 5 - fotosFormulario.length;
                        archivos.slice(0, disponibles).forEach(archivo => {
                          const reader = new FileReader();
                          reader.onload = (ev) => {
                            const img = new Image();
                            img.onload = () => {
                              const MAX = 800;
                              let w = img.width;
                              let h = img.height;
                              if (w > h && w > MAX) { h = Math.round(h * MAX / w); w = MAX; }
                              else if (h > MAX) { w = Math.round(w * MAX / h); h = MAX; }
                              const canvas = document.createElement('canvas');
                              canvas.width = w;
                              canvas.height = h;
                              canvas.getContext('2d').drawImage(img, 0, 0, w, h);
                              setFotosFormulario(prev => [...prev, canvas.toDataURL('image/jpeg', 0.65)]);
                            };
                            img.src = ev.target.result;
                          };
                          reader.readAsDataURL(archivo);
                        });
                        e.target.value = '';
                      }}
                    />
                  </label>
                )}
              </div>
            </div>

            {/* ── Flujo de pago ── */}
            <div className="border border-blue-200 rounded-xl p-4 bg-blue-50">
              <p className="text-sm font-semibold text-blue-800 mb-3">💳 ¿Cómo quieres pagar?</p>
              <div className="flex flex-col gap-2">
                {[
                  { value: 'unico', label: 'Pago único', desc: 'Pagas el total al aceptar la cotización. El dinero se libera al transportista cuando confirmas la entrega.' },
                  { value: 'dos_pagos', label: 'Anticipo + contra entrega', desc: 'Pagas el 50% al inicio y el 50% restante cuando confirmas que recibiste la mercancía.' },
                ].map(op => (
                  <label key={op.value} className={`flex items-start gap-3 p-3 rounded-lg cursor-pointer border-2 transition ${
                    (solicitudBase?.flujoPago || 'unico') === op.value ? 'border-blue-500 bg-white' : 'border-transparent bg-white/50 hover:bg-white'
                  }`}>
                    <input type="radio" name="flujoPago" value={op.value} defaultChecked={op.value === 'unico'} className="mt-1 accent-blue-600 flex-shrink-0" />
                    <div>
                      <p className="text-sm font-semibold text-gray-800">{op.label}</p>
                      <p className="text-xs text-gray-500 mt-0.5">{op.desc}</p>
                    </div>
                  </label>
                ))}
              </div>
            </div>

            {/* Guardar como plantilla */}
            {(() => {
              return (
                <div className="border border-dashed border-gray-300 rounded-xl p-4 bg-gray-50">
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input type="checkbox" name="guardarPlantilla" checked={guardarPlantillaCheck} onChange={e => setGuardarPlantillaCheck(e.target.checked)} className="w-4 h-4 text-blue-600 rounded" />
                    <span className="text-sm font-medium text-gray-600">Guardar esta ruta como plantilla para uso futuro</span>
                  </label>
                  {guardarPlantillaCheck && (
                    <input
                      type="text" name="nombrePlantilla" placeholder="Nombre de la plantilla (ej: 'TJ-Mex semanal')"
                      className="mt-3 w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  )}
                </div>
              );
            })()}

            {/* Botones */}
            <div className="flex space-x-4 pt-4">
              <button
                type="button"
                onClick={() => { onClose(); setFotosFormulario([]); setOrigenCoords(null); setDestinoCoords(null); }}
                className="flex-1 px-6 py-3 border border-gray-300 rounded-lg bg-white text-gray-700 hover:bg-gray-50 font-medium"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium flex items-center justify-center space-x-2"
              >
                <Plus size={20} />
                <span>Publicar Solicitud</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// ─── Panel de Ganancias Detallado ──────────────────────────────────
function GananciasDetalle({ comisiones, nombreEmpresa, esBono, esFlete, totales, colorEstado, labelEstado }) {
  const [tab, setTab] = useState('todas');
  const [filtroNivel, setFiltroNivel] = useState('todos');
  const [filtroStatus, setFiltroStatus] = useState('todas');
  const [busqueda, setBusqueda] = useState('');
  const [pagina, setPagina] = useState(1);
  const [expandido, setExpandido] = useState(null);
  const POR_PAGINA = 15;

  const lista = comisiones.filter(c => {
    if (tab === 'bonos' && !esBono(c)) return false;
    if (tab === 'fletes' && !esFlete(c)) return false;
    if (filtroNivel !== 'todos' && c.nivel !== Number(filtroNivel)) return false;
    if (filtroStatus !== 'todas' && c.status !== filtroStatus) return false;
    const emp = nombreEmpresa(c).toLowerCase();
    if (busqueda && !emp.includes(busqueda.toLowerCase())) return false;
    return true;
  }).sort((a, b) => new Date(b.creadoEn||b.fecha) - new Date(a.creadoEn||a.fecha));

  const totalPaginas = Math.ceil(lista.length / POR_PAGINA);
  const pageLista = lista.slice((pagina-1)*POR_PAGINA, pagina*POR_PAGINA);

  const nivelColor = (n) => n===1?'bg-blue-100 text-blue-700 border-blue-200':n===2?'bg-purple-100 text-purple-700 border-purple-200':'bg-amber-100 text-amber-700 border-amber-200';
  const nivelLabel = (n) => n===1?'N1 · Directo':n===2?'N2 · Indirecto':'N3 · Red';

  // Descripción legible de dónde vino la comisión
  const descripcionOrigen = (c) => {
    const emp = nombreEmpresa(c);
    const ruta = c.viaje ? `${c.viaje.origen} → ${c.viaje.destino}` : null;
    if (c.tipo === 'comision_registro' || c.tipo === 'bono_referido' || c.tipo === 'comision_flete_registro') {
      return { titulo: `Bono por registro de ${emp}`, detalle: 'Se liberó al completar su primer flete en Choyero.', icon: '🎁' };
    }
    if (c.tipo === 'comision_flete' || c.tipo?.includes('flete')) {
      const base = c.nivel === 1
        ? `Tu referido directo ${emp} completó un flete`
        : c.nivel === 2
        ? `Un referido de tu red N2 (${emp}) completó un flete`
        : `Un referido de tu red N3 (${emp}) completó un flete`;
      return { titulo: base, detalle: ruta || null, icon: '🚛' };
    }
    if (c.tipo === 'comision_cliente') {
      return { titulo: `Cliente ${emp} confirmó recepción de flete`, detalle: ruta || null, icon: '✅' };
    }
    return { titulo: emp, detalle: c.tipo || null, icon: '💰' };
  };

  const montoFlete = (c) => c.viaje?.costoFinal || c.viaje?.precio || null;

  if (comisiones.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8 mb-6 text-center">
        <p className="text-4xl mb-3">🌱</p>
        <p className="font-bold text-gray-700 text-lg">Aún no tienes ganancias registradas</p>
        <p className="text-sm text-gray-400 mt-1">Invita empresas con tu código. Ganarás comisiones cuando completen fletes.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-lg mb-6 overflow-hidden">
      <div className="p-6 border-b border-gray-100">
        <h3 className="font-bold text-gray-800 text-lg">Detalle de mis ganancias</h3>
        <p className="text-sm text-gray-500 mt-0.5">Cada comisión y bono con su origen exacto</p>
      </div>

      {/* Desglose visual por tipo y nivel */}
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-px bg-gray-100">
        {[
          { label: '🎁 Bonos registro', val: totales.bonos, bg: 'bg-orange-50', txt: 'text-orange-700', sub: 'Por invitar empresas' },
          { label: '🚛 Comis. fletes', val: totales.fletes, bg: 'bg-teal-50', txt: 'text-teal-700', sub: 'Por fletes completados' },
          { label: '👤 N1 Directo', val: totales.n1, bg: 'bg-blue-50', txt: 'text-blue-700', sub: 'Referidos directos tuyos' },
          { label: '👥 N2', val: totales.n2, bg: 'bg-purple-50', txt: 'text-purple-700', sub: 'Referidos de tus N1' },
          { label: '🌐 N3', val: totales.n3, bg: 'bg-amber-50', txt: 'text-amber-700', sub: 'Referidos de tus N2' },
        ].map(({ label, val, bg, txt, sub }) => (
          <div key={label} className={`${bg} p-4 text-center`}>
            <p className={`text-xs font-semibold ${txt} mb-0.5`}>{label}</p>
            <p className={`text-lg font-bold ${txt}`}>${val.toLocaleString('es-MX')}</p>
            <p className="text-xs text-gray-400 mt-0.5">{sub}</p>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div className="p-4 border-b border-gray-100 space-y-3">
        <div className="flex gap-1 bg-gray-100 rounded-xl p-1">
          {[['todas','Todas'],['bonos','🎁 Bonos'],['fletes','🚛 Fletes']].map(([v,l])=>(
            <button key={v} onClick={()=>{setTab(v);setPagina(1);}}
              className={`flex-1 text-xs font-semibold py-1.5 rounded-lg transition ${tab===v?'bg-white shadow text-gray-800':'text-gray-500 hover:text-gray-700'}`}>
              {l}
            </button>
          ))}
        </div>
        <div className="flex flex-wrap gap-2">
          <input type="text" placeholder="Buscar empresa..." value={busqueda}
            onChange={e=>{setBusqueda(e.target.value);setPagina(1);}}
            className="flex-1 min-w-[140px] border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-green-300"/>
          <select value={filtroNivel} onChange={e=>{setFiltroNivel(e.target.value);setPagina(1);}}
            className="border border-gray-200 rounded-lg px-2 py-1.5 text-sm focus:outline-none">
            <option value="todos">Todos los niveles</option>
            <option value="1">N1 Directo</option>
            <option value="2">N2</option>
            <option value="3">N3</option>
          </select>
          <select value={filtroStatus} onChange={e=>{setFiltroStatus(e.target.value);setPagina(1);}}
            className="border border-gray-200 rounded-lg px-2 py-1.5 text-sm focus:outline-none">
            <option value="todas">Todos los estados</option>
            <option value="disponible">Disponible</option>
            <option value="pendiente">En espera</option>
            <option value="pagada">Pagada</option>
          </select>
        </div>
      </div>

      {/* Lista de comisiones */}
      {pageLista.length === 0 ? (
        <div className="text-center py-10 text-gray-400 text-sm">Sin resultados para estos filtros</div>
      ) : (
        <div className="divide-y divide-gray-100">
          {pageLista.map(c => {
            const { titulo, detalle, icon } = descripcionOrigen(c);
            const isOpen = expandido === c.id;
            const fletoVal = montoFlete(c);
            const fecha = new Date(c.creadoEn||c.fecha);
            const fechaStr = fecha.toLocaleDateString('es-MX',{day:'2-digit',month:'short',year:'numeric'});
            const horaStr = fecha.toLocaleTimeString('es-MX',{hour:'2-digit',minute:'2-digit'});
            return (
              <div key={c.id}>
                <button
                  onClick={() => setExpandido(isOpen ? null : c.id)}
                  className="w-full text-left px-5 py-4 hover:bg-gray-50 transition flex items-start gap-4"
                >
                  {/* Icono tipo */}
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-xl flex-shrink-0 mt-0.5">
                    {icon}
                  </div>

                  {/* Info principal */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <div className="min-w-0">
                        <p className="font-semibold text-gray-800 text-sm leading-snug">{titulo}</p>
                        {detalle && <p className="text-xs text-gray-500 mt-0.5 truncate">📍 {detalle}</p>}
                        <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                          <span className={`text-xs font-semibold px-2 py-0.5 rounded-full border ${nivelColor(c.nivel)}`}>
                            {nivelLabel(c.nivel)}
                          </span>
                          <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${colorEstado(c.status)}`}>
                            {labelEstado(c.status)}
                          </span>
                          <span className="text-xs text-gray-400">{fechaStr} · {horaStr}</span>
                        </div>
                      </div>
                      {/* Monto */}
                      <div className="text-right flex-shrink-0">
                        <p className={`text-lg font-bold ${c.status==='pendiente'?'text-yellow-600':c.status==='revertida'?'text-red-500':'text-green-700'}`}>
                          +${c.monto.toLocaleString('es-MX')}
                        </p>
                        <p className="text-xs text-gray-400">MXN</p>
                      </div>
                    </div>
                  </div>

                  {/* Chevron */}
                  <span className={`text-gray-400 flex-shrink-0 mt-1 transition-transform ${isOpen?'rotate-90':''}`}>›</span>
                </button>

                {/* Detalle expandido */}
                {isOpen && (
                  <div className="px-5 pb-5 bg-gray-50 border-t border-gray-100">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                      <div className="bg-white rounded-xl shadow-lg p-4 border border-gray-200">
                        <p className="text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wide">Origen de la comisión</p>
                        <div className="space-y-1.5 text-sm">
                          <div className="flex justify-between">
                            <span className="text-gray-400">Empresa generadora</span>
                            <span className="font-semibold text-gray-800">{nombreEmpresa(c)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-400">Tipo</span>
                            <span className="font-medium text-gray-600">{c.tipo || '—'}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-400">Nivel de red</span>
                            <span className={`text-xs font-bold px-2 py-0.5 rounded-full border ${nivelColor(c.nivel)}`}>{nivelLabel(c.nivel)}</span>
                          </div>
                        </div>
                      </div>
                      <div className="bg-white rounded-xl shadow-lg p-4 border border-gray-200">
                        <p className="text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wide">Detalle del flete</p>
                        {c.viaje ? (
                          <div className="space-y-1.5 text-sm">
                            <div className="flex justify-between">
                              <span className="text-gray-400">Ruta</span>
                              <span className="font-semibold text-gray-800 text-right text-xs">{c.viaje.origen} → {c.viaje.destino}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-400">Tu comisión</span>
                              <span className="font-bold text-green-700">${c.monto.toLocaleString('es-MX')} MXN</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-400">Base de cálculo</span>
                              <span className="text-xs text-gray-400">% sobre comisión Choyero</span>
                            </div>
                          </div>
                        ) : (
                          <p className="text-xs text-gray-400 italic">
                            {esBono(c) ? 'Bono fijo por registro de empresa referida.' : 'Sin datos de flete asociado.'}
                          </p>
                        )}
                      </div>
                    </div>
                    {/* Estado explicado */}
                    <div className="mt-3 bg-white rounded-xl shadow-lg p-4 border border-gray-200">
                      <p className="text-xs font-semibold text-gray-500 mb-1 uppercase tracking-wide">Estado de tu pago</p>
                      <p className="text-sm text-gray-600">
                        {c.status === 'disponible' && '✅ Fondos disponibles para retirar en cualquier momento.'}
                        {c.status === 'pendiente' && '⏳ En espera de que la empresa referida complete su primer flete para liberarse.'}
                        {c.status === 'pagada' && '💳 Ya fue transferida a tu cuenta en un retiro anterior.'}
                        {c.status === 'revertida' && '❌ Esta comisión fue revertida (el flete fue cancelado o hay una disputa).'}
                        {c.status === 'congelada' && '🔒 Fondos en revisión por el equipo de Choyero.'}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Paginación */}
      {totalPaginas > 1 && (
        <div className="flex items-center justify-between px-5 py-3 border-t border-gray-100">
          <p className="text-xs text-gray-400">
            {(pagina-1)*POR_PAGINA+1}–{Math.min(pagina*POR_PAGINA, lista.length)} de {lista.length} registros
          </p>
          <div className="flex gap-1">
            <button onClick={()=>setPagina(p=>Math.max(1,p-1))} disabled={pagina===1}
              className="px-3 py-1 text-xs border border-gray-300 rounded-lg bg-white text-gray-700 disabled:opacity-40 hover:bg-gray-50">← Ant.</button>
            {Array.from({length:Math.min(5,totalPaginas)},(_,i)=>{
              const p = pagina<=3?i+1:pagina+i-2;
              if(p<1||p>totalPaginas) return null;
              return <button key={p} onClick={()=>setPagina(p)}
                className={`w-7 h-7 text-xs rounded-lg ${p===pagina?'bg-green-600 text-white':'border border-gray-300 hover:bg-gray-50'}`}>{p}</button>;
            })}
            <button onClick={()=>setPagina(p=>Math.min(totalPaginas,p+1))} disabled={pagina===totalPaginas}
              className="px-3 py-1 text-xs border border-gray-300 rounded-lg bg-white text-gray-700 disabled:opacity-40 hover:bg-gray-50">Sig. →</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Nodo del árbol de referidos ───────────────────────────────────
function NodoRed({ u, hijos, comPorEmpresa, cfg, isLast }) {
  const [abierto, setAbierto] = useState(true);
  const esEmpresa = !!u.empresaId;
  const nombre = u.empresa?.nombre || u.nombre || '—';
  const tipoPersona = u.rol === 'transportista' ? 'Transportista' : esEmpresa ? 'Empresa' : 'Persona física';
  const status = u.empresa?.status;
  const coms = esEmpresa ? (comPorEmpresa[u.empresaId] || []) : [];
  const totalEmp = coms.filter(c => c.status !== 'revertida').reduce((s, c) => s + c.monto, 0);
  const tieneHijos = hijos.length > 0;

  const nivelBg = { 1: 'bg-blue-500', 2: 'bg-purple-500', 3: 'bg-orange-400' };
  const statusBadge = {
    activa: 'bg-green-100 text-green-700',
    pendiente: 'bg-yellow-100 text-yellow-700',
    suspendida: 'bg-red-100 text-red-600',
    rechazada: 'bg-red-100 text-red-600',
  };

  return (
    <div className="relative">
      {/* Línea vertical del árbol */}
      {!isLast && (
        <div className="absolute left-4 top-10 bottom-0 w-px bg-gray-200" />
      )}

      <div className="flex items-start gap-0 mb-1">
        {/* Conector horizontal + toggle */}
        <div className="flex flex-col items-center flex-shrink-0 w-8 pt-3">
          {tieneHijos ? (
            <button
              onClick={() => setAbierto(o => !o)}
              className="w-5 h-5 rounded-full border-2 border-gray-300 bg-white flex items-center justify-center text-gray-400 hover:border-blue-400 hover:text-blue-500 transition z-10"
            >
              <span className="text-xs leading-none">{abierto ? '−' : '+'}</span>
            </button>
          ) : (
            <div className="w-2 h-2 rounded-full bg-gray-300 mt-1.5" />
          )}
        </div>

        {/* Card del nodo */}
        <div className="flex-1 min-w-0 bg-white border border-gray-200 rounded-xl px-3 py-2.5 flex items-center gap-3 shadow-sm">
          {/* Icono con nivel */}
          <div className="relative flex-shrink-0">
            <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${esEmpresa ? (status === 'activa' ? 'bg-green-500' : 'bg-orange-400') : 'bg-blue-500'}`}>
              {esEmpresa ? <Building2 size={16} className="text-white" /> : <User size={16} className="text-white" />}
            </div>
            <div className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full flex items-center justify-center text-white text-[9px] font-bold ${nivelBg[u.nivel]}`}>
              {u.nivel}
            </div>
          </div>

          {/* Nombre y tipo */}
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-sm text-gray-800 truncate leading-tight">{nombre}</p>
            <p className="text-xs text-gray-400">{tipoPersona}</p>
          </div>

          {/* Status y ganancias */}
          <div className="flex items-center gap-2 flex-shrink-0">
            {status && (
              <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${statusBadge[status] || 'bg-gray-100 text-gray-500'}`}>
                {status}
              </span>
            )}
            {cfg.habilitada !== false && totalEmp > 0 && (
              <span className="text-xs font-bold text-green-700 bg-green-50 px-2 py-0.5 rounded-full">
                +${totalEmp.toLocaleString('es-MX')}
              </span>
            )}
            {tieneHijos && (
              <span className="text-xs text-gray-400">{hijos.length} ref.</span>
            )}
          </div>
        </div>
      </div>

      {/* Hijos */}
      {tieneHijos && abierto && (
        <div className="ml-8 pl-2 border-l-2 border-gray-200 mt-0.5 space-y-0.5">
          {hijos.map((hijo, i) => (
            <NodoRed
              key={hijo.id}
              u={hijo}
              hijos={hijo._hijos || []}
              comPorEmpresa={comPorEmpresa}
              cfg={cfg}
              isLast={i === hijos.length - 1}
            />
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Nodo del árbol visual ─────────────────────────────────────────
function NodoArbol({ nodo, depth = 0, isFirst, isLast, solo }) {
  const [open, setOpen] = React.useState(true);
  const hijos = nodo.referidos || [];
  const tieneHijos = hijos.length > 0;

  const colores = [
    { circle: '#3b82f6', light: '#eff6ff', border: '#93c5fd', tag: 'N1' },
    { circle: '#8b5cf6', light: '#f5f3ff', border: '#c4b5fd', tag: 'N2' },
    { circle: '#f97316', light: '#fff7ed', border: '#fdba74', tag: 'N3' },
  ];
  const col = colores[depth] || colores[2];
  const inicial = (nodo.nombre || '?')[0].toUpperCase();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 0 }}>
      {/* Conector de entrada (horizontal + vertical desde padre) */}
      {depth > 0 && (
        <div style={{ display: 'flex', width: '100%', height: 24, alignItems: 'flex-end' }}>
          <div style={{ flex: 1, borderTop: isFirst || solo ? 'none' : '2px solid #d1d5db', height: 1, alignSelf: 'center' }} />
          <div style={{ width: 2, height: 24, backgroundColor: '#d1d5db' }} />
          <div style={{ flex: 1, borderTop: isLast || solo ? 'none' : '2px solid #d1d5db', height: 1, alignSelf: 'center' }} />
        </div>
      )}

      {/* Card del nodo */}
      <div
        onClick={tieneHijos ? (e) => { e.preventDefault(); setOpen(o => !o); } : undefined}
        onMouseDown={tieneHijos ? (e) => e.preventDefault() : undefined}
        style={{
          background: col.light, border: `2px solid ${col.border}`,
          borderRadius: 10, padding: '6px 8px', width: 90, textAlign: 'center',
          cursor: tieneHijos ? 'pointer' : 'default',
          boxShadow: '0 1px 3px rgba(0,0,0,0.07)', position: 'relative',
          userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none',
        }}
      >
        {/* Avatar */}
        <div style={{
          width: 30, height: 30, borderRadius: '50%', backgroundColor: col.circle,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontWeight: 700, fontSize: 13, margin: '0 auto 4px',
        }}>
          {inicial}
        </div>
        {/* Tag de nivel */}
        <span style={{
          position: 'absolute', top: 4, right: 4, background: col.circle,
          color: '#fff', fontSize: 8, fontWeight: 700, padding: '1px 4px', borderRadius: 4,
        }}>{col.tag}</span>
        {/* Nombre */}
        <p style={{ fontWeight: 700, fontSize: 11, color: '#1f2937', lineHeight: 1.2, marginBottom: 2, wordBreak: 'break-word' }}>
          {nodo.nombre}
        </p>
        {/* Tipo + actividad */}
        <p style={{ fontSize: 9, color: nodo.activo ? '#16a34a' : '#9ca3af', marginBottom: 2 }}>
          {nodo.esEmpresa ? (nodo.rol === 'transportista' ? '🚛 Empresa' : '🏢 Empresa') : '👤 Cliente'}
          {' '}{nodo.activo ? '· Activo' : '· Inactivo'}
        </p>
        {/* Stats compactos */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 4, flexWrap: 'wrap' }}>
          {(nodo.viajesCompletados || 0) > 0 && (
            <span style={{ fontSize: 9, color: '#6b7280' }}>{nodo.viajesCompletados}v</span>
          )}
          {(nodo.totalReferidos || 0) > 0 && (
            <span style={{ fontSize: 9, color: col.circle, fontWeight: 700 }}>{nodo.totalReferidos}r</span>
          )}
          {nodo.gananciasGeneradas > 0 && (
            <span style={{ fontSize: 9, color: '#16a34a', fontWeight: 700 }}>${nodo.gananciasGeneradas.toLocaleString('es-MX')}</span>
          )}
        </div>
        {tieneHijos && (
          <div style={{ marginTop: 2, color: '#9ca3af', fontSize: 9 }}>{open ? '▲' : '▼'}</div>
        )}
      </div>

      {/* Hijos */}
      {tieneHijos && open && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {/* Línea vertical hacia abajo */}
          <div style={{ width: 2, height: 20, backgroundColor: '#d1d5db' }} />
          {/* Fila de hijos */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
            {hijos.map((hijo, i) => (
              <NodoArbol
                key={hijo.id}
                nodo={hijo}
                depth={depth + 1}
                isFirst={i === 0}
                isLast={i === hijos.length - 1}
                solo={hijos.length === 1}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Mi Red de Referidos ───────────────────────────────────────────
function SeccionMiRedReferidos({ store, usuario, codigoReferido }) {
  const cfg = store.configPlataforma?.redMercadeo || {};
  const [arbol, setArbol] = React.useState(null);
  const [cargando, setCargando] = React.useState(true);
  const [arbolOpen, setArbolOpen] = React.useState(true);

  React.useEffect(() => {
    apiGetArbolReferidos().then(data => { setArbol(data || []); }).catch(() => setArbol([])).finally(() => setCargando(false));
  }, []);

  const contar = (nodos) => nodos.reduce((s, n) => s + 1 + contar(n.referidos || []), 0);
  const totalRed = arbol ? contar(arbol) : 0;
  const gananciasPorNivel = (nv) => (store.comisionesRed || []).filter(c => c.nivel === nv && c.status !== 'revertida').reduce((s, c) => s + c.monto, 0);
  const totalGanancias = (store.comisionesRed || []).filter(c => c.status !== 'revertida').reduce((s, c) => s + c.monto, 0);

  const n2count = arbol?.reduce((s, n) => s + (n.referidos?.length || 0), 0) || 0;
  const n3count = arbol?.reduce((s, n) => s + (n.referidos || []).reduce((acc, n2) => acc + (n2.referidos?.length || 0), 0), 0) || 0;

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-bold text-gray-800 text-lg">Mi red</h3>
        <span className="text-sm text-gray-400">{totalRed} en tu red</span>
      </div>

      {/* Resumen por nivel */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        {[
          { label: 'Total red', count: totalRed, earnings: totalGanancias, color: 'border-gray-200 bg-gray-50', textColor: 'text-gray-700' },
          { label: 'N1 Directo', count: arbol?.length || 0, earnings: gananciasPorNivel(1), color: 'border-blue-200 bg-blue-50', textColor: 'text-blue-700' },
          { label: 'N2', count: n2count, earnings: gananciasPorNivel(2), color: 'border-purple-200 bg-purple-50', textColor: 'text-purple-700' },
          { label: 'N3', count: n3count, earnings: gananciasPorNivel(3), color: 'border-orange-200 bg-orange-50', textColor: 'text-orange-700' },
        ].map(({ label, count, earnings, color, textColor }) => (
          <div key={label} className={`rounded-xl border p-3 text-center ${color}`}>
            <p className={`text-xs font-semibold mb-1 ${textColor}`}>{label}</p>
            <p className="text-2xl font-bold text-gray-800">{count}</p>
            {cfg.habilitada !== false && earnings > 0 && (
              <p className="text-xs font-bold text-green-700 mt-1">${earnings.toLocaleString('es-MX')}</p>
            )}
          </div>
        ))}
      </div>

      {/* Árbol visual */}
      {cargando ? (
        <div className="text-center py-10 text-gray-400 text-sm">Cargando red...</div>
      ) : !arbol || arbol.length === 0 ? (
        <div className="text-center py-10 text-gray-400">
          <Gift size={32} className="mx-auto mb-3 opacity-40" />
          <p className="font-medium">Tu red está vacía</p>
          <p className="text-sm mt-1">Comparte tu código para empezar.</p>
        </div>
      ) : (
        <div style={{ overflowX: 'auto', overflowY: 'visible', paddingBottom: 16 }}>
          {/* Nodo raíz: Tú */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 'max-content', margin: '0 auto' }}>
            {/* Card Tú */}
            <div
              onClick={(e) => { e.preventDefault(); setArbolOpen(o => !o); }}
              onMouseDown={(e) => e.preventDefault()}
              style={{
                background: '#1e3a5f', borderRadius: 10, padding: '6px 12px',
                color: '#fff', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                cursor: 'pointer', userSelect: 'none', WebkitUserSelect: 'none',
              }}
            >
              <div style={{ width: 30, height: 30, borderRadius: '50%', background: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, margin: '0 auto 3px' }}>
                {(usuario?.nombre || 'T')[0].toUpperCase()}
              </div>
              <p style={{ fontWeight: 700, fontSize: 11 }}>{(usuario?.nombre || '').split(' ')[0]}</p>
              <p style={{ fontSize: 9, opacity: 0.7 }}>Tú {arbolOpen ? '▲' : '▼'}</p>
            </div>

            {/* Línea hacia hijos */}
            {arbolOpen && <div style={{ width: 2, height: 20, backgroundColor: '#d1d5db' }} />}

            {/* Hijos N1 */}
            {arbolOpen && (
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                {arbol.map((nodo, i) => (
                  <NodoArbol
                    key={nodo.id}
                    nodo={nodo}
                    depth={0}
                    isFirst={i === 0}
                    isLast={i === arbol.length - 1}
                    solo={arbol.length === 1}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      <p className="text-xs text-gray-400 text-center mt-3">Toca un nodo para expandir/contraer sus referidos</p>
    </div>
  );
}

// ─── Sección: Retiro de ganancias por referidos ──────────────────────────────
function SeccionRetiroReferidos({ saldoDisponible, usuarioId, comisionesRaw, clabeGuardada = '', bancoGuardado = '', usuario = null, autoOpen = false, onAutoOpenDone = null, setSeccionExterna = null, setAbrirClabeExterna = null }) {
  const [retiros, setRetiros] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false);
  React.useEffect(() => { if (autoOpen && clabeGuardada) { setShowModal(true); onAutoOpenDone?.(); } }, [autoOpen]);
  const [form, setForm] = React.useState({ monto: '', clabe: clabeGuardada, banco: bancoGuardado });
  const [enviando, setEnviando] = React.useState(false);
  const [msg, setMsg] = React.useState(null);
  const [descargando, setDescargando] = React.useState(null);
  const MINIMO = 500;

  // Saldo real = disponible en comisiones - retiros pendientes/aprobados (aún no pagados)
  const retiradoPendiente = retiros.filter(r => ['pendiente', 'aprobado'].includes(r.status)).reduce((s, r) => s + r.monto, 0);
  const saldoReal = Math.max(0, saldoDisponible - retiradoPendiente);

  const cargarRetiros = React.useCallback(() => {
    apiGetMisRetiros().then(r => setRetiros(r || [])).catch(() => {});
  }, []);

  React.useEffect(() => { cargarRetiros(); }, [cargarRetiros]);

  const solicitar = async () => {
    const montoNum = parseFloat(form.monto);
    if (!montoNum || montoNum < MINIMO) return setMsg({ ok: false, text: `El mínimo es $${MINIMO.toLocaleString()}` });
    if (montoNum > saldoReal) return setMsg({ ok: false, text: 'Saldo insuficiente' });
    if (!form.clabe || !/^\d{18}$/.test(form.clabe)) return setMsg({ ok: false, text: 'CLABE inválida (18 dígitos)' });

    setEnviando(true); setMsg(null);
    try {
      const d = await apiSolicitarRetiro({ monto: montoNum, metodo: 'spei', cuenta: { clabe: form.clabe, banco: form.banco } });
      if (d.ok) {
        setMsg({ ok: true, text: d.mensaje || 'Solicitud enviada. El pago se procesará el próximo viernes.' });
        setShowModal(false);
        setForm({ monto: '', clabe: '', banco: '' });
        cargarRetiros();
      } else {
        setMsg({ ok: false, text: d.error || 'Error al solicitar' });
      }
    } catch (e) {
      setMsg({ ok: false, text: e?.message || 'Error al solicitar retiro' });
    } finally {
      setEnviando(false);
    }
  };


  const colorStatus = { pendiente: 'bg-yellow-100 text-yellow-700', aprobado: 'bg-blue-100 text-blue-700', pagado: 'bg-green-100 text-green-700', rechazado: 'bg-red-100 text-red-700', cancelado: 'bg-gray-100 text-gray-500' };
  const labelStatus = { pendiente: '⏳ Pendiente', aprobado: '✅ Aprobado', pagado: '💚 Pagado', rechazado: '❌ Rechazado', cancelado: '🚫 Cancelado' };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <DollarSign size={20} className="text-green-600" /> Retiro de ganancias
          </h3>
          <p className="text-sm text-gray-500 mt-0.5">
            Saldo disponible: <span className="font-bold text-green-700">${saldoReal.toLocaleString()} MXN</span>
          </p>
          <p className="text-xs text-gray-500 mt-0.5">Los pagos se procesan automáticamente cada viernes</p>
        </div>
        {!clabeGuardada ? (
          <button
            onClick={() => { setSeccionExterna('pagos'); setAbrirClabeExterna(true); }}
            className="text-right group"
          >
            <p className="text-xs text-orange-600 font-semibold group-hover:underline">+ Agregar CLABE interbancaria</p>
            <p className="text-xs text-gray-400">Necesaria para recibir tus retiros</p>
          </button>
        ) : saldoReal >= MINIMO ? (
          <button
            onClick={() => { setForm(p => ({ ...p, clabe: p.clabe || clabeGuardada, banco: p.banco || bancoGuardado })); setShowModal(true); setMsg(null); }}
            className="flex items-center gap-2 bg-green-600 text-white font-semibold px-5 py-2.5 rounded-xl hover:bg-green-700 transition text-sm"
          >
            <ArrowRight size={16} /> Solicitar retiro
          </button>
        ) : (
          <div className="text-right">
            <p className="text-xs text-gray-400">Mínimo: ${MINIMO.toLocaleString()}</p>
            <p className="text-xs text-gray-400">Te faltan <span className="font-semibold text-orange-600">${(MINIMO - saldoReal).toLocaleString()}</span></p>
          </div>
        )}
      </div>

      {msg && (
        <div className={`mb-4 px-4 py-3 rounded-lg text-sm font-medium ${msg.ok ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
          {msg.text}
        </div>
      )}

      {/* Historial de retiros */}
      {retiros.length > 0 && (
        <div className="mt-2">
          <p className="text-xs font-semibold text-gray-500 uppercase mb-2">Historial de retiros</p>
          <div className="space-y-2">
            {retiros.map(r => (
              <div key={r.id} className="bg-gray-50 rounded-xl px-4 py-3">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-gray-800">${r.monto.toLocaleString()} MXN</p>
                    <p className="text-xs text-gray-500">
                      CLABE: <span className="font-mono">{r.cuenta?.clabe ? `···· ${r.cuenta.clabe.slice(-4)}` : '—'}</span>
                      {r.cuenta?.banco && ` · ${r.cuenta.banco}`}
                    </p>
                    <p className="text-xs text-gray-400">{new Date(r.creadoEn).toLocaleDateString('es-MX')}</p>
                  </div>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${colorStatus[r.status] || 'bg-gray-100 text-gray-600'}`}>
                    {labelStatus[r.status] || r.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Modal de solicitud */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white shadow-2xl rounded-2xl w-full max-w-md p-6">
            <div className="flex items-center justify-between mb-5">
              <h3 className="text-xl font-bold text-gray-800">Solicitar retiro</h3>
              <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Monto a retirar</label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-semibold">$</span>
                  <input
                    type="number" min={MINIMO} max={saldoReal} step={50}
                    value={form.monto}
                    onChange={e => setForm(p => ({ ...p, monto: e.target.value }))}
                    onWheel={e => e.target.blur()}
                    className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 pl-8 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                    placeholder={`Mínimo $${MINIMO.toLocaleString()}`}
                  />
                </div>
                <p className="text-xs text-gray-400 mt-1">Disponible: ${saldoReal.toLocaleString()} MXN</p>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">CLABE Interbancaria <span className="text-red-500">*</span></label>
                <input
                  type="text" maxLength={18}
                  value={form.clabe}
                  onChange={e => setForm(p => ({ ...p, clabe: e.target.value.replace(/\D/g, '').slice(0, 18) }))}
                  className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm font-mono tracking-widest focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="18 dígitos"
                />
                {clabeGuardada && form.clabe === clabeGuardada && (
                  <p className="text-xs text-green-600 mt-1">✓ Usando CLABE guardada en tu perfil</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Banco</label>
                <input
                  type="text"
                  value={form.banco}
                  onChange={e => setForm(p => ({ ...p, banco: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="Ej: BBVA, Banorte, HSBC..."
                />
              </div>
            </div>

            {msg && (
              <div className={`mt-4 px-4 py-3 rounded-lg text-sm font-medium ${msg.ok ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                {msg.text}
              </div>
            )}

            <div className="flex gap-3 mt-6">
              <button
                onClick={solicitar} disabled={enviando}
                className="flex-1 bg-green-600 text-white font-semibold py-2.5 rounded-xl hover:bg-green-700 transition disabled:opacity-50 text-sm"
              >
                {enviando ? 'Enviando...' : '💸 Solicitar retiro'}
              </button>
              <button onClick={() => setShowModal(false)} className="px-4 border border-gray-300 rounded-xl bg-gray-50 text-gray-600 hover:bg-gray-100 text-sm">Cancelar</button>
            </div>

            <p className="text-xs text-gray-400 text-center mt-3">Los pagos se procesan automáticamente cada viernes a las 10:00 AM</p>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Sección: Mi Actividad ───────────────────────────────────────────────────
function SeccionMiActividad() {
  const [metricas, setMetricas] = React.useState(null);
  const [cargando, setCargando] = React.useState(true);

  React.useEffect(() => {
    apiGetMisMetricas()
      .then(m => setMetricas(m))
      .catch(() => {})
      .finally(() => setCargando(false));
  }, []);

  const fmt = (n) => `$${(n || 0).toLocaleString('es-MX', { minimumFractionDigits: 0 })} MXN`;

  if (cargando) return (
    <div className="p-6 max-w-4xl mx-auto flex items-center justify-center h-48">
      <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (!metricas || metricas.fletesCompletados === 0) return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
        <BarChart3 size={26} className="text-blue-600" /> Mi Actividad
      </h2>
      <div className="bg-white rounded-2xl border border-gray-200 p-12 text-center">
        <Activity size={48} className="mx-auto text-gray-300 mb-4" />
        <p className="text-gray-500">Aún no tienes fletes completados.</p>
        <p className="text-sm text-gray-400 mt-1">Tus métricas aparecerán aquí una vez que completes tu primer flete.</p>
      </div>
    </div>
  );

  const maxMensual = Math.max(...metricas.gastoMensual.map(m => m.monto), 1);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
        <BarChart3 size={26} className="text-blue-600" /> Mi Actividad
      </h2>

      {/* Cards principales */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {[
          { label: 'Fletes completados', value: metricas.fletesCompletados, icon: CheckCircle, color: 'text-green-600', bg: 'bg-green-50' },
          { label: 'Gasto este mes', value: fmt(metricas.gastoMes), icon: CreditCard, color: 'text-blue-600', bg: 'bg-blue-50' },
          { label: 'Gasto este año', value: fmt(metricas.gastoAnio), icon: TrendingUp, color: 'text-purple-600', bg: 'bg-purple-50' },
          { label: 'Ahorro estimado', value: fmt(metricas.ahorroEstimado), icon: DollarSign, color: 'text-orange-600', bg: 'bg-orange-50' },
        ].map(({ label, value, icon: Icon, color, bg }) => (
          <div key={label} className={`${bg} rounded-2xl p-4 border border-gray-100`}>
            <Icon size={20} className={`${color} mb-2`} />
            <p className="text-xs text-gray-500 mb-0.5">{label}</p>
            <p className={`text-lg font-black ${color}`}>{value}</p>
          </div>
        ))}
      </div>

      {/* Gráfica mensual */}
      <div className="bg-white rounded-2xl border border-gray-200 p-6 mb-6">
        <h3 className="font-bold text-gray-800 mb-4">Gasto últimos 6 meses</h3>
        <div className="flex items-end gap-2 h-32">
          {metricas.gastoMensual.map((m, i) => (
            <div key={i} className="flex-1 flex flex-col items-center gap-1">
              <span className="text-xs text-gray-500">{m.monto > 0 ? `$${(m.monto/1000).toFixed(0)}k` : ''}</span>
              <div
                className="w-full rounded-t-lg bg-blue-500 transition-all"
                style={{ height: `${Math.max(4, (m.monto / maxMensual) * 100)}px` }}
              />
              <span className="text-xs text-gray-400">{m.mes}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Insights */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {metricas.rutaFrecuente && (
          <div className="bg-white rounded-2xl border border-gray-200 p-5">
            <p className="text-xs font-semibold text-gray-400 uppercase mb-2">Ruta más frecuente</p>
            <p className="font-bold text-gray-800">{metricas.rutaFrecuente.origen}</p>
            <p className="text-gray-400 text-xs my-0.5">↓</p>
            <p className="font-bold text-gray-800">{metricas.rutaFrecuente.destino}</p>
            <p className="text-xs text-blue-600 mt-2 font-semibold">{metricas.rutaFrecuente.count} flete{metricas.rutaFrecuente.count !== 1 ? 's' : ''}</p>
          </div>
        )}
        {metricas.transportistaFavorito && (
          <div className="bg-white rounded-2xl border border-gray-200 p-5">
            <p className="text-xs font-semibold text-gray-400 uppercase mb-2">Transportista favorito</p>
            <p className="font-bold text-gray-800 text-lg">{metricas.transportistaFavorito.nombre}</p>
            <p className="text-xs text-green-600 mt-2 font-semibold">{metricas.transportistaFavorito.viajes} viaje{metricas.transportistaFavorito.viajes !== 1 ? 's' : ''} juntos</p>
          </div>
        )}
        <div className="bg-white rounded-2xl border border-gray-200 p-5">
          <p className="text-xs font-semibold text-gray-400 uppercase mb-2">Resumen general</p>
          <div className="space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Gasto total acumulado</span>
              <span className="font-bold text-gray-800">{fmt(metricas.gastoTotal)}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Cancelaciones realizadas</span>
              <span className={`font-bold ${metricas.cancelados > 0 ? 'text-red-500' : 'text-gray-800'}`}>{metricas.cancelados}</span>
            </div>
            {metricas.ahorroEstimado > 0 && (
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Ahorro vs precio máximo</span>
                <span className="font-bold text-orange-600">{fmt(metricas.ahorroEstimado)}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Sección: Mis Pagos (cliente) ────────────────────────────────────────────
function SeccionMisPagosCliente({ usuario, dispatch, store, onConfirmarEntrega, refreshKey = 0, autoOpenClabe = false, onAutoOpenClabeDone = null }) {
  const [pagos, setPagos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [msg, setMsg] = React.useState(null);

  // ── CLABE guardada ──
  const [editandoClabe, setEditandoClabe] = React.useState(false);
  React.useEffect(() => { if (autoOpenClabe) { setEditandoClabe(true); onAutoOpenClabeDone?.(); } }, [autoOpenClabe]);
  const [clabeForm, setClabeForm] = React.useState({ clabe: usuario?.clabe || '', banco: usuario?.banco || '' });
  const [guardandoClabe, setGuardandoClabe] = React.useState(false);
  const [msgClabe, setMsgClabe] = React.useState(null);
  const [clabeGuardada, setClabeGuardada] = React.useState(usuario?.clabe || '');
  const [bancoGuardado, setBancoGuardado] = React.useState(usuario?.banco || '');

  const guardarClabe = async () => {
    if (clabeForm.clabe && !/^\d{18}$/.test(clabeForm.clabe)) {
      return setMsgClabe({ ok: false, text: 'La CLABE debe tener 18 dígitos' });
    }
    setGuardandoClabe(true); setMsgClabe(null);
    try {
      const actualizado = await apiActualizarPerfil({ clabe: clabeForm.clabe || null, banco: clabeForm.banco || null });
      if (actualizado) {
        setClabeGuardada(actualizado.clabe || '');
        setBancoGuardado(actualizado.banco || '');
        if (dispatch) dispatch(s => ({ ...s, usuarioPerfil: { ...(s.usuarioPerfil || {}), ...actualizado } }));
        setMsgClabe({ ok: true, text: 'CLABE guardada correctamente' });
        setEditandoClabe(false);
      }
    } catch (e) {
      setMsgClabe({ ok: false, text: 'Error al guardar' });
    } finally {
      setGuardandoClabe(false);
    }
  };

  const [retiros, setRetiros] = React.useState([]);
  const esReferidor = store.usuarioPerfil?.esReferidor ?? usuario?.esReferidor;

  const cargar = React.useCallback(() => {
    const promesas = [
      apiGetMisPagos().then(p => setPagos(p || [])).catch(() => setPagos([])),
    ];
    if (esReferidor) {
      promesas.push(apiGetMisRetiros().then(r => setRetiros(r || [])).catch(() => setRetiros([])));
    }
    Promise.all(promesas).finally(() => setLoading(false));
  }, [esReferidor]); // eslint-disable-line

  React.useEffect(() => { cargar(); }, [cargar]);
  React.useEffect(() => { if (refreshKey > 0) cargar(); }, [refreshKey]); // eslint-disable-line

  const totalGastado = pagos.filter(p => ['liberado', 'pagado'].includes(p.status)).reduce((s, p) => s + p.monto, 0);
  const enTransitoMonto = pagos.filter(p => p.status === 'retenido').reduce((s, p) => s + p.monto, 0);
  const pendienteConfirmar = pagos.filter(p => p.status === 'retenido' && p.viaje?.status === 'completada');

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
        <CreditCard size={26} className="text-blue-600" /> Mis Pagos
      </h2>

      {msg && (
        <div className={`mb-4 px-4 py-3 rounded-lg text-sm font-medium ${msg.ok ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
          {msg.text}
        </div>
      )}

      {/* ── CLABE para retiro de comisiones — solo referidores ── */}
      {(store.usuarioPerfil?.esReferidor ?? usuario?.esReferidor) && <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5 mb-6">
        <div className="flex items-center justify-between mb-3">
          <div>
            <h3 className="font-bold text-gray-800 flex items-center gap-2">
              <CreditCard size={18} className="text-indigo-600" /> CLABE interbancaria
            </h3>
            <p className="text-xs text-gray-500 mt-0.5">Se usa para recibir tus retiros de comisiones por referidos</p>
          </div>
          {!editandoClabe && (
            <button onClick={() => { setClabeForm({ clabe: clabeGuardada, banco: bancoGuardado }); setEditandoClabe(true); setMsgClabe(null); }}
              className="text-xs text-indigo-600 hover:text-indigo-800 font-semibold border border-indigo-200 px-3 py-1.5 rounded-lg hover:bg-indigo-50 transition">
              {clabeGuardada ? 'Editar' : '+ Agregar'}
            </button>
          )}
        </div>

        {msgClabe && (
          <div className={`mb-3 px-3 py-2 rounded-lg text-xs font-medium ${msgClabe.ok ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
            {msgClabe.text}
          </div>
        )}

        {editandoClabe ? (
          <div className="space-y-3">
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">CLABE (18 dígitos)</label>
              <input
                type="text" inputMode="numeric" maxLength={18}
                value={clabeForm.clabe}
                onChange={e => setClabeForm(p => ({ ...p, clabe: e.target.value.replace(/\D/g, '') }))}
                placeholder="ej. 012345678901234567"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">Banco (opcional)</label>
              <input
                type="text"
                value={clabeForm.banco}
                onChange={e => setClabeForm(p => ({ ...p, banco: e.target.value }))}
                placeholder="ej. BBVA, Banorte, HSBC..."
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300"
              />
            </div>
            <div className="flex gap-2">
              <button onClick={guardarClabe} disabled={guardandoClabe}
                className="bg-indigo-600 text-white text-sm font-semibold px-4 py-2 rounded-lg hover:bg-indigo-700 transition disabled:opacity-50">
                {guardandoClabe ? 'Guardando...' : 'Guardar'}
              </button>
              <button onClick={() => { setEditandoClabe(false); setMsgClabe(null); }}
                className="text-gray-600 text-sm px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition">
                Cancelar
              </button>
            </div>
          </div>
        ) : clabeGuardada ? (
          <div className="flex items-center gap-3 bg-indigo-50 rounded-xl px-4 py-3">
            <CreditCard size={20} className="text-indigo-500 shrink-0" />
            <div>
              <p className="font-mono text-sm font-bold text-indigo-800 tracking-widest">
                {'•'.repeat(14)}{clabeGuardada.slice(-4)}
              </p>
              {bancoGuardado && <p className="text-xs text-indigo-600 mt-0.5">{bancoGuardado}</p>}
            </div>
            <span className="ml-auto text-xs text-green-600 font-semibold bg-green-100 px-2 py-0.5 rounded-full">✓ Guardada</span>
          </div>
        ) : (
          <p className="text-sm text-gray-400 italic">Sin CLABE registrada — agrégala para solicitar retiros más rápido</p>
        )}
      </div>}

      {/* ── Historial de retiros MLM — solo referidores ── */}
      {esReferidor && retiros.length > 0 && (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5 mb-6">
          <h3 className="font-bold text-gray-800 flex items-center gap-2 mb-4">
            <span className="text-lg">💸</span> Retiros de comisiones
          </h3>
          <div className="space-y-2">
            {retiros.map(r => {
              const colorStatus = r.status === 'pagado' ? 'bg-green-100 text-green-700'
                : r.status === 'aprobado' ? 'bg-blue-100 text-blue-700'
                : r.status === 'rechazado' ? 'bg-red-100 text-red-600'
                : 'bg-yellow-100 text-yellow-700';
              const labelStatus = r.status === 'pagado' ? '✅ Pagado'
                : r.status === 'aprobado' ? '🔄 Aprobado'
                : r.status === 'rechazado' ? '❌ Rechazado'
                : '⏳ Pendiente';
              return (
                <div key={r.id} className="flex items-center justify-between bg-gray-50 rounded-xl px-4 py-3">
                  <div>
                    <p className="font-semibold text-gray-800">${r.monto.toLocaleString('es-MX')} MXN</p>
                    <p className="text-xs text-gray-400">
                      {new Date(r.creadoEn).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}
                      {r.cuenta?.clabe && <span className="ml-2 font-mono">···· {r.cuenta.clabe.slice(-4)}</span>}
                    </p>
                    {r.notasAdmin && <p className="text-xs text-gray-500 mt-0.5 italic">{r.notasAdmin}</p>}
                  </div>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${colorStatus}`}>{labelStatus}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Pagos pendientes de confirmar */}
      {pendienteConfirmar.length > 0 && (
        <div className="mb-6 bg-orange-50 border border-orange-200 rounded-xl p-4">
          <p className="font-bold text-orange-800 mb-3 flex items-center gap-2">⏳ Entregas pendientes de confirmar ({pendienteConfirmar.length})</p>
          {pendienteConfirmar.map(p => (
            <div key={p.id} className="flex items-center justify-between bg-white rounded-lg shadow border-orange-200 p-3 mb-2">
              <div>
                <p className="font-medium text-gray-800 text-sm">{p.viaje?.origen?.split(',')[0]} → {p.viaje?.destino?.split(',')[0]}</p>
                <p className="text-xs text-gray-500">Pago retenido: <span className="font-bold text-orange-700">${p.monto.toLocaleString()} MXN</span></p>
              </div>
              <button
                onClick={() => onConfirmarEntrega && onConfirmarEntrega(p.viajeId)}
                className="flex items-center gap-2 bg-green-600 text-white text-sm font-semibold px-4 py-2 rounded-lg hover:bg-green-700 transition"
              >
                ✅ Confirmar de recibido
              </button>
            </div>
          ))}
        </div>
      )}

      {loading ? (
        <div className="text-center py-12 text-gray-400">Cargando...</div>
      ) : pagos.length === 0 ? (
        <div className="text-center py-12 text-gray-400">
          <DollarSign size={40} className="mx-auto mb-3 opacity-30" />
          <p>No tienes pagos registrados aún</p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 gap-4 mb-5">
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
              <p className="text-xs text-blue-700 font-semibold uppercase mb-1">Total gastado</p>
              <p className="text-2xl font-bold text-blue-800">${totalGastado.toLocaleString()} <span className="text-sm font-normal">MXN</span></p>
            </div>
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
              <p className="text-xs text-yellow-700 font-semibold uppercase mb-1">En tránsito / por confirmar</p>
              <p className="text-2xl font-bold text-yellow-800">${enTransitoMonto.toLocaleString()} <span className="text-sm font-normal">MXN</span></p>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Ruta</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Transportista</th>
                  <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">Monto</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase">Estado</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {pagos.map(p => (
                  <tr key={p.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <p className="font-medium text-gray-800 truncate max-w-[180px]">{p.viaje?.origen?.split(',')[0]} → {p.viaje?.destino?.split(',')[0]}</p>
                      {p.viaje?.retornoId && <span className="text-xs bg-teal-100 text-teal-700 px-1.5 py-0.5 rounded font-semibold">Retorno</span>}
                    </td>
                    <td className="px-4 py-3 text-gray-600">{p.viaje?.transportista || '—'}</td>
                    <td className="px-4 py-3 text-right font-bold text-gray-800">${p.monto.toLocaleString()}</td>
                    <td className="px-4 py-3 text-center">
                      {['liberado', 'pagado'].includes(p.status) || p.viaje?.status === 'confirmado' ? (
                        <span className="bg-green-100 text-green-700 text-xs font-semibold px-2 py-1 rounded-full">✅ Completado</span>
                      ) : p.status === 'reembolsado' ? (
                        <span className="bg-red-100 text-red-700 text-xs font-semibold px-2 py-1 rounded-full">↩ Reembolsado</span>
                      ) : p.status === 'cancelado' || p.viaje?.status === 'cancelado' ? (
                        <span className="bg-gray-100 text-gray-600 text-xs font-semibold px-2 py-1 rounded-full">🚫 Cancelado</span>
                      ) : p.viaje?.status === 'completada' ? (
                        <span className="bg-orange-100 text-orange-700 text-xs font-semibold px-2 py-1 rounded-full">⏳ Pendiente confirmar</span>
                      ) : (
                        <span className="bg-yellow-100 text-yellow-700 text-xs font-semibold px-2 py-1 rounded-full">🔒 En tránsito</span>
                      )}
                    </td>
                    <td className="px-4 py-3 text-gray-500 text-xs">{new Date(p.creadoEn).toLocaleDateString('es-MX')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

function AppCliente({ usuario, onLogout }) {
  const { store, dispatch, recargar } = useApiStore('cliente');
  // ========== ESTADOS DE LA APLICACIÓN ==========
  const [seccion, setSeccion] = useState('dashboard');
  const [abrirRetiroDirecto, setAbrirRetiroDirecto] = useState(false);
  const [abrirClabeDirecto, setAbrirClabeDirecto] = useState(false);
  const [sidebarAbierto, setSidebarAbierto] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  // GPS en tiempo real del chofer — keyed por viajeId
  const [choferGpsLive, setChoferGpsLive] = useState({});
  useEffect(() => {
    const handle = (e) => {
      const { viajeId, ordenId, lat, lng, choferNombre } = e.detail || {};
      if (!lat || !lng) return;
      setChoferGpsLive(prev => {
        const next = { ...prev };
        const gps = { lat, lng, choferNombre, ts: Date.now() };
        if (viajeId) next[viajeId] = gps;
        if (ordenId) next[ordenId] = gps;
        return next;
      });
    };
    window.addEventListener('choyero_gps_update', handle);
    return () => window.removeEventListener('choyero_gps_update', handle);
  }, []);
  const [solicitudParaRepetir, setSolicitudParaRepetir] = useState(null);
  const [solicitudEditando, setSolicitudEditando] = useState(null);
  const [mostrarPlantillas, setMostrarPlantillas] = useState(false);
  const [expandedSolicitud, setExpandedSolicitud] = useState(null);
  const [expandedViaje, setExpandedViaje] = useState(null);
  const [speiPendienteViajeId, setSpeiPendienteViajeId] = useState(null);
  const [reglasReferidosAbiertas, setReglasReferidosAbiertas] = useState(false);
  const [modalCartaPorte, setModalCartaPorte] = useState(null); // { viajeId, cartaPorte }
  const [cartaPorteForm, setCartaPorteForm] = useState(null);
  const [guardandoCartaPorte, setGuardandoCartaPorte] = useState(false);
  const [editandoContacto, setEditandoContacto] = useState(null); // viajeId
  const [contactoForm, setContactoForm] = useState({ contactoDestino: '', telefonoDestino: '' });
  const [guardandoContacto, setGuardandoContacto] = useState(false);
  const [modalSolicitarFactura, setModalSolicitarFactura] = useState(null); // { viajeId, viaje }
  const [formSolicitarFactura, setFormSolicitarFactura] = useState({ rfcReceptor: '', nombreReceptor: '', regimenFiscal: '', cpFiscal: '', usoCfdi: 'S01', notas: '' });
  const [enviandoSolicitudFactura, setEnviandoSolicitudFactura] = useState(false);
  const [modalDatosFiscales, setModalDatosFiscales] = useState(false);
  const [formDatosFiscales, setFormDatosFiscales] = useState({ rfc: '', razonSocial: '', regimenFiscal: '', cpFiscal: '', usoCfdi: 'G03' });
  const [guardandoDatosFiscales, setGuardandoDatosFiscales] = useState(false);
  const [msgDatosFiscales, setMsgDatosFiscales] = useState(null);
  const [modalFiscalRequerido, setModalFiscalRequerido] = useState(false); // bloquea antes del pago
  const [subiendoCsfPago, setSubiendoCsfPago] = useState(false);
  const [modalCancelarSolicitud, setModalCancelarSolicitud] = useState(null); // { sol }
  const [motivoCancelacion, setMotivoCancelacion] = useState(''); // valor del select
  const [motivoLibre, setMotivoLibre] = useState(''); // texto libre cuando es 'otro'
  const [cancelando, setCancelando] = useState(false);
  const _facturasVistasKey = `choyero_facturas_cliente_vistas_${usuario?.id || 'guest'}`;
  const [facturasClienteVistas, setFacturasClienteVistas] = useState(() => {
    try { return new Set(JSON.parse(localStorage.getItem(`choyero_facturas_cliente_vistas_${usuario?.id || 'guest'}`) || '[]')); } catch { return new Set(); }
  });

  // ── Carta Porte: productos y direcciones guardados en localStorage ──
  const _cpKey = (tipo) => `choyero_cp_${tipo}_${usuario?.id}`;
  const cpGetGuardados = (tipo) => { try { return JSON.parse(localStorage.getItem(_cpKey(tipo)) || '[]'); } catch { return []; } };
  const cpSaveProducto = (prod) => {
    const lista = cpGetGuardados('productos');
    if (lista.some(p => p.descripcion === prod.descripcion && p.claveSAT === prod.claveSAT)) return false;
    lista.unshift({ ...prod, _id: Date.now() });
    localStorage.setItem(_cpKey('productos'), JSON.stringify(lista.slice(0, 20)));
    return true;
  };
  const cpDeleteProducto = (id) => {
    const lista = cpGetGuardados('productos').filter(p => p._id !== id);
    localStorage.setItem(_cpKey('productos'), JSON.stringify(lista));
  };
  const cpSaveDireccion = (dir) => {
    const lista = cpGetGuardados('direcciones');
    if (lista.some(d => d.nombre === dir.nombre && d.rfc === dir.rfc)) return false;
    lista.unshift({ ...dir, _id: Date.now() });
    localStorage.setItem(_cpKey('direcciones'), JSON.stringify(lista.slice(0, 20)));
    return true;
  };
  const cpDeleteDireccion = (id) => {
    const lista = cpGetGuardados('direcciones').filter(d => d._id !== id);
    localStorage.setItem(_cpKey('direcciones'), JSON.stringify(lista));
  };
  const [verMapaViajeId, setVerMapaViajeId] = useState(null);
  const [verMapaRetornoId, setVerMapaRetornoId] = useState(null);
  const [expandedRetorno, setExpandedRetorno] = useState(null);
  const [mostrarCotizaciones, setMostrarCotizaciones] = useState(false);
  const [califTransCache, setCalifTransCache] = useState({});
  const [opinExpanded, setOpinExpanded] = useState({});
  const [mostrarComparador, setMostrarComparador] = useState(false);
  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
  const [mostrarPasarelaPago, setMostrarPasarelaPago] = useState(false);
  const [mostrarCompartir, setMostrarCompartir] = useState(false);
  const [mostrarCalificar, setMostrarCalificar] = useState(null);
  const [calificacionLocal, setCalificacionLocal] = useState(0);
  const [comentarioLocal, setComentarioLocal] = useState('');
  const [hoverStar, setHoverStar] = useState(0);
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);
  const [cotizacionesParaComparar, setCotizacionesParaComparar] = useState([]);
  const [cotizacionGanadora, setCotizacionGanadora] = useState(null);
  const esPersonaFisica = usuario?.tipoPersona === 'fisica';
  const [notificacion, setNotificacion] = useState(null);
  const [procesandoPago, setProcesandoPago] = useState(false);
  const [pagoCompletado, setPagoCompletado] = useState(false);
  const [linkCopiado, setLinkCopiado] = useState(null); // null | 'cliente' | 'transportista' | 'referidor'
  const [codigoReferidoInput, setCodigoReferidoInput] = useState('');
  const [msgAplicarReferido, setMsgAplicarReferido] = useState(null);
  const [mostrarNotificaciones, setMostrarNotificaciones] = useState(false);
  const [chatModal, setChatModal] = useState(null);
  const [modalTicket, setModalTicket] = useState(null); // { viajeId, origen, destino }
  const [ticketTipo, setTicketTipo] = useState('');
  const [ticketDescripcion, setTicketDescripcion] = useState('');
  const [ticketEnviando, setTicketEnviando] = useState(false);
  const _ticketsKey = `choyero_tickets_${usuario?.id || 'guest'}`;
  const [viajesConTicket, setViajesConTicket] = useState(() => {
    try { return JSON.parse(localStorage.getItem(`choyero_tickets_${usuario?.id || 'guest'}`) || '[]'); } catch { return []; }
  });
  const _chatSeenKey = `choyero_chat_seen_${usuario?.id || 'guest'}`;
  const [lastSeenMessages, setLastSeenMessages] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem(_chatSeenKey) || '{}'); } catch { return {}; }
  });
  const [unreadByChatKey, setUnreadByChatKey] = useState({});
  const chatModalRef = useRef(null);
  const prevMensajesCount = useRef((store.mensajes || []).length);
  const handleAvatarChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (ev) => {
      const avatar = ev.target.result;
      // Feedback inmediato: actualiza store.usuarioPerfil para que la UI reaccione
      dispatch(s => ({ ...s, usuarioPerfil: { ...(s.usuarioPerfil || usuario || {}), avatar } }));
      try {
        const updated = await apiActualizarPerfil({ avatar });
        guardarUsuario({ ...usuario, ...updated });
        dispatch(s => ({ ...s, usuarioPerfil: { ...(s.usuarioPerfil || {}), ...updated } }));
      } catch { /* ya se actualizó localmente */ }
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  };
  const [toastNotif, setToastNotif] = useState([]);
  const [fotoLightbox, setFotoLightbox] = useState(null);
  // Solicitar permiso de notificaciones del navegador al montar
  useEffect(() => { solicitarPermisoNotif(); }, []);
  // Expirar solicitudes vencidas al montar y cada minuto
  useEffect(() => {
    expirarSolicitudesVencidas();
    const interval = setInterval(expirarSolicitudesVencidas, 60000);
    return () => clearInterval(interval);
  }, []);
  // Detectar regreso desde MercadoPago y expandir viaje correspondiente
  useEffect(() => {
    try {
      const viajeId = sessionStorage.getItem('choyero_viaje_pago');
      if (viajeId) {
        sessionStorage.removeItem('choyero_viaje_pago');
        setSeccion('viajes');
        setExpandedViaje(viajeId);
        // Detectar si el pago quedó pendiente (SPEI): collection_status=pending
        const params = new URLSearchParams(window.location.search);
        if (params.get('collection_status') === 'pending' || params.get('status') === 'pending') {
          setSpeiPendienteViajeId(viajeId);
        }
        window.history.replaceState({}, '', window.location.pathname);
        setTimeout(() => document.getElementById(`viaje-${viajeId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 600);
      }
    } catch (_) {}
  }, []);

  // Detectar regreso desde MercadoPago para retorno vacío
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const pagoRetornoRaw = sessionStorage.getItem('choyero_retorno_pago');
      if (params.get('pago') === 'exitoso' && params.get('retornoId') && pagoRetornoRaw) {
        const { retornoId, ofertaId, viajeId } = JSON.parse(pagoRetornoRaw);
        sessionStorage.removeItem('choyero_retorno_pago');
        window.history.replaceState({}, '', window.location.pathname);
        apiPagarRetorno(retornoId, ofertaId, 'mercadopago').catch(() => { mostrarNotificacion('El pago fue procesado pero hubo un error al confirmar. Contacta a soporte si el viaje no aparece.', 'error'); });
        setSeccion('viajes');
        if (viajeId) {
          setExpandedViaje(viajeId);
          setTimeout(() => document.getElementById(`viaje-${viajeId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 600);
        }
      }
    } catch (_) {}
  }, []);

  // Tick para refrescar contadores de tiempo cada 60 s
  const [tickMinuto, setTickMinuto] = useState(0);
  useEffect(() => {
    const iv = setInterval(() => setTickMinuto(t => t + 1), 60000);
    return () => clearInterval(iv);
  }, []);
  const [toastPausado, setToastPausado] = useState(false);
  const [confirmarEntregaViajeId, setConfirmarEntregaViajeId] = useState(null);
  const [modalContraEntrega, setModalContraEntrega] = useState(null); // { viajeId, monto }
  const [procesandoContraEntrega, setProcesandoContraEntrega] = useState(false);
  const [pagosRefreshKey, setPagosRefreshKey] = useState(0);
  const [cancelarViajeModal, setCancelarViajeModal] = useState(null); // { id, origen, destino }
  const [cancelarMotivo, setCancelarMotivo] = useState('');
  const [cancelandoViaje, setCancelndoViaje] = useState(false);
  const [cancelModalError, setCancelModalError] = useState(null);
  const [reenvioVerifLoading, setReenvioVerifLoading] = useState(false);
  const [reenvioVerifOk, setReenvioVerifOk] = useState(false);
  const [fotosFormulario, setFotosFormulario] = useState([]);
  const [origenCoords, setOrigenCoords] = useState(null);
  const [destinoCoords, setDestinoCoords] = useState(null);
  const [mapaAbierto, setMapaAbierto] = useState(null); // 'origen' | 'destino' | null
  const [ciudadCoordsInicial, setCiudadCoordsInicial] = useState(null);
  const [editandoPerfil, setEditandoPerfil] = useState(false);
  const [formPerfil, setFormPerfil] = useState({});
  const [perfilGuardado, setPerfilGuardado] = useState(false);

  const abrirMapa = (tipo, ciudadTexto) => {
    setCiudadCoordsInicial(getCoordsBC(ciudadTexto));
    setMapaAbierto(tipo);
  };

  // Estados mapa para oferta de retorno
  const [mapaAbiertoOferta, setMapaAbiertoOferta] = useState(null); // 'origen' | 'destino' | null
  const [ciudadCoordsInicialOferta, setCiudadCoordsInicialOferta] = useState(null);
  // GPS para cuando se acepta contraoferta sin haber marcado coords
  const [gpsContraoferta, setGpsContraoferta] = useState(null); // { retornoId, ofertaId, tipo: 'origen'|'destino', origenCoords, destinoCoords, retorno, oferta }

  const abrirMapaOferta = (tipo, ciudadTexto) => {
    setCiudadCoordsInicialOferta(getCoordsBC(ciudadTexto));
    setMapaAbiertoOferta(tipo);
  };

  // ========== NOTIFICACIONES DEL STORE ==========
  const notifsPendientes = getNotificacionesPendientes(store, usuario?.id, 'cliente')
    .filter(n => !['calificacion_pendiente', 'nueva_orden', 'escrow_liberado'].includes(n.tipo));

  // Toasts: solo desde evento centralizado de useApiStore (nunca desde polling directo)
  useEffect(() => {
    const agruparCotizaciones = (notifs) => {
      const resultado = [];
      const solicitudesVistas = new Set();
      for (const n of notifs) {
        if (n.tipo === 'nueva_cotizacion' && n.datos?.solicitudId) {
          const sid = n.datos.solicitudId;
          if (solicitudesVistas.has(sid)) continue;
          solicitudesVistas.add(sid);
          const count = notifs.filter(x => x.tipo === 'nueva_cotizacion' && x.datos?.solicitudId === sid).length;
          resultado.push(count > 1
            ? { ...n, titulo: `📋 ${count} nuevas cotizaciones`, mensaje: `Tienes ${count} cotizaciones disponibles para tu solicitud de flete.` }
            : n);
        } else {
          resultado.push(n);
        }
      }
      return resultado;
    };

    // Tipos de notificación exclusivos de transportista — nunca deben mostrarse en el portal cliente
    const TIPOS_SOLO_TRANSPORTISTA = ['calificacion_pendiente', 'nueva_orden', 'escrow_liberado'];

    const handle = (e) => {
      const nuevas = (e.detail?.notificaciones || []).filter(n => !TIPOS_SOLO_TRANSPORTISTA.includes(n.tipo));
      if (nuevas.length === 0) return;
      const agrupadas = agruparCotizaciones(nuevas);
      setToastNotif(q => {
        let actualizado = [...q];
        for (const n of agrupadas) {
          if (n.tipo === 'nueva_cotizacion' && n.datos?.solicitudId) {
            const idx = actualizado.findIndex(x => x.tipo === 'nueva_cotizacion' && x.datos?.solicitudId === n.datos.solicitudId);
            if (idx >= 0) {
              const prevCount = actualizado[idx]._cotizCount || 1;
              const addCount = nuevas.filter(x => x.tipo === 'nueva_cotizacion' && x.datos?.solicitudId === n.datos.solicitudId).length;
              const total = prevCount + addCount;
              actualizado[idx] = { ...actualizado[idx], _cotizCount: total, titulo: `📋 ${total} nuevas cotizaciones`, mensaje: `Tienes ${total} cotizaciones disponibles para tu solicitud de flete.` };
            } else {
              actualizado.push({ ...n, _cotizCount: nuevas.filter(x => x.tipo === 'nueva_cotizacion' && x.datos?.solicitudId === n.datos.solicitudId).length });
            }
          } else {
            actualizado.push(n);
          }
        }
        return actualizado;
      });
      // Marcar como leídas al mostrarse en pantalla — evita que reaparezcan en la siguiente sesión
      marcarNotificacionesLeidas(usuario?.id, 'cliente');
      apiMarcarLeidas().catch(() => {});
    };
    window.addEventListener('choyero_notif_nueva', handle);
    return () => window.removeEventListener('choyero_notif_nueva', handle);
  }, [usuario?.id]); // eslint-disable-line

  // Detectar nuevos mensajes de chat vía evento de socket y mostrar toast
  const mensajesYaToastados = useRef(new Set());
  useEffect(() => {
    const handle = (e) => {
      if (e.detail?.evento !== 'nuevo_mensaje') return;
      const m = e.detail?.data?.mensaje;
      if (!m || m.emisorId === usuario?.id) return;
      if (mensajesYaToastados.current.has(m.id)) return;
      mensajesYaToastados.current.add(m.id);
      // Respuestas de admin a tickets siempre pasan (socket ya llega por user_${id})
      const esRespuestaAdmin = m.emisorRol === 'admin' && m.destinatarioRol === 'cliente';
      if (!esRespuestaAdmin) {
        const myViajeIds = new Set((store.viajes || []).filter(v => v.clienteId === usuario?.id).map(v => v.id));
        if (!myViajeIds.has(m.viajeId)) return;
      }
      if (m.destinatarioRol && m.destinatarioRol !== 'cliente') return;
      // Incrementar badge si el chat de ese viaje no está abierto
      const modalActual = chatModalRef.current;
      const chatAbierto = modalActual && modalActual.viajeId === m.viajeId;
      if (!chatAbierto) {
        const chatKey = `${m.viajeId}_${m.emisorRol}`;
        setUnreadByChatKey(prev => ({ ...prev, [chatKey]: (prev[chatKey] || 0) + 1 }));
        const preview = m.texto.length > 40 ? m.texto.slice(0, 40) + '…' : m.texto;
        setToastNotif(q => [...q, { tipo: 'chat_mensaje', titulo: `💬 Mensaje de ${m.emisorNombre}`, mensaje: preview, datos: { viajeId: m.viajeId }, contraparte: { id: m.emisorId, nombre: m.emisorNombre, rol: m.emisorRol } }]);
        playNotifSound();
        fireNotifBrowser(`💬 Mensaje de ${m.emisorNombre}`, preview);
      }
    };
    window.addEventListener('choyero_realtime', handle);
    return () => window.removeEventListener('choyero_realtime', handle);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario?.id, store.viajes]);

  const cerrarToast = () => {
    setToastNotif(q => {
      if (q[0]?.id) marcarNotificacionesLeidas(usuario?.id, 'cliente');
      return q.slice(1);
    });
    setToastPausado(true);
  };

  // Mostrar siguiente notificación cuando el modal de cotizaciones se cierra
  useEffect(() => {
    if (toastPausado && !mostrarCotizaciones) {
      setToastPausado(false);
    }
  }, [mostrarCotizaciones, toastPausado]);

  // Cerrar modales con tecla ESC — en orden de prioridad (más reciente primero)
  // NO incluye: mostrarPasarelaPago, retornoPagar, mostrarConfirmacion (flujos de pago)
  useEffect(() => {
    const handle = (e) => {
      if (e.key !== 'Escape') return;
      if (chatModal)               { chatModalRef.current = null; setChatModal(null); return; }
      if (mostrarCalificar)        { setMostrarCalificar(null); return; }
      if (cancelarViajeModal)      { setCancelarViajeModal(null); setCancelModalError(null); return; }
      if (modalCancelarSolicitud)  { setModalCancelarSolicitud(null); return; }
      if (confirmarEntregaViajeId) { setConfirmarEntregaViajeId(null); return; }
      if (modalTicket)             { setModalTicket(null); return; }
      if (modalCartaPorte)         { setModalCartaPorte(null); return; }
      if (modalSolicitarFactura)   { setModalSolicitarFactura(null); return; }
      if (modalDatosFiscales)      { setModalDatosFiscales(false); return; }
      if (mostrarComparador)       { setMostrarComparador(false); return; }
      if (mostrarCotizaciones)     { setMostrarCotizaciones(false); return; }
      if (mostrarPlantillas)       { setMostrarPlantillas(false); return; }
      if (mostrarFormulario)       { setMostrarFormulario(false); setSolicitudParaRepetir(null); return; }
      // Notificaciones — menor prioridad que modales
      if (toastNotif.length > 0 && !toastPausado) { cerrarToast(); return; }
      if (mostrarNotificaciones)   { setMostrarNotificaciones(false); return; }
    };
    document.addEventListener('keydown', handle);
    return () => document.removeEventListener('keydown', handle);
  }, [chatModal, mostrarCalificar, cancelarViajeModal, modalCancelarSolicitud, confirmarEntregaViajeId, modalTicket, modalCartaPorte, modalSolicitarFactura, modalDatosFiscales, mostrarComparador, mostrarCotizaciones, mostrarPlantillas, mostrarFormulario, toastNotif.length, toastPausado, mostrarNotificaciones]); // eslint-disable-line


  // Auto-cerrar solo alertas simples (alerta_*) no persistentes después de 3.5s
  useEffect(() => {
    if (toastNotif.length === 0 || toastPausado) return;
    const notif = toastNotif[0];
    if (notif?.persistente) return;
    if (!notif?.tipo?.startsWith('alerta_')) return;
    const timer = setTimeout(() => setToastNotif(q => q.slice(1)), 3500);
    return () => clearTimeout(timer);
  }, [toastNotif.length, toastPausado]); // eslint-disable-line

  const abrirNotificaciones = () => {
    setMostrarNotificaciones(true);
    marcarNotificacionesLeidas(usuario?.id, 'cliente');
    apiMarcarLeidas().catch(() => {});
    dispatch(s => ({
      ...s,
      notificaciones: (s.notificaciones || []).map(n =>
        (n.destinatarioId === usuario?.id) ? { ...n, leida: true } : n
      )
    }));
  };

  // ========== RECORDATORIOS DE CONFIRMACIÓN DE ENTREGA ==========
  useEffect(() => {
    const INTERVALO_MS = 3 * 60 * 1000; // cada 3 minutos
    const verificar = () => {
      const s = getStore();
      const pendientesViaje = (s.viajes || []).filter(v =>
        v.clienteId === usuario.id && v.status === 'completada' && !v.clienteConfirmo
      );
      const pendientesRetorno = (s.retornosVacios || []).flatMap(r =>
        (r.ofertas || []).filter(o =>
          o.clienteId === usuario.id && o.pagado &&
          r.status !== 'entrega_confirmada'
        ).map(o => ({ retorno: r, oferta: o }))
      ).filter(({ retorno }) => {
        const orden = (s.ordenesChofer || []).find(oc => oc.retornoId === retorno.id);
        return orden?.status === 'completada';
      });
      if (pendientesViaje.length > 0 || pendientesRetorno.length > 0) {
        const total = pendientesViaje.length + pendientesRetorno.length;
        const primerViajeId = pendientesViaje[0]?.id || null;
        const primerRetornoId = pendientesRetorno[0]?.retorno?.id || null;
        setToastNotif(q => [...q, {
          tipo: 'alerta_warning', titulo: '⚠ Atención',
          mensaje: `⏳ Tienes ${total} entrega${total > 1 ? 's' : ''} pendiente${total > 1 ? 's' : ''} de confirmar. ¡Confirma para liberar los fondos al transportista!`,
          persistente: true,
          navegar: primerRetornoId ? 'fletes' : 'viajes',
          expandViajeId: primerViajeId,
          expandRetornoId: primerRetornoId,
        }]);
      }
    };
    verificar(); // revisar al montar
    const id = setInterval(verificar, INTERVALO_MS);
    return () => clearInterval(id);
  }, [usuario.id]); // eslint-disable-line

  // ========== RECORDATORIO: RETORNO ACEPTADO SIN PAGAR ==========
  useEffect(() => {
    const _ssKey = `choyero_rec_cliente_${usuario?.id}`;
    const checkPago = () => {
      const s = getStore();
      const ahora = Date.now();
      const last = JSON.parse(sessionStorage.getItem(_ssKey) || '{}');
      // Solo mostrar si no hay ya una notificación persistente activa (ej. confirmar entrega)
      const sinPagar = (s.retornosVacios || []).filter(r => {
        const miOferta = (r.ofertas || []).find(o => o.clienteId === usuario?.id && o.status === 'aceptada' && !o.pagado);
        return !!miOferta;
      });
      if (sinPagar.length > 0 && (!last.pago || ahora - last.pago > 5 * 60 * 1000)) {
        last.pago = ahora;
        sessionStorage.setItem(_ssKey, JSON.stringify(last));
        setToastNotif(q => [...q, {
          tipo: 'alerta_warning', titulo: '⚠ Atención',
          mensaje: `💳 Tienes ${sinPagar.length} flete(s) de retorno aceptado(s) pendiente(s) de pago. ¡Paga ahora para reservar tu espacio!`,
          persistente: true, navegar: 'fletes'
        }]);
      }
    };
    let interval;
    const timer = setTimeout(() => {
      checkPago();
      interval = setInterval(checkPago, 5 * 60 * 1000);
    }, 2 * 60 * 1000);
    return () => { clearTimeout(timer); if (interval) clearInterval(interval); };
  }, [usuario?.id]); // eslint-disable-line

  // ========== DATOS DESDE STORE COMPARTIDO ==========
  // Solicitudes de este cliente — normaliza campos para que el JSX existente funcione
  const misSolicitudes = store.solicitudes
    .filter(s => {
      if (s.clienteId !== usuario.id) return false;
      if (['aceptada', 'en_curso', 'completada', 'completado', 'cancelada', 'cancelado', 'expirada'].includes(s.status)) return false;
      // Excluir si la fecha de recogida ya pasó
      const fechaRecogida = s.fechaRecogida || s.fecha || '';
      if (fechaRecogida && fechaRecogida < new Date().toISOString().slice(0, 10)) return false;
      // Excluir si la fecha de expiración ya pasó (red de seguridad frontend)
      if (s.fechaExpiracion && new Date(s.fechaExpiracion) < new Date()) return false;
      return true;
    })
    .map(s => {
      const cotizacionesDeSol = store.cotizaciones
        .filter(c => c.solicitudId === s.id)
        .sort((a, b) => new Date(b.fechaCreacion || 0) - new Date(a.fechaCreacion || 0));
      const precios = cotizacionesDeSol.map(c => c.precio).filter(Boolean);
      return {
        ...s,
        cotizaciones: cotizacionesDeSol.length,                          // campo que usa el JSX
        mejorOferta: precios.length > 0 ? Math.min(...precios) : null   // campo que usa el JSX
      };
    })
    .sort((a, b) => new Date(b.fechaCreacion || 0) - new Date(a.fechaCreacion || 0));
  const setMisSolicitudes = () => {}; // No-op (el store maneja el estado)

  // Auto-expandir primera solicitud al entrar a la sección por primera vez
  useEffect(() => {
    if (seccion !== 'solicitudes' || misSolicitudes.length === 0 || expandedSolicitud) return;
    const key = `choyero_first_sol_expanded_${usuario?.id}`;
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, '1');
    setExpandedSolicitud(misSolicitudes[0].id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seccion, misSolicitudes.length]);

  // Viajes activos: todo excepto confirmados por el cliente (esos van al historial)
  const yaCalificadoPorCliente = (viajeId) =>
    (store.calificaciones || []).some(c => c.viajeId === viajeId && c.autorRol === 'cliente');
  const viajesActivosStore = (store.viajes || []).filter(v =>
    v.clienteId === usuario.id &&
    v.status !== 'entrega_confirmada' && v.status !== 'confirmado'
  );

  // Cotizaciones por solicitud desde el store
  const cotizacionesPorSolicitud_store = {};
  store.cotizaciones.forEach(c => {
    if (!cotizacionesPorSolicitud_store[c.solicitudId]) cotizacionesPorSolicitud_store[c.solicitudId] = [];
    cotizacionesPorSolicitud_store[c.solicitudId].push({
      ...c,
      transportista: c.empresa?.nombre || c.transportistaNombre,
      calificacion: c.transportista?.calificacion ?? c.calificacion,
      viajesCompletados: c.transportista?.viajesCompletados ?? c.viajesCompletados,
      cancelacionesTransportista: c.transportista?.cancelacionesComoTransportista ?? 0,
      ultimaCancelacionTransportista: c.transportista?.ultimaCancelacionTransportista ?? null,
    });
  });

  // (bloque eliminado — cotizaciones estáticas de demo removidas)
  const cotizacionesPorSolicitud_static = {
    'SOL-UNUSED': [
      { 
        id: 'COT-001', 
        transportista: 'Transportes Veloz SA',
        logo: '🚛',
        precio: 4200,
        tiempoEntrega: '6-8 horas',
        calificacion: 4.8,
        viajesCompletados: 234,
        telefono: '664-123-4567',
        unidadOfrecida: 'Torton 2022',
        seguro: true,
        rastreoGPS: true,
        comentario: 'Disponibilidad inmediata. Chofer con 10 años de experiencia.'
      },
      { 
        id: 'COT-002', 
        transportista: 'Carga Segura BC',
        logo: '🚚',
        precio: 4500,
        tiempoEntrega: '5-6 horas',
        calificacion: 4.9,
        viajesCompletados: 456,
        telefono: '664-234-5678',
        unidadOfrecida: 'Torton 2023',
        seguro: true,
        rastreoGPS: true,
        comentario: 'Servicio express disponible. Incluye seguro premium.'
      },
      { 
        id: 'COT-003', 
        transportista: 'Fletes del Norte',
        logo: '📦',
        precio: 3900,
        tiempoEntrega: '8-10 horas',
        calificacion: 4.5,
        viajesCompletados: 189,
        telefono: '664-345-6789',
        unidadOfrecida: 'Torton 2021',
        seguro: true,
        rastreoGPS: false,
        comentario: 'Mejor precio garantizado.'
      },
      { 
        id: 'COT-004', 
        transportista: 'Logística Peninsular',
        logo: '🏆',
        precio: 4800,
        tiempoEntrega: '4-5 horas',
        calificacion: 4.7,
        viajesCompletados: 312,
        telefono: '664-456-7890',
        unidadOfrecida: 'Torton 2024',
        seguro: true,
        rastreoGPS: true,
        comentario: 'Unidad nueva, aire acondicionado, servicio premium.'
      }
    ],
    'SOL-002': [
      { 
        id: 'COT-005', 
        transportista: 'Refrigerados Express',
        logo: '❄️',
        precio: 5800,
        tiempoEntrega: '8-10 horas',
        calificacion: 4.9,
        viajesCompletados: 567,
        telefono: '686-123-4567',
        unidadOfrecida: 'Trailer Refrigerado 2023',
        seguro: true,
        rastreoGPS: true,
        comentario: 'Especialistas en cadena de frío. Temperatura controlada.'
      },
      { 
        id: 'COT-006', 
        transportista: 'Transportes Veloz SA',
        logo: '🚛',
        precio: 6200,
        tiempoEntrega: '7-8 horas',
        calificacion: 4.8,
        viajesCompletados: 234,
        telefono: '664-123-4567',
        unidadOfrecida: 'Trailer Refrigerado 2022',
        seguro: true,
        rastreoGPS: true,
        comentario: 'Unidad con termógrafo certificado.'
      },
      { 
        id: 'COT-007', 
        transportista: 'Fríos del Pacífico',
        logo: '🧊',
        precio: 5500,
        tiempoEntrega: '10-12 horas',
        calificacion: 4.6,
        viajesCompletados: 145,
        telefono: '686-234-5678',
        unidadOfrecida: 'Trailer Refrigerado 2021',
        seguro: true,
        rastreoGPS: true,
        comentario: 'Precio económico, servicio confiable.'
      }
    ],
    'SOL-003': [
      { 
        id: 'COT-008', 
        transportista: 'Mudanzas BCS',
        logo: '🏠',
        precio: 2800,
        tiempoEntrega: '3-4 horas',
        calificacion: 4.7,
        viajesCompletados: 89,
        telefono: '612-123-4567',
        unidadOfrecida: 'Rabon 2022',
        seguro: true,
        rastreoGPS: false,
        comentario: 'Especialistas en muebles. Incluye 2 ayudantes.'
      },
      { 
        id: 'COT-009', 
        transportista: 'Fletes Los Cabos',
        logo: '🌴',
        precio: 3200,
        tiempoEntrega: '2-3 horas',
        calificacion: 4.8,
        viajesCompletados: 203,
        telefono: '624-234-5678',
        unidadOfrecida: 'Rabon 2023',
        seguro: true,
        rastreoGPS: true,
        comentario: 'Servicio express. Entrega garantizada.'
      },
      { 
        id: 'COT-010', 
        transportista: 'Carga Express Sur',
        logo: '⚡',
        precio: 2600,
        tiempoEntrega: '4-5 horas',
        calificacion: 4.4,
        viajesCompletados: 67,
        telefono: '612-345-6789',
        unidadOfrecida: 'Rabon 2020',
        seguro: false,
        rastreoGPS: false,
        comentario: 'El mejor precio de la zona.'
      }
    ]
  };

  // Helper: obtiene el logo actual de la empresa (prioriza el logo vigente sobre el guardado en la cotización)
  const getLogoEmpresa = (cot) => {
    const empresa = (store.empresasActivas || []).find(e => e.id === cot.empresaId);
    return empresa?.logo || cot.empresa?.logo || cot.logo || '🚛';
  };

  // Helper: datos vivos de la empresa para una cotización (calificación y viajes actualizados)
  const getEmpresaViva = (cot) =>
    (store.empresasActivas || []).find(e => e.id === cot.empresaId) || null;

  // Merge: cotizaciones reales del store tienen prioridad sobre las estáticas
  const cotizacionesPorSolicitud = { ...cotizacionesPorSolicitud_static };
  Object.keys(cotizacionesPorSolicitud_store).forEach(solicitudId => {
    cotizacionesPorSolicitud[solicitudId] = [
      ...(cotizacionesPorSolicitud_store[solicitudId] || []),
      ...((cotizacionesPorSolicitud_static[solicitudId] || []).filter(
        c => !cotizacionesPorSolicitud_store[solicitudId]?.find(sc => sc.id === c.id)
      ))
    ].sort((a, b) => {
      const aEmp = (store.empresasActivas || []).find(e => e.id === a.empresaId || e.id === a.transportistaId);
      const bEmp = (store.empresasActivas || []).find(e => e.id === b.empresaId || e.id === b.transportistaId);
      const aIsPro = aEmp?.plan === 'pro' ? 0 : 1;
      const bIsPro = bEmp?.plan === 'pro' ? 0 : 1;
      if (aIsPro !== bIsPro) return aIsPro - bIsPro;
      return new Date(b.fechaCreacion || 0) - new Date(a.fechaCreacion || 0);
    });
  });

  // Viajes activos: combinar los del store + uno de demo si el store está vacío
  const viajesActivos = viajesActivosStore.sort((a, b) => new Date(b.creadoEn || 0) - new Date(a.creadoEn || 0));
  const setViajesActivos = () => {}; // Manejado por el store

  const VIAJE_COMPLETADO = s => ['confirmado', 'entrega_confirmada'].includes(s);

  // Historial: viajes completados/cancelados + solicitudes canceladas sin viaje
  const historialFromStore = [
    ...(store.viajes || [])
      .filter(v => (v.clienteId === usuario?.id) &&
        (v.clienteConfirmo === true || VIAJE_COMPLETADO(v.status) ||
         ['cancelado', 'cancelado_admin'].includes(v.status)))
      .map(v => {
        const calif = (store.calificaciones || []).find(c => c.viajeId === v.id && c.autorRol === 'cliente');
        const solicitud = (store.solicitudes || []).find(s => s.id === v.solicitudId);
        const esCancelado = ['cancelado', 'cancelado_admin'].includes(v.status);
        return {
          id: v.id,
          fecha: (v.fechaCompletada || v.fechaCancelacion || v.creadoEn || '').split('T')[0],
          ruta: `${v.origen} → ${v.destino}`,
          transportista: v.transportistaNombre || v.transportista || '—',
          transportistaId: v.transportistaId,
          choferId: v.choferId,
          clienteConfirmo: v.clienteConfirmo,
          costo: v.costoFinal || v.precio || v.costo || 0,
          status: v.status,
          calificacion: calif ? calif.estrellas : null,
          solicitudData: solicitud || null,
          tipo: 'flete',
          esCancelado,
          motivoCancelacion: v.motivoCancelacion || v.motivoCancelacionAdmin || null,
        };
      }),
    // Solicitudes canceladas o vencidas sin viaje asociado
    ...(store.solicitudes || [])
      .filter(s => s.clienteId === usuario?.id &&
        ['cancelada', 'expirada'].includes(s.status) &&
        !(store.viajes || []).some(v => v.solicitudId === s.id))
      .map(s => {
        const esVencida = s.status === 'expirada';
        return {
          id: s.id,
          folio: s.folio,
          fecha: (s.creadoEn || '').split('T')[0],
          ruta: `${s.origen} → ${s.destino}`,
          transportista: '—',
          costo: 0,
          status: s.status,
          calificacion: null,
          solicitudData: s,
          tipo: esVencida ? 'solicitud_vencida' : 'solicitud_cancelada',
          esCancelado: true,
          motivoCancelacion: s.motivoCancelacion || null,
          esVencida,
        };
      }),
    ...(store.retornosVacios || [])
      .filter(r => r.status === 'entrega_confirmada' || r.status === 'completado')
      .flatMap(r => {
        const miOferta = (r.ofertas || []).find(o => o.clienteId === usuario?.id && o.status === 'aceptada');
        if (!miOferta) return [];
        // Usar el ID del viaje generado por el retorno, no el ID del retorno
        const viajeDelRetorno = (store.viajes || []).find(v => v.retornoId === r.id && v.clienteId === usuario?.id);
        return [{
          id: viajeDelRetorno?.id || r.id,
          fecha: (miOferta.fechaPago || r.fechaPublicacion || '').split('T')[0],
          ruta: `${(r.origenActual || r.origen)} → ${r.destino}`,
          transportista: r.empresaNombre || '—',
          transportistaId: r.transportistaId,
          costo: miOferta.monto || 0,
          status: 'entrega_confirmada',
          calificacion: null,
          solicitudData: null,
          tipo: 'retorno'
        }];
      })
  ].sort((a, b) => new Date(b.fecha || 0) - new Date(a.fecha || 0));

  const historial = historialFromStore;

  // Marcar facturas subidas como vistas al entrar a la sección — antes se hacía inline en el
  // cuerpo del render de la sección 'facturas' (setState + localStorage.setItem durante el
  // render, un side-effect fuera de un useEffect), movido aquí para no violar la pureza del
  // render (revisión frontend 2026-08-22).
  useEffect(() => {
    if (seccion !== 'facturas') return;
    const viajesConFactura = (store.viajes || []).filter(v => v.solicitudFactura);
    const subidaIds = viajesConFactura.filter(v => v.solicitudFactura.status === 'subida').map(v => v.solicitudFactura.id);
    if (subidaIds.some(id => !facturasClienteVistas.has(id))) {
      const nuevas = new Set([...facturasClienteVistas, ...subidaIds]);
      setFacturasClienteVistas(nuevas);
      try { localStorage.setItem(_facturasVistasKey, JSON.stringify([...nuevas])); } catch {}
    }
  }, [seccion, store.viajes, facturasClienteVistas, _facturasVistasKey]); // eslint-disable-line

  // ========== FUNCIONES AUXILIARES ==========
  const getStatusColor = (status) => {
    const colors = {
      'abierta': 'bg-blue-100 text-blue-800',
      'en_cotizacion': 'bg-blue-100 text-blue-800',
      'cotizando': 'bg-blue-100 text-blue-800',
      'aceptada': 'bg-purple-100 text-purple-800',
      'activo': 'bg-purple-100 text-purple-800',
      'en_curso': 'bg-indigo-100 text-indigo-800',
      'asignado': 'bg-purple-100 text-purple-800',
      'asignada': 'bg-purple-100 text-purple-800',
      'en_proceso': 'bg-indigo-100 text-indigo-800',
      'en_camino_recogida': 'bg-sky-100 text-sky-800',
      'cargando': 'bg-yellow-100 text-yellow-800',
      'en_ruta': 'bg-orange-100 text-orange-800',
      'llegada_destino': 'bg-teal-100 text-teal-800',
      'descargando': 'bg-amber-100 text-amber-800',
      'completado': 'bg-green-100 text-green-800',
      'completada': 'bg-green-100 text-green-800',
      'entrega_confirmada': 'bg-emerald-100 text-emerald-800',
      'confirmado': 'bg-emerald-100 text-emerald-800',
      'cancelado': 'bg-red-100 text-red-800',
      'cancelada': 'bg-red-100 text-red-800',
      'expirada': 'bg-red-100 text-red-700'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const getStatusText = (status) => {
    const texts = {
      'abierta': 'En Cotización',
      'en_cotizacion': 'En Cotización',
      'cotizando': 'En Cotización',
      'pendiente_pago': 'Pendiente de Pago',
      'aceptada': 'Pago Realizado',
      'activo': 'Pago Realizado',
      'en_curso': 'En Curso',
      'asignado': 'Asignado',
      'asignada': 'Asignado',
      'en_proceso': 'En Proceso',
      'en_camino_recogida': 'Chofer en Camino',
      'cargando': 'Cargando',
      'en_ruta': 'En Ruta',
      'llegada_destino': 'En Destino',
      'descargando': 'Descargando',
      'completado': 'Completado',
      'completada': 'Completado',
      'entrega_confirmada': 'Entrega Confirmada',
      'confirmado': 'Entrega Confirmada',
      'cancelado': 'Cancelado',
      'cancelada': 'Cancelado',
      'expirada': '⏰ Expirada'
    };
    return texts[status] || status;
  };

  // Mostrar notificación temporal
  const mostrarNotificacion = (mensaje, tipo = 'success') => {
    const titulos = { success: '✓ Listo', warning: '⚠ Atención', error: '✗ Error' };
    setToastNotif(q => [...q, { tipo: `alerta_${tipo}`, titulo: titulos[tipo] || 'Aviso', mensaje, persistente: false }]);
  };

  // ========== FUNCIONES DE ACCIONES ==========
  
  // Abrir modal de cotizaciones para una solicitud
  const verCotizaciones = (solicitud) => {
    setSolicitudSeleccionada(solicitud);
    setCotizacionesParaComparar([]);
    setMostrarCotizaciones(true);
  };

  // Agregar/quitar cotización del comparador
  const toggleComparar = (cotizacion) => {
    if (cotizacionesParaComparar.find(c => c.id === cotizacion.id)) {
      setCotizacionesParaComparar(cotizacionesParaComparar.filter(c => c.id !== cotizacion.id));
    } else if (cotizacionesParaComparar.length < 3) {
      setCotizacionesParaComparar([...cotizacionesParaComparar, cotizacion]);
    } else {
      mostrarNotificacion('Solo puedes comparar hasta 3 cotizaciones', 'warning');
    }
  };

  // Abrir comparador lado a lado
  const abrirComparador = () => {
    if (cotizacionesParaComparar.length < 2) {
      mostrarNotificacion('Selecciona al menos 2 cotizaciones para comparar', 'warning');
      return;
    }
    setMostrarComparador(true);
  };

  // Seleccionar ganador (mostrar confirmación)
  const seleccionarGanador = (cotizacion) => {
    setCotizacionGanadora(cotizacion);
    setMostrarConfirmacion(true);
  };

  // Confirmar selección del transportista - Abre pasarela de pago
  // Los datos fiscales se solicitan solo si el cliente quiere factura (post-pago)
  const confirmarSeleccion = () => {
    setMostrarConfirmacion(false);
    setMostrarPasarelaPago(true);
    setPagoCompletado(false);
    setProcesandoPago(false);
  };

  // Procesar pago con MercadoPago
  const procesarPago = async () => {
    setProcesandoPago(true);
    try {
      // 1. Crear el viaje en el backend
      const viaje = await apiAceptarCotizacion(cotizacionGanadora.id, { metodoPago: 'mercadopago' });
      const viajeId = viaje?.id;
      if (!viajeId) throw new Error('No se pudo crear el viaje');

      // 2. Crear preferencia de MercadoPago (o bypass)
      const resultado = await apiCrearPreferenciaMercadoPago(viajeId);

      await recargar();
      setMostrarPasarelaPago(false);
      setMostrarComparador(false);
      setMostrarCotizaciones(false);
      setSolicitudSeleccionada(null);
      setCotizacionGanadora(null);
      setCotizacionesParaComparar([]);

      // 3. Redirigir a MercadoPago (o saltar si bypass activo)
      if (!resultado.bypass) {
        // Guardar viajeId para expandirlo al regresar de MP
        try { sessionStorage.setItem('choyero_viaje_pago', viajeId); } catch (_) {}
        const url = resultado.paymentUrl || (process.env.NODE_ENV === 'production' ? resultado.initPoint : resultado.sandboxInitPoint);
        phCapture('pago_iniciado', { viajeId, monto: cotizacionGanadora?.precio });
        window.location.href = url;
      } else {
        // Bypass: cerrar modales e ir directo a Viajes Activos con el viaje expandido
        setMostrarPasarelaPago(false);
        setMostrarComparador(false);
        setMostrarCotizaciones(false);
        setSeccion('viajes');
        setExpandedViaje(viajeId);
        setTimeout(() => document.getElementById(`viaje-${viajeId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 300);
      }
    } catch (e) {
      setProcesandoPago(false);
      mostrarNotificacion('Error al iniciar el pago. Intenta de nuevo.', 'error');
    }
  };

  // Función para calificar un viaje (API + store local)
  // El backend califica al transportista Y al chofer automáticamente con la misma puntuación.
  const calificarViaje = (viajeId, estrellas, comentario) => {
    const viajeStore = store.viajes.find(v => v.id === viajeId);
    const transportistaId = mostrarCalificar?.transportistaId || viajeStore?.transportistaId || null;
    const choferUserId = mostrarCalificar?.choferId || viajeStore?.choferId || null;
    // Feedback inmediato en store local
    calificarServicio(viajeId, usuario.id, 'cliente', transportistaId, 'transportista', estrellas, comentario, choferUserId);
    setMostrarCalificar(null);
    mostrarNotificacion('¡Gracias por tu calificación! Ayuda a otros usuarios.', 'success');
    // Backend maneja el doble rating (transportista + chofer) en una sola llamada
    apiCalificar(viajeId, { puntuacion: estrellas, comentario })
      .catch(() => { mostrarNotificacion('No se pudo guardar la calificación. Intenta de nuevo más tarde.', 'error'); });
  };

  // Función para compartir en redes sociales
  const compartirEnRed = (red) => {
    const mensaje = encodeURIComponent('¡Encontré Choyero! La mejor app para cotizar fletes en Baja California. Compara precios y elige al mejor transportista. 🚛');
    const url = encodeURIComponent('https://choyero.app');
    
    const urls = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${mensaje}`,
      twitter: `https://twitter.com/intent/tweet?text=${mensaje}&url=${url}`,
      whatsapp: `https://wa.me/?text=${mensaje}%20${url}`,
    };
    
    if (urls[red]) {
      window.open(urls[red], '_blank', 'width=600,height=400');
    }
    mostrarNotificacion(`Compartiendo en ${red}...`, 'success');
  };

  // Código de referido real del backend (guardado en el usuario autenticado)
  const codigoReferido = usuario?.codigoReferido || (usuario?.id ? generarCodigoReferido(usuario.id) : null);
  const resumenReferidos = usuario?.id ? getResumenReferidos(usuario.id) : { referidos: [], totalBonos: 0 };

  // Fallback para copiar texto en contextos HTTP (red local sin HTTPS)
  const _copiarTexto = (texto) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(texto).catch(() => {
        const ta = document.createElement('textarea');
        ta.value = texto; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (_) {}
        document.body.removeChild(ta);
      });
    } else {
      const ta = document.createElement('textarea');
      ta.value = texto; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (_) {}
      document.body.removeChild(ta);
    }
  };

  // Función para copiar link de referido
  const copiarLinkReferido = (tipo) => {
    const base = window.location.origin;
    const links = {
      landing:        `${base}/?ref=${codigoReferido}`,
      cliente:        `${base}/?ref=${codigoReferido}&tipo=cliente`,
      transportista:  `${base}/?ref=${codigoReferido}&tipo=transportista`,
      referidor:      `${base}/referidos?ref=${codigoReferido}`,
    };
    _copiarTexto(links[tipo] || links.landing);
    setLinkCopiado(tipo);
    setTimeout(() => setLinkCopiado(null), 3000);
    mostrarNotificacion('¡Link copiado al portapapeles!', 'success');
  };

  // Crear nueva solicitud → escribe al store compartido
  const crearSolicitud = (e) => {
    e.preventDefault();
    if (!origenCoords) { mostrarNotificacion('Debes marcar el punto exacto de origen en el mapa.', 'error'); return; }
    if (!destinoCoords) { mostrarNotificacion('Debes marcar el punto exacto de destino en el mapa.', 'error'); return; }
    const formData = new FormData(e.target);
    const fechaSel = formData.get('fecha');
    const maxFecha = new Date(Date.now() + 15 * 86400000).toISOString().split('T')[0];
    if (fechaSel && fechaSel > maxFecha) {
      mostrarNotificacion('La fecha de recogida no puede ser mayor a 15 días a partir de hoy.', 'error');
      return;
    }
    if (!formData.get('horaRecogida')) {
      mostrarNotificacion('Debes indicar la hora desde la que estarás disponible para la recogida.', 'error');
      return;
    }
    if (!formData.get('horaFinCarga')) {
      mostrarNotificacion('Debes indicar la hora límite de llegada del camión.', 'error');
      return;
    }
    if (formData.get('horaFinCarga') <= formData.get('horaRecogida')) {
      mostrarNotificacion('La hora límite debe ser mayor a la hora de inicio.', 'error');
      return;
    }
    const payload = {
      origen: formData.get('origen'),
      destino: formData.get('destino'),
      descripcion: formData.get('carga'),
      peso: parseFloat(formData.get('peso')),
      fechaRecogida: formData.get('fecha') ? `${formData.get('fecha')}T${formData.get('horaRecogida')}` : null,
      horaFinCarga: formData.get('horaFinCarga') || null,
      fotos: fotosFormulario,
      origenCoords,
      destinoCoords,
      flujoPago: formData.get('flujoPago') || 'unico',
    };
    // Guardar como plantilla si el usuario marcó la opción
    if (formData.get('guardarPlantilla') === 'on') {
      const nombrePlantilla = formData.get('nombrePlantilla') || `${formData.get('origen')} → ${formData.get('destino')}`;
      guardarPlantillaRuta(usuario.id, {
        nombre: nombrePlantilla,
        origen: formData.get('origen'),
        destino: formData.get('destino'),
        carga: formData.get('carga'),
        peso: parseFloat(formData.get('peso')),
        tipoUnidad: formData.get('tipoUnidad') || '',
        origenCoords,
        destinoCoords
      });
    }
    // Cerrar form y dar feedback inmediato
    setFotosFormulario([]);
    setOrigenCoords(null);
    setDestinoCoords(null);
    setMostrarFormulario(false);
    setSolicitudParaRepetir(null);
    mostrarNotificacion('¡Solicitud publicada! Los transportistas comenzarán a enviar cotizaciones.', 'success');
    phCapture('solicitud_creada', { origen: payload.origen, destino: payload.destino, tipoUnidad: payload.tipoUnidad });
    // Update optimista: agregar al store local para que aparezca sin parpadeo
    storeCrearSolicitud(usuario.id, usuario.nombre, payload);
    setSeccion('solicitudes');
    // Enviar al backend en segundo plano — el polling sincronizará el ID real
    apiCrearSolicitud(payload)
      .catch(() => {
        recargar(); // limpiar solicitud optimista del store si falló
        mostrarNotificacion('Error al guardar la solicitud en el servidor. Intenta de nuevo.', 'error');
        setMostrarFormulario(true);
      });
  };

  const editarSolicitud = async (e) => {
    e.preventDefault();
    if (!origenCoords) { mostrarNotificacion('Debes marcar el punto exacto de origen en el mapa.', 'error'); return; }
    if (!destinoCoords) { mostrarNotificacion('Debes marcar el punto exacto de destino en el mapa.', 'error'); return; }
    const formData = new FormData(e.target);
    try {
      await apiEditarSolicitud(solicitudEditando.id, {
        origen: formData.get('origen'),
        destino: formData.get('destino'),
        descripcion: formData.get('carga'),
        peso: parseFloat(formData.get('peso')) || null,
        fechaRecogida: formData.get('fecha') || null,
        notas: formData.get('notas') || '',
        prioridad: formData.get('prioridad') || 'normal',
        fotos: fotosFormulario,
        origenCoords,
        destinoCoords,
      });
      recargar();
    } catch {
      mostrarNotificacion('Error al actualizar la solicitud.', 'error');
      return;
    }
    setFotosFormulario([]);
    setOrigenCoords(null);
    setDestinoCoords(null);
    setMostrarFormulario(false);
    setSolicitudEditando(null);
    mostrarNotificacion('Solicitud actualizada. Los transportistas verán los cambios.', 'success');
  };

  // ========== CÁLCULOS DE GASTO ==========
  const hoy = new Date().toISOString().slice(0, 10);
  const mesActual = new Date().toISOString().slice(0, 7);
  const viajesCompletadosCliente = (store.viajes || []).filter(v =>
    v.clienteId === usuario?.id && VIAJE_COMPLETADO(v.status)
  );
  const gastoHoy = viajesCompletadosCliente
    .filter(v => (v.fechaCompletada || v.creadoEn || '').startsWith(hoy))
    .reduce((sum, v) => sum + (v.costoFinal || v.precio || v.costo || 0), 0);
  const gastoMes = viajesCompletadosCliente
    .filter(v => (v.fechaCompletada || v.creadoEn || '').startsWith(mesActual))
    .reduce((sum, v) => sum + (v.costoFinal || v.precio || v.costo || 0), 0);
  const gastoTotalReal = viajesCompletadosCliente.reduce((sum, v) => sum + (v.costoFinal || v.precio || v.costo || 0), 0);
  const gastoTotal = gastoTotalReal > 0 ? gastoTotalReal : historial.reduce((sum, v) => sum + (v.costoFinal || v.precio || v.costo || 0), 0);

  // ========== COMPROBANTE DE ENTREGA ==========
  const generarComprobante = (viaje) => {
    const viajeCompleto = store.viajes?.find(v => v.id === viaje.id) || {};
    const evidencias = (store.notificaciones || []).filter(n => n.tipo === 'evidencia_entrega' && n.datos?.viajeId === viaje.id);
    const fotos = evidencias.map(n => n.datos?.foto).filter(Boolean);
    const numero = viaje.id || '—';
    const fecha = (viaje.fechaCompletada || viaje.creadoEn || '').split('T')[0] || new Date().toLocaleDateString('es-MX');
    const ruta = viaje.ruta || `${viaje.origen || '—'} → ${viaje.destino || '—'}`;
    const transportista = viajeCompleto.empresa?.nombre || viaje.transportista || '—';
    const costo = (viaje.costoFinal || viaje.precio || viaje.costo || 0).toLocaleString();
    const carga = viajeCompleto.solicitud?.tipoVehiculo || '—';
    const peso = viajeCompleto.solicitud?.peso ? `${viajeCompleto.solicitud.peso} tons` : '—';
    const ordenActiva = viajeCompleto.ordenesChofer?.[0];
    const chofer = ordenActiva?.choferNombre || '—';
    const unidad = ordenActiva?.unidadLabel || viajeCompleto.cotizacion?.unidadOfrecida || '—';
    const descripcion = viajeCompleto.solicitud?.descripcion || '—';
    const fotosHtml = fotos.length > 0
      ? `<div style="margin-top:20px"><p style="font-weight:bold;color:#374151;margin-bottom:8px">Evidencias de entrega:</p><div style="display:flex;gap:10px;flex-wrap:wrap">${fotos.map(f => `<img src="${f}" style="width:120px;height:90px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb" />`).join('')}</div></div>` : '';
    const win = window.open('', '_blank', 'width=700,height=900');
    if (!win) return;
    win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Comprobante ${numero}</title><style>
      body{font-family:Arial,sans-serif;margin:0;padding:32px;color:#1f2937;background:#fff}
      .header{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #f97316;padding-bottom:20px;margin-bottom:24px}
      .logo{font-size:32px;font-weight:900;color:#f97316}
      .logo span{color:#1f2937}
      .badge{background:#dcfce7;color:#166534;padding:6px 14px;border-radius:20px;font-size:13px;font-weight:bold}
      .title{font-size:22px;font-weight:bold;margin-bottom:4px}
      .subtitle{color:#6b7280;font-size:13px}
      .grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px}
      .field{background:#f9fafb;padding:12px 14px;border-radius:8px;border:1px solid #e5e7eb}
      .field-label{font-size:11px;color:#9ca3af;text-transform:uppercase;font-weight:600;margin-bottom:4px}
      .field-value{font-size:15px;font-weight:600;color:#111827}
      .total{background:linear-gradient(135deg,#f97316,#ea580c);color:white;padding:16px 20px;border-radius:12px;display:flex;justify-content:space-between;align-items:center;margin:20px 0}
      .footer{margin-top:24px;padding-top:16px;border-top:1px solid #e5e7eb;text-align:center;font-size:12px;color:#9ca3af}
      @media print{button{display:none}}
    </style></head><body>
      <div class="header">
        <div><div class="logo">Choyero<span>!</span></div><div style="color:#6b7280;font-size:12px;margin-top:4px">Marketplace Logístico · Baja California</div></div>
        <div style="text-align:right"><div class="badge">✓ Entrega Confirmada</div><div style="color:#6b7280;font-size:12px;margin-top:8px">Folio: <strong>${numero}</strong></div></div>
      </div>
      <div class="title">Comprobante de Entrega</div>
      <div class="subtitle" style="margin-bottom:24px">Fecha: ${fecha}</div>
      <div class="grid">
        <div class="field"><div class="field-label">Ruta</div><div class="field-value">${ruta}</div></div>
        <div class="field"><div class="field-label">Transportista</div><div class="field-value">${transportista}</div></div>
        <div class="field"><div class="field-label">Tipo de carga</div><div class="field-value">${carga}</div></div>
        <div class="field"><div class="field-label">Peso</div><div class="field-value">${peso}</div></div>
        <div class="field"><div class="field-label">Chofer</div><div class="field-value">${chofer}</div></div>
        <div class="field"><div class="field-label">Unidad</div><div class="field-value">${unidad}</div></div>
        <div class="field" style="grid-column:span 2"><div class="field-label">Descripción del flete</div><div class="field-value">${descripcion}</div></div>
        <div class="field"><div class="field-label">Cliente</div><div class="field-value">${usuario?.nombre || '—'}</div></div>
      </div>
      <div class="total"><span style="font-size:16px;font-weight:600">Total pagado</span><span style="font-size:26px;font-weight:900">$${costo} MXN</span></div>
      ${fotosHtml}
      <div class="footer"><p>Este documento es un comprobante de entrega generado por Choyero Marketplace Logístico.</p><p style="margin-top:4px">© ${new Date().getFullYear()} Choyero · marketplace-logistico.mx</p></div>
      <div style="text-align:center;margin-top:20px"><button onclick="window.print()" style="background:#f97316;color:white;border:none;padding:10px 28px;border-radius:8px;font-size:15px;font-weight:bold;cursor:pointer">🖨️ Imprimir / Guardar PDF</button></div>
    </body></html>`);
    win.document.close();
  };

  // ========== RETORNOS VACÍOS (fletes de oportunidad) ==========
  const _normCiudad = (c) => (c || '').toLowerCase().replace(/,\s*(bc|bcs)$/i, '').trim();
  const _ciudadClienteRaw = (usuario?.ciudad || usuario?.direccion || '').toLowerCase();
  const retornosDisponibles = (store.retornosVacios || []).filter(r => {
    // Retornos abiertos: solo clientes en ruta pueden ver y ofertar
    if (['disponible', 'negociando'].includes(r.status)) {
      if (new Date(r.expiresAt || r.fechaExpiracion) < new Date()) return false;
      // Filtrar por ciudad del cliente — acepta ciudad o extrae de direccion
      if (_ciudadClienteRaw) {
        const rutaCompleta = [(r.origenActual || r.origen), ...(r.ciudadesEnRuta?.length ? r.ciudadesEnRuta : calcCiudadesEnRuta((r.origenActual || r.origen), r.destino)), r.destino];
        const enRuta = rutaCompleta.some(c => _ciudadClienteRaw.includes(_normCiudad(c)));
        if (!enRuta) return false;
      }
      return true;
    }
    // Retorno aceptado: solo lo ve el cliente cuya oferta fue aceptada
    if (r.status === 'aceptado') {
      const miOferta = (r.ofertas || []).find(o => o.clienteId === usuario?.id && o.status === 'aceptada');
      return !!miOferta;
    }
    // entrega_confirmada → ya va al historial, no a fletes activos
    return false;
  }).sort((a, b) => new Date(b.fechaPublicacion || 0) - new Date(a.fechaPublicacion || 0));
  const [ofertaRetornoId, setOfertaRetornoId] = useState(null);
  const [formOferta, setFormOferta] = useState({ monto: '', mensaje: '', ciudadCliente: '', destinoEntrega: '', peso: '', volumen: '', fotos: [], origenCoords: null, destinoCoords: null });
  const [retornoPagar, setRetornoPagar] = useState(null); // { retorno, oferta } — activa pasarela
  const [procesandoPagoRetorno, setProcesandoPagoRetorno] = useState(false);
  const [pagoRetornoCompletado, setPagoRetornoCompletado] = useState(false);
  const [formDirecciones, setFormDirecciones] = useState({ retornoId: null, ofertaId: null, origenDir: '', destinoDir: '' }); // paso de direcciones post-aceptación

  const formatTiempoRestante = (expiraDate) => {
    const mins = Math.max(0, Math.round((expiraDate - Date.now()) / 60000));
    if (mins >= 1440) return expiraDate.toLocaleDateString('es-MX', { day: 'numeric', month: 'short' });
    if (mins >= 60) { const h = Math.floor(mins / 60); const m = mins % 60; return m > 0 ? `${h}h ${m}m` : `${h}h`; }
    return `${mins}m`;
  };

  const precioConDescuento = (ret) => {
    const base = ret.precioBase ?? ret.precio ?? 0;
    const expira = ret.fechaExpiracion || ret.expiresAt;
    const publicado = ret.fechaPublicacion || ret.creadoEn;
    const total = new Date(expira) - new Date(publicado);
    const transcurrido = Date.now() - new Date(publicado);
    const pct = total > 0 ? transcurrido / total : 0;
    if (pct > 0.66) return Math.round(base * 0.80);
    if (pct > 0.33) return Math.round(base * 0.90);
    return base;
  };

  // ========== MENÚ DE NAVEGACIÓN ==========
  const esMoral = usuario?.tipoPersona === 'moral';

  // Badge Red Referidos: comisiones disponibles acreditadas desde la última vez que el usuario visitó la sección
  const _redSeenKey = `choyero_red_seen_${usuario?.id || 'guest'}`;
  const _redLastSeen = (() => { try { return sessionStorage.getItem(_redSeenKey) || '0'; } catch { return '0'; } })();
  const _comisionesNuevas = !esMoral
    ? (store.comisionesRed || []).filter(c =>
        c.userId === usuario?.id &&
        c.status === 'disponible' &&
        c.fecha > _redLastSeen
      ).length
    : 0;

  const menu = [
    { id: 'dashboard', label: 'Dashboard', icon: Package },
    { id: 'solicitudes', label: 'Mis Solicitudes', icon: FileText },
    { id: 'viajes', label: 'Viajes Activos', icon: Truck },
    { id: 'fletes', label: 'Fletes Retorno', icon: RotateCcw, badge: retornosDisponibles.filter(r => ['disponible','negociando'].includes(r.status)).length || undefined },
    { id: 'historial', label: 'Historial', icon: Clock },
    { id: 'actividad', label: 'Mi Actividad', icon: BarChart3 },
    { id: 'pagos', label: 'Mis Pagos', icon: CreditCard },
    { id: 'facturas', label: 'Mis Facturas', icon: FileCheck, badge: (store.viajes || []).filter(v => v.solicitudFactura?.status === 'subida' && !facturasClienteVistas.has(v.solicitudFactura.id)).length || undefined },
...((store.usuarioPerfil?.esReferidor ?? usuario?.esReferidor) ? [{ id: 'compartir', label: 'Prog. Referidos', icon: Gift, badge: _comisionesNuevas || undefined }] : []),
    { id: 'perfil', label: 'Mi Perfil', icon: User }
  ];

  // ========== COMPONENTES DE MODALES ==========

  // Modal: Formulario de Nueva Solicitud
  // Modal: Ver Cotizaciones de una Solicitud
  const ModalCotizaciones = () => {
    const cotizaciones = cotizacionesPorSolicitud[solicitudSeleccionada?.id] || [];
    
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
        <div className="bg-white shadow-2xl rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            {/* Header */}
            <div className="flex justify-between items-start mb-6">
              <div>
                <h3 className="text-2xl font-bold text-gray-800">Cotizaciones Recibidas</h3>
                <p className="text-gray-400">
                  Solicitud {solicitudSeleccionada?.id} • {solicitudSeleccionada?.origen} → {solicitudSeleccionada?.destino}
                </p>
              </div>
              <button onClick={() => setMostrarCotizaciones(false)} className="text-gray-400 hover:text-gray-600 p-2">
                <X size={24} />
              </button>
            </div>

            {/* Barra de comparación */}
            {cotizacionesParaComparar.length > 0 && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 flex justify-between items-center">
                <div className="flex items-center space-x-2">
                  <Scale size={20} className="text-blue-600" />
                  <span className="text-blue-800 font-medium">
                    {cotizacionesParaComparar.length} cotización(es) seleccionada(s) para comparar
                  </span>
                </div>
                <button 
                  onClick={abrirComparador}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
                >
                  Comparar Lado a Lado
                </button>
              </div>
            )}

            {/* Lista de Cotizaciones */}
            <div className="space-y-4">
              {cotizaciones.map((cot, index) => (
                <div 
                  key={cot.id} 
                  className={`border-2 rounded-xl p-5 transition-all ${
                    cotizacionesParaComparar.find(c => c.id === cot.id)
                      ? 'border-blue-500 bg-blue-50'
                      : cot.empresa?.plan === 'pro'
                      ? 'border-yellow-400 bg-gradient-to-br from-yellow-50/40 to-orange-50/30 hover:border-yellow-500'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  {/* ── Cabecera: logo + info empresa + precio ── */}
                  <div className="flex justify-between items-start">
                    <div className="flex items-start space-x-4">
                      {/* Logo + avatar transportista */}
                      <div className="relative flex-shrink-0">
                        <div className="w-14 h-14 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center">
                          {(() => { const logo = getLogoEmpresa(cot); return ((logo?.startsWith('data:') || logo?.startsWith('http')) || logo?.startsWith('http'))
                            ? <img src={logo} alt="logo" className="w-full h-full object-cover" />
                            : <span className="text-3xl">{logo}</span>; })()}
                        </div>
                        {cot.transportista?.avatar && (
                          <img src={cot.transportista.avatar} alt="transportista" className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full object-cover border-2 border-white shadow" />
                        )}
                      </div>
                      {/* Nombre + rating + dirección */}
                      <div>
                        <div className="flex items-center gap-2 flex-wrap">
                          <h4 className="font-bold text-lg text-gray-800">{cot.transportista}</h4>
                          {cot.empresa?.plan === 'pro' && (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold bg-gradient-to-r from-yellow-400 to-orange-400 text-white shadow-sm">★ PRO</span>
                          )}
                          {cot.empresa?.esMiembroFundador && (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold bg-gradient-to-r from-purple-500 to-indigo-500 text-white shadow-sm">🏅 Fundador</span>
                          )}
                        </div>
                        {/* Rating + viajes + cancelaciones */}
                        {(() => {
                          const ev = getEmpresaViva(cot);
                          const califApi = cot.empresa?.usuarios?.[0]?.calificacion;
                          const viajesApi = cot.empresa?.usuarios?.[0]?.viajesCompletados;
                          const calif = califApi ?? ev?.calificacion ?? cot.calificacion;
                          const viajes = viajesApi ?? ev?.viajesCompletados ?? cot.viajesCompletados;
                          const SEIS_MESES_MS = 6 * 30 * 24 * 60 * 60 * 1000;
                          const ultima = cot.ultimaCancelacionTransportista;
                          const expirado = ultima && (Date.now() - new Date(ultima).getTime()) > SEIS_MESES_MS;
                          const cancelaciones = expirado ? 0 : (cot.cancelacionesTransportista ?? 0);
                          const tieneViajes = viajes != null && viajes > 0;
                          const tieneCalif = calif != null && calif > 0 && tieneViajes;
                          return (
                            <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600 mt-0.5">
                              {tieneCalif && (
                                <span className="flex items-center font-semibold text-gray-800">
                                  <Star size={14} className="text-yellow-400 mr-1" fill="currentColor" />
                                  {typeof calif === 'number' ? calif.toFixed(1) : calif}
                                </span>
                              )}
                              {tieneViajes && <><span className="text-gray-600">•</span><span>{viajes} viajes</span></>}
                              {cancelaciones > 0 && (
                                <span title={`${cancelaciones} cancelación(es) de viaje en los últimos 6 meses`}
                                  className="text-xs px-1.5 py-0.5 bg-red-100 text-red-600 rounded-full font-semibold">
                                  ❌ {cancelaciones}
                                </span>
                              )}
                            </div>
                          );
                        })()}
                        {/* Dirección de la empresa */}
                        {(cot.empresa?.ciudad || cot.empresa?.estado) && (
                          <p className="text-xs text-gray-500 mt-1 flex items-center gap-1">
                            <MapPin size={11} className="flex-shrink-0 text-gray-400" />
                            {[cot.empresa.ciudad, cot.empresa.estado].filter(Boolean).join(', ')}
                          </p>
                        )}
                        {/* Flotilla PRO + Insignias */}
                        <div className="flex flex-wrap gap-1 mt-1.5">
                          {cot.empresa?.plan === 'pro' && cot.empresa?.flota > 0 && (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-orange-50 text-orange-700 border border-orange-200">
                              🚛 Flotilla: {cot.empresa.flota} unidades
                            </span>
                          )}
                          {(cot.empresa?.insigniasManuales || (store.empresasActivas || []).find(e => e.id === cot.empresaId)?.insigniasManuales || [])
                            .map(id => CATALOGO_INSIGNIAS.find(b => b.id === id)).filter(Boolean)
                            .map(i => (
                              <span key={i.id} title={i.desc} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${i.color}`}>
                                {i.emoji} {i.label}
                              </span>
                            ))
                          }
                        </div>
                      {/* ── Perfil de confianza ── */}
                      {(() => {
                        const viajes = cot.transportista?.viajesCompletados ?? 0;
                        const cancelaciones = (() => {
                          const SEIS_MESES_MS = 6 * 30 * 24 * 60 * 60 * 1000;
                          const ultima = cot.transportista?.ultimaCancelacionTransportista;
                          const expirado = ultima && (Date.now() - new Date(ultima).getTime()) > SEIS_MESES_MS;
                          return expirado ? 0 : (cot.transportista?.cancelacionesComoTransportista ?? 0);
                        })();
                        const total = viajes + cancelaciones;
                        const tasaCompletacion = total > 0 ? Math.round(viajes / total * 100) : null;
                        const responseMs = cot.creadoEn && solicitudSeleccionada?.creadoEn
                          ? new Date(cot.creadoEn) - new Date(solicitudSeleccionada.creadoEn)
                          : null;
                        const responseHrs = responseMs != null ? Math.max(0, Math.round(responseMs / 3600000)) : null;
                        const mesesPlataforma = cot.empresa?.creadoEn
                          ? Math.floor((Date.now() - new Date(cot.empresa.creadoEn)) / (30.5 * 24 * 3600 * 1000))
                          : null;
                        const ninguno = tasaCompletacion == null && responseHrs == null && mesesPlataforma == null;
                        if (ninguno) return null;
                        return (
                          <div className="flex flex-wrap gap-2 mt-2">
                            {tasaCompletacion != null && (
                              <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${tasaCompletacion >= 90 ? 'bg-green-100 text-green-700' : tasaCompletacion >= 70 ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-600'}`}>
                                ✅ {tasaCompletacion}% completación
                              </span>
                            )}
                            {responseHrs != null && (
                              <span className="text-xs px-2 py-0.5 rounded-full font-semibold bg-blue-50 text-blue-600">
                                ⚡ Respondió en {responseHrs < 1 ? 'menos de 1h' : `${responseHrs}h`}
                              </span>
                            )}
                            {mesesPlataforma != null && (
                              <span className="text-xs px-2 py-0.5 rounded-full font-semibold bg-gray-100 text-gray-600">
                                📅 {mesesPlataforma < 1 ? 'Nuevo' : mesesPlataforma < 12 ? `${mesesPlataforma} mes${mesesPlataforma !== 1 ? 'es' : ''}` : `${Math.floor(mesesPlataforma / 12)} año${Math.floor(mesesPlataforma / 12) !== 1 ? 's' : ''}`} en plataforma
                              </span>
                            )}
                          </div>
                        );
                      })()}

                      {/* Opiniones de clientes — acordeón colapsable */}
                      {cot.transportistaId && (() => {
                        const tid = cot.transportistaId;
                        if (califTransCache[tid] === undefined) {
                          setTimeout(() => {
                            setCalifTransCache(prev => {
                              if (prev[tid] !== undefined) return prev;
                              apiGetCalificacionesUsuario(tid)
                                .then(cals => setCalifTransCache(p => ({ ...p, [tid]: cals || [] })))
                                .catch(() => setCalifTransCache(p => ({ ...p, [tid]: [] })));
                              return { ...prev, [tid]: null };
                            });
                          }, 0);
                          return null;
                        }
                        const cals = califTransCache[tid];
                        if (!cals || cals.length === 0) return null;
                        const promedio = (cals.reduce((s, c) => s + c.puntuacion, 0) / cals.length).toFixed(1);
                        const expandido = !!opinExpanded[tid];
                        return (
                          <div className="mt-3 border border-blue-200 rounded-xl overflow-hidden">
                            {/* Cinta clickeable */}
                            <button
                              type="button"
                              onClick={() => setOpinExpanded(prev => ({ ...prev, [tid]: !prev[tid] }))}
                              className="w-full flex items-center justify-between px-4 py-2.5 bg-blue-50 hover:bg-blue-100 transition"
                            >
                              <div className="flex items-center gap-2">
                                <span className="text-sm">💬</span>
                                <span className="text-xs font-semibold text-blue-700">{cals.length} opinión{cals.length !== 1 ? 'es' : ''} de clientes</span>
                                <div className="flex items-center gap-0.5">
                                  {[1,2,3,4,5].map(s => (
                                    <Star key={s} size={11} className={s <= Math.round(parseFloat(promedio)) ? 'text-yellow-400' : 'text-gray-300'} fill={s <= Math.round(parseFloat(promedio)) ? 'currentColor' : 'none'} />
                                  ))}
                                  <span className="text-xs text-blue-600 font-bold ml-1">{promedio}</span>
                                </div>
                              </div>
                              <ChevronDown size={15} className={`text-blue-400 transition-transform ${expandido ? 'rotate-180' : ''}`} />
                            </button>
                            {/* Reseñas desplegables */}
                            {expandido && (
                              <div className="bg-white px-4 py-3 space-y-2.5">
                                {cals.map((c, i) => (
                                  <div key={i} className={`pb-2.5 ${i < cals.length - 1 ? 'border-b border-gray-100' : ''}`}>
                                    <div className="flex items-center justify-between mb-1">
                                      <div className="flex items-center gap-1">
                                        {[1,2,3,4,5].map(s => (
                                          <Star key={s} size={11} className={s <= Math.round(c.puntuacion) ? 'text-yellow-400' : 'text-gray-300'} fill={s <= Math.round(c.puntuacion) ? 'currentColor' : 'none'} />
                                        ))}
                                        <span className="text-xs font-bold text-gray-700 ml-1">{c.autorNombre}</span>
                                      </div>
                                      <span className="text-xs text-gray-400">{new Date(c.creadoEn).toLocaleDateString('es-MX', { month: 'short', year: 'numeric' })}</span>
                                    </div>
                                    <p className="text-sm text-gray-600 italic">"{c.comentario}"</p>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })()}
                      </div>
                    </div>
                    {/* Precio */}
                    <div className="text-right flex-shrink-0">
                      {index === 0 && (
                        <span className="bg-green-100 text-green-700 text-xs font-semibold px-2 py-1 rounded-full mb-2 inline-block">Mejor Precio</span>
                      )}
                      <p className="text-3xl font-bold text-gray-800">${cot.precio.toLocaleString()}</p>
                      <p className="text-sm text-gray-500">MXN</p>
                      <p className="text-xs text-gray-400">IVA incluido</p>
                    </div>
                  </div>

                  {/* ── Tipo de unidad visual ── */}
                  {cot.tipoUnidad && (
                    <TipoUnidadBadge
                      tipo={cot.tipoUnidad}
                      marcaModelo={cot.unidadOfrecida || (cot.marcaUnidad ? `${cot.marcaUnidad} ${cot.modeloUnidad || ''} ${cot.anioUnidad || ''}`.trim() : null)}
                      foto={cot.fotoUnidad || null}
                      gpsInstalado={cot.rastreoGPS}
                      largoM={cot.largoM}
                      anchoM={cot.anchoM}
                      altoM={cot.altoM}
                      seguroCarga={cot.seguro}
                      tempMinima={cot.tempMinima}
                    />
                  )}

                  {/* ── Años de experiencia del chofer ── */}
                  {cot.aniosExperienciaChofer > 0 && (
                    <div className="flex items-center gap-2 mt-2 px-3 py-2 bg-blue-50 border border-blue-100 rounded-xl">
                      <span className="text-lg">👨‍✈️</span>
                      <div>
                        <span className="text-xs text-blue-500 font-semibold">Chofer</span>
                        <span className="ml-2 text-sm font-bold text-blue-800">{cot.aniosExperienciaChofer} año{cot.aniosExperienciaChofer !== 1 ? 's' : ''} de experiencia</span>
                      </div>
                    </div>
                  )}

                  {/* ── Detalles: 4 columnas ── */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4 pt-4 border-t">
                    <div>
                      <p className="text-xs text-gray-500 mb-0.5">Tiempo de entrega</p>
                      <p className="font-semibold text-sm">{cot.tiempoEntrega || '—'}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 mb-0.5">Unidad</p>
                      <p className="font-semibold text-sm">{cot.unidadOfrecida || (cot.marcaUnidad ? `${cot.marcaUnidad} ${cot.modeloUnidad || ''} ${cot.anioUnidad || ''}`.trim() : '—')}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 mb-0.5">Seguro incluido</p>
                      <p className="font-semibold text-sm">{cot.seguro ? '✅ Sí' : '❌ No'}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 mb-0.5">Rastreo GPS</p>
                      <p className="font-semibold text-sm">{cot.rastreoGPS ? '✅ Sí' : '❌ No'}</p>
                    </div>
                    {cot.cargaDescarga != null && (
                      <div>
                        <p className="text-xs text-gray-500 mb-0.5">Carga/Descarga</p>
                        <p className="font-semibold text-sm">{cot.cargaDescarga ? '✅ Incluida' : '❌ No incluida'}</p>
                      </div>
                    )}
                  </div>

                  {/* ── Nota del transportista ── */}
                  {(cot.notas || cot.comentario) && (
                    <div className="mt-3 bg-gray-50 rounded-lg px-4 py-3">
                      <p className="text-sm text-gray-600 italic">"{cot.notas || cot.comentario}"</p>
                    </div>
                  )}

                  {/* Botones de acción */}
                  <div className="flex space-x-3 mt-4">
                    <button 
                      onClick={() => toggleComparar(cot)}
                      className={`flex-1 px-4 py-2 rounded-lg font-medium flex items-center justify-center space-x-2 ${
                        cotizacionesParaComparar.find(c => c.id === cot.id)
                          ? 'bg-blue-100 text-blue-700 border-2 border-blue-500'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      <Scale size={18} />
                      <span>{cotizacionesParaComparar.find(c => c.id === cot.id) ? 'Quitar' : 'Comparar'}</span>
                    </button>
                    <button 
                      onClick={() => seleccionarGanador(cot)}
                      className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium flex items-center justify-center space-x-2"
                    >
                      <CheckCircle size={18} />
                      <span>Seleccionar</span>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Modal: Comparador Lado a Lado
  const ModalComparador = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
      <div className="bg-white shadow-2xl rounded-xl max-w-5xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h3 className="text-2xl font-bold text-gray-800">Comparar Cotizaciones</h3>
              <p className="text-gray-400">Analiza las diferencias para tomar la mejor decisión</p>
            </div>
            <button onClick={() => setMostrarComparador(false)} className="text-gray-400 hover:text-gray-600 p-2">
              <X size={24} />
            </button>
          </div>

          {/* Tabla comparativa */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b-2">
                  <th className="text-left py-4 px-4 font-semibold text-gray-600 w-1/4">Característica</th>
                  {cotizacionesParaComparar.map(cot => (
                    <th key={cot.id} className="text-center py-4 px-4">
                      <div className="relative mx-auto mb-2 w-12 h-12">
                        <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center">
                          {(() => { const logo = getLogoEmpresa(cot); return (logo?.startsWith('data:') || logo?.startsWith('http'))
                            ? <img src={logo} alt="logo" className="w-full h-full object-cover" />
                            : <span className="text-2xl">{logo}</span>; })()}
                        </div>
                        {cot.transportista?.avatar && (
                          <img src={cot.transportista.avatar} alt="transportista" className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-white shadow" />
                        )}
                      </div>
                      <div className="font-bold text-gray-800">{cot.transportista}</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className="border-b bg-green-50">
                  <td className="py-4 px-4 font-semibold">💰 Precio</td>
                  {cotizacionesParaComparar.map(cot => {
                    const esMenorPrecio = cot.precio === Math.min(...cotizacionesParaComparar.map(c => c.precio));
                    return (
                      <td key={cot.id} className="text-center py-4 px-4">
                        <span className={`text-2xl font-bold ${esMenorPrecio ? 'text-green-600' : 'text-gray-800'}`}>
                          ${cot.precio.toLocaleString()}
                        </span>
                        <span className="block text-xs text-gray-400">IVA incluido</span>
                        {esMenorPrecio && <span className="block text-xs text-green-600 mt-1">✓ Mejor precio</span>}
                      </td>
                    );
                  })}
                </tr>
                <tr className="border-b">
                  <td className="py-4 px-4 font-semibold">⏱️ Tiempo de entrega</td>
                  {cotizacionesParaComparar.map(cot => (
                    <td key={cot.id} className="text-center py-4 px-4 font-medium">{cot.tiempoEntrega}</td>
                  ))}
                </tr>
                <tr className="border-b bg-gray-50">
                  <td className="py-4 px-4 font-semibold">⭐ Calificación</td>
                  {cotizacionesParaComparar.map(cot => {
                    const esMejorCal = cot.calificacion === Math.max(...cotizacionesParaComparar.map(c => c.calificacion));
                    return (
                      <td key={cot.id} className="text-center py-4 px-4">
                        <span className={`font-bold ${esMejorCal ? 'text-yellow-600' : ''}`}>
                          {cot.calificacion} / 5
                        </span>
                        {esMejorCal && <span className="block text-xs text-yellow-600 mt-1">✓ Mejor calificado</span>}
                      </td>
                    );
                  })}
                </tr>
                <tr className="border-b">
                  <td className="py-4 px-4 font-semibold">🚛 Viajes completados</td>
                  {cotizacionesParaComparar.map(cot => (
                    <td key={cot.id} className="text-center py-4 px-4 font-medium">
                      {getEmpresaViva(cot)?.viajesCompletados ?? cot.viajesCompletados}
                    </td>
                  ))}
                </tr>
                <tr className="border-b">
                  <td className="py-4 px-4 font-semibold">❌ Cancelaciones</td>
                  {cotizacionesParaComparar.map(cot => {
                    const SEIS_MESES_MS = 6 * 30 * 24 * 60 * 60 * 1000;
                    const ultima = cot.ultimaCancelacionTransportista;
                    const expirado = ultima && (Date.now() - new Date(ultima).getTime()) > SEIS_MESES_MS;
                    const n = expirado ? 0 : (cot.cancelacionesTransportista ?? 0);
                    const esPeor = n === Math.max(...cotizacionesParaComparar.map(c => {
                      const u = c.ultimaCancelacionTransportista;
                      const exp = u && (Date.now() - new Date(u).getTime()) > SEIS_MESES_MS;
                      return exp ? 0 : (c.cancelacionesTransportista ?? 0);
                    })) && n > 0;
                    return (
                      <td key={cot.id} className="text-center py-4 px-4">
                        {n === 0
                          ? <span className="text-green-600 font-semibold text-sm">✓ Ninguna</span>
                          : <span className={`font-bold ${esPeor ? 'text-red-600' : 'text-orange-600'}`}>{n} en 6 meses</span>}
                      </td>
                    );
                  })}
                </tr>
                <tr className="border-b bg-gray-50">
                  <td className="py-4 px-4 font-semibold">🚚 Unidad ofrecida</td>
                  {cotizacionesParaComparar.map(cot => (
                    <td key={cot.id} className="text-center py-4 px-4 font-medium">
                      {cot.marcaUnidad
                        ? <>{cot.marcaUnidad} {cot.modeloUnidad}<br /><span className="text-xs text-gray-500">{cot.tipoUnidad} · {cot.anioUnidad || '—'}</span></>
                        : cot.unidadOfrecida || '—'}
                    </td>
                  ))}
                </tr>
                <tr className="border-b">
                  <td className="py-4 px-4 font-semibold">🛡️ Seguro incluido</td>
                  {cotizacionesParaComparar.map(cot => (
                    <td key={cot.id} className="text-center py-4 px-4">
                      {cot.seguro 
                        ? <span className="text-green-600 font-semibold">✅ Sí</span>
                        : <span className="text-red-600 font-semibold">❌ No</span>
                      }
                    </td>
                  ))}
                </tr>
                <tr className="border-b bg-gray-50">
                  <td className="py-4 px-4 font-semibold">📍 Rastreo GPS</td>
                  {cotizacionesParaComparar.map(cot => (
                    <td key={cot.id} className="text-center py-4 px-4">
                      {cot.rastreoGPS
                        ? <span className="text-green-600 font-semibold">✅ Sí</span>
                        : <span className="text-red-600 font-semibold">❌ No</span>
                      }
                    </td>
                  ))}
                </tr>
                <tr className="border-b">
                  <td className="py-4 px-4 font-semibold">📦 Carga/Descarga</td>
                  {cotizacionesParaComparar.map(cot => (
                    <td key={cot.id} className="text-center py-4 px-4">
                      {cot.cargaDescarga
                        ? <span className="text-green-600 font-semibold">✅ Incluida</span>
                        : <span className="text-red-600 font-semibold">❌ No incluida</span>
                      }
                    </td>
                  ))}
                </tr>
                <tr>
                  <td className="py-4 px-4 font-semibold">📝 Comentario</td>
                  {cotizacionesParaComparar.map(cot => (
                    <td key={cot.id} className="text-center py-4 px-4 text-sm text-gray-600 italic">
                      "{cot.comentario}"
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>

          {/* Botones de selección */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 pt-6 border-t">
            {cotizacionesParaComparar.map(cot => (
              <button
                key={cot.id}
                onClick={() => seleccionarGanador(cot)}
                className="px-6 py-4 bg-green-600 text-white rounded-xl hover:bg-green-700 font-medium flex flex-col items-center space-y-2"
              >
                <div className="w-10 h-10 rounded-lg overflow-hidden bg-white bg-opacity-20 flex items-center justify-center mx-auto">
                  {(() => { const logo = getLogoEmpresa(cot); return (logo?.startsWith('data:') || logo?.startsWith('http'))
                    ? <img src={logo} alt="logo" className="w-full h-full object-cover" />
                    : <span className="text-xl">{logo}</span>; })()}
                </div>
                <span>Seleccionar a {cot.transportista.split(' ')[0]}</span>
                <span className="text-green-200">${cot.precio.toLocaleString()} MXN</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  // Modal: Confirmación de Selección
  const ModalConfirmacion = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
      <div className="bg-white shadow-2xl rounded-xl max-w-md w-full">
        <div className="p-6">
          <div className="text-center mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle size={48} className="text-green-600" />
            </div>
            <h3 className="text-2xl font-bold text-gray-800">Confirmar Selección</h3>
            <p className="text-gray-500 mt-2">
              Estás a punto de contratar a este transportista
            </p>
          </div>

          {/* Resumen de la selección */}
          <div className="bg-gray-50 rounded-xl p-4 mb-6">
            <div className="flex items-center space-x-4 mb-4">
              <div className="w-14 h-14 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center flex-shrink-0">
                {(() => { const logo = cotizacionGanadora ? getLogoEmpresa(cotizacionGanadora) : '🚛'; return (logo?.startsWith('data:') || logo?.startsWith('http'))
                  ? <img src={logo} alt="logo" className="w-full h-full object-cover" />
                  : <span className="text-3xl">{logo}</span>; })()}
              </div>
              <div>
                <h4 className="font-bold text-lg">{cotizacionGanadora?.transportista}</h4>
                <div className="flex items-center text-sm text-gray-600">
                  {(() => {
                    const _ev = getEmpresaViva(cotizacionGanadora);
                    const _cal = _ev?.calificacion ?? cotizacionGanadora?.calificacion;
                    const _viajes = _ev?.viajesCompletados ?? cotizacionGanadora?.viajesCompletados;
                    const _tieneViajes = _viajes != null && _viajes > 0;
                    return _tieneViajes ? (
                      <><Star size={14} className="text-yellow-500 mr-1" fill="currentColor" />{typeof _cal === 'number' ? _cal.toFixed(1) : _cal} • {_viajes} viajes</>
                    ) : <span>{_viajes ?? 0} viajes</span>;
                  })()}
                </div>
              </div>
            </div>
            
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Ruta:</span>
                <span className="font-medium">{solicitudSeleccionada?.origen} → {solicitudSeleccionada?.destino}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Tiempo de entrega:</span>
                <span className="font-medium">{cotizacionGanadora?.tiempoEntrega}</span>
              </div>
              <div className="flex justify-between text-lg pt-2 border-t mt-2">
                <span className="font-semibold">Total a pagar:</span>
                <span className="font-bold text-green-600">${cotizacionGanadora?.precio.toLocaleString()} MXN</span>
              </div>
            </div>
          </div>

          <p className="text-sm text-gray-500 text-center mb-6">
            Al confirmar, serás redirigido a la pasarela de pago seguro.
          </p>

          {/* Botones */}
          <div className="flex space-x-4">
            <button 
              onClick={() => setMostrarConfirmacion(false)}
              className="flex-1 px-6 py-3 border border-gray-300 rounded-lg bg-white text-gray-700 hover:bg-gray-50 font-medium"
            >
              Cancelar
            </button>
            <button 
              onClick={confirmarSeleccion}
              className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium flex items-center justify-center space-x-2"
            >
              <CreditCard size={20} />
              <span>Proceder al Pago</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  // Modal: Calificar Servicio
  const ModalCalificar = () => {
    const handleSubmit = () => {
      if (calificacionLocal === 0) {
        mostrarNotificacion('Por favor selecciona una calificación', 'warning');
        return;
      }
      calificarViaje(mostrarCalificar.id, calificacionLocal, comentarioLocal);
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
        <div className="bg-white shadow-2xl rounded-xl max-w-md w-full">
          <div className="p-6 border-b">
            <div className="flex justify-between items-center">
              <h3 className="text-xl font-bold text-gray-800">Califica el Servicio</h3>
              <button onClick={() => setMostrarCalificar(null)} className="text-gray-400 hover:text-gray-600">
                <X size={24} />
              </button>
            </div>
          </div>

          <div className="p-6">
            {/* Info del viaje */}
            <div className="bg-gray-50 rounded-xl p-4 mb-6">
              <p className="text-sm text-gray-500">Viaje {mostrarCalificar?.id}</p>
              <p className="font-semibold">{mostrarCalificar?.ruta}</p>
              <p className="text-gray-600">{mostrarCalificar?.transportista}</p>
            </div>

            {/* Estrellas de calificación */}
            <div className="text-center mb-6">
              <p className="text-sm font-semibold text-gray-700 mb-3">¿Cómo fue tu experiencia?</p>
              <div className="flex justify-center space-x-2">
                {[1, 2, 3, 4, 5].map(star => (
                  <button
                    key={star}
                    onClick={() => setCalificacionLocal(star)}
                    onMouseEnter={() => setHoverStar(star)}
                    onMouseLeave={() => setHoverStar(0)}
                    className="transition-transform hover:scale-110"
                  >
                    <Star 
                      size={40} 
                      className={
                        (hoverStar || calificacionLocal) >= star 
                          ? 'text-yellow-400' 
                          : 'text-gray-400'
                      }
                      fill={(hoverStar || calificacionLocal) >= star ? 'currentColor' : 'none'}
                    />
                  </button>
                ))}
              </div>
              <p className="text-sm text-gray-500 mt-2">
                {calificacionLocal === 0 && 'Selecciona una calificación'}
                {calificacionLocal === 1 && '😞 Muy malo'}
                {calificacionLocal === 2 && '😕 Malo'}
                {calificacionLocal === 3 && '😐 Regular'}
                {calificacionLocal === 4 && '🙂 Bueno'}
                {calificacionLocal === 5 && '😍 ¡Excelente!'}
              </p>
            </div>

            {/* Comentario opcional */}
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Comentario (opcional)
              </label>
              <textarea 
                value={comentarioLocal}
                onChange={(e) => setComentarioLocal(e.target.value)}
                placeholder="Cuéntanos más sobre tu experiencia..."
                rows="3"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Sugerencias rápidas */}
            <div className="mb-6">
              <p className="text-xs text-gray-500 mb-2">Sugerencias:</p>
              <div className="flex flex-wrap gap-2">
                {['Puntual', 'Buen trato', 'Cuidadoso con la carga', 'Buena comunicación', 'Precio justo'].map(tag => (
                  <button 
                    key={tag}
                    onClick={() => setComentarioLocal(prev => prev ? `${prev}, ${tag}` : tag)}
                    className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm hover:bg-blue-100"
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </div>

            {/* Botón de enviar */}
            <button 
              onClick={handleSubmit}
              className="w-full px-6 py-3 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 font-semibold flex items-center justify-center space-x-2"
            >
              <Send size={20} />
              <span>Enviar Calificación</span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Componente de Notificación

  // ========== PANEL DE NOTIFICACIONES ==========
  const PanelNotificaciones = () => {
    const TIPOS_SOLO_TRANSPORTISTA = ['calificacion_pendiente', 'nueva_orden', 'escrow_liberado'];
    const todas = (store.notificaciones || [])
      .filter(n => (n.destinatarioId === usuario?.id || n.destinatarioRol === 'cliente') && !TIPOS_SOLO_TRANSPORTISTA.includes(n.tipo))
      .slice().sort((a, b) => new Date(b.creadoEn) - new Date(a.creadoEn));
    return (
      <div className="fixed inset-0 z-[1000] flex items-start justify-center md:justify-end pt-2 px-2 md:pt-4 md:pr-4 md:px-0" onClick={() => setMostrarNotificaciones(false)}>
        <div className="bg-white shadow-2xl rounded-xl w-full max-w-sm md:w-96 max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
          <div className="p-4 border-b flex justify-between items-center">
            <h3 className="font-bold text-gray-800 text-lg">Notificaciones</h3>
            <div className="flex items-center gap-2">
              {todas.length > 0 && (
                <button onClick={() => { apiEliminarTodasNotificaciones().catch(() => {}); limpiarNotificaciones(usuario?.id, 'cliente'); setMostrarNotificaciones(false); }} className="text-xs text-red-500 hover:text-red-700 font-medium">Limpiar todo</button>
              )}
              <button onClick={() => setMostrarNotificaciones(false)} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
            </div>
          </div>
          {todas.length === 0 ? (
            <div className="p-8 text-center text-gray-500">
              <AlertCircle size={40} className="mx-auto mb-3 text-gray-400" />
              <p>Sin notificaciones</p>
            </div>
          ) : (
            <div className="divide-y">
              {todas.map(n => {
                const destino =
                  n.tipo === 'nueva_cotizacion' ? 'solicitudes' :
                  n.tipo === 'solicitud_expirada' ? 'historial' :
                  n.tipo === 'solicitud_cancelada_confirmacion' ? 'historial' :
                  n.tipo === 'solicitud_expirando' ? 'solicitudes' :
                  n.tipo === 'viaje_cancelado' ? 'viajes' :
                  (n.tipo === 'entrega_completada' || n.tipo?.startsWith('status_')) ? 'viajes' :
                  n.tipo === 'pago_recibido' ? 'pagos' :
                  (n.tipo === 'retiro_aprobado' || n.tipo === 'retiro_pagado' || n.tipo === 'retiro_rechazado') ? 'pagos' :
                  n.tipo === 'comision_disponible' ? 'compartir' : null;
                const linkLabel =
                  n.tipo === 'nueva_cotizacion' ? 'Ver cotizaciones →' :
                  n.tipo === 'solicitud_expirando' ? (n.datos?.cotizacionesCount > 0 ? 'Ver cotizaciones →' : 'Ver solicitud →') :
                  n.tipo === 'solicitud_expirada' ? 'Ver historial →' :
                  n.tipo === 'solicitud_cancelada_confirmacion' ? 'Ver historial →' :
                  n.tipo === 'viaje_cancelado' ? 'Ver viajes →' :
                  n.tipo === 'entrega_completada' ? 'Ver entrega →' :
                  n.tipo?.startsWith('status_') ? 'Ver viaje activo →' :
                  (n.tipo === 'pago_recibido' || n.tipo === 'retiro_aprobado' || n.tipo === 'retiro_pagado' || n.tipo === 'retiro_rechazado') ? 'Ver pagos →' :
                  n.tipo === 'comision_disponible' ? 'Ver comisiones →' : null;
                return (
                  <div key={n.id}
                    className={`p-4 relative ${destino ? 'cursor-pointer hover:bg-gray-50' : ''} ${n.leida ? 'bg-white' : 'bg-blue-50'}`}
                    onClick={() => { if (destino) { setSeccion(destino); setMostrarNotificaciones(false); } }}
                  >
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        apiEliminarNotificacion(n.id).catch(() => {});
                        dispatch(s => ({ ...s, notificaciones: (s.notificaciones || []).filter(x => x.id !== n.id) }));
                      }}
                      className="absolute top-3 right-3 text-gray-300 hover:text-gray-500 transition"
                      title="Descartar"
                    >
                      <X size={14} />
                    </button>
                    <div className="flex items-start space-x-3 pr-5">
                      <div className={`mt-1 w-2 h-2 rounded-full flex-shrink-0 ${n.leida ? 'bg-gray-300' : 'bg-blue-500'}`} />
                      <div className="flex-1">
                        <p className="font-semibold text-gray-800 text-sm">{n.titulo}</p>
                        <p className="text-gray-600 text-sm mt-0.5">{n.mensaje}</p>
                        <p className="text-xs text-gray-400 mt-1">{new Date(n.creadoEn).toLocaleString('es-MX')}</p>
                        {linkLabel && <span className="mt-2 inline-block text-xs text-blue-600 font-semibold">{linkLabel}</span>}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  };

  // ========== RENDER PRINCIPAL ==========
  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      {/* Notificación flotante de acciones */}
      {/* Toast automático de notificaciones entrantes */}
      {toastNotif.length > 0 && !toastPausado && (() => {
        const notif = toastNotif[0];
        const esAlerta = notif.tipo?.startsWith('alerta_');
        const alertaTipo = esAlerta ? notif.tipo.replace('alerta_', '') : null;
        // Alertas simples no persistentes → píldora clásica
        if (esAlerta && !notif.persistente) {
          const bgColor = { success: 'bg-green-500', warning: 'bg-yellow-500', error: 'bg-red-500' }[alertaTipo] || 'bg-gray-700';
          return (
            <div className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${bgColor} text-white px-8 py-5 rounded-2xl shadow-2xl z-[99999] flex items-center space-x-3 text-center max-w-sm w-full mx-4 pointer-events-none`}>
              {alertaTipo === 'success' && <CheckCircle size={24} className="flex-shrink-0" />}
              {alertaTipo === 'warning' && <AlertCircle size={24} className="flex-shrink-0" />}
              {alertaTipo === 'error' && <XCircle size={24} className="flex-shrink-0" />}
              <span className="font-medium">{notif.mensaje}</span>
            </div>
          );
        }
        const headerColor = esAlerta
          ? { success: 'bg-green-600', warning: 'bg-yellow-500', error: 'bg-red-600' }[alertaTipo] || 'bg-gray-700'
          : notif.tipo === 'viaje_cancelado' ? 'bg-red-600'
          : notif.tipo === 'solicitud_expirando' ? 'bg-yellow-500'
          : (notif.tipo === 'pago_recibido' || notif.tipo === 'retiro_pagado' || notif.tipo === 'comision_disponible') ? 'bg-green-600'
          : notif.tipo === 'retiro_rechazado' ? 'bg-red-600'
          : 'bg-blue-600';
        const borderColor = esAlerta
          ? { success: 'border-green-200', warning: 'border-yellow-300', error: 'border-red-200' }[alertaTipo] || 'border-gray-200'
          : (notif.tipo === 'viaje_cancelado' || notif.tipo === 'retiro_rechazado') ? 'border-red-200'
          : notif.tipo === 'solicitud_expirando' ? 'border-yellow-300'
          : (notif.tipo === 'pago_recibido' || notif.tipo === 'retiro_pagado' || notif.tipo === 'comision_disponible') ? 'border-green-200'
          : 'border-blue-200';
        const hoverColor = esAlerta
          ? { success: 'hover:bg-green-50', warning: 'hover:bg-yellow-50', error: 'hover:bg-red-50' }[alertaTipo] || 'hover:bg-gray-50'
          : 'hover:bg-blue-50';
        const tocaColor = esAlerta
          ? { warning: 'text-yellow-600', error: 'text-red-600' }[alertaTipo]
          : 'text-blue-600';
        const seccionDestino = esAlerta ? (notif.navegar || null) : ({
          nueva_cotizacion: 'solicitudes',
          solicitud_expirada: 'solicitudes',
          solicitud_expirando: 'solicitudes',
          chofer_asignado: 'viajes',
          viaje_iniciado: 'viajes',
          incidencia_cliente: 'viajes',
          evidencia_entrega: 'viajes',
          status_en_ruta: 'viajes',
          status_llegada_destino: 'viajes',
          status_completada: 'viajes',
          entrega_completada: 'viajes',
          viaje_cancelado: 'viajes',
          retorno_oferta: 'fletes',
          pago_recibido: 'pagos',
          retiro_aprobado: 'pagos',
          retiro_pagado: 'pagos',
          retiro_rechazado: 'pagos',
          comision_disponible: 'compartir',
        }[notif.tipo] || null);
        const esNavegable = !!seccionDestino || notif.tipo === 'chat_mensaje';
        return (
          <div className="fixed inset-0 flex items-center justify-center z-[2000] pointer-events-none">
            <div className={`bg-white border ${borderColor} rounded-2xl shadow-2xl w-96 pointer-events-auto animate-slide-in-right`}>
              <div className={`${headerColor} px-5 py-3 rounded-t-2xl flex items-center justify-between`}>
                <div className="flex items-center gap-2 text-white text-sm font-semibold">
                  {esAlerta
                    ? (alertaTipo === 'success' ? <CheckCircle size={16} /> : alertaTipo === 'error' ? <XCircle size={16} /> : <AlertCircle size={16} />)
                    : <Bell size={16} />}
                  <span>{notif.titulo || 'Nueva notificación'}{toastNotif.length > 1 ? ` (1 de ${toastNotif.length})` : ''}</span>
                </div>
                <button onClick={() => cerrarToast()} className="text-white hover:opacity-70">
                  <X size={18} />
                </button>
              </div>
              <div
                className={`p-5 ${esNavegable ? `cursor-pointer ${hoverColor}` : ''}`}
                onClick={() => {
                  if (!esNavegable) return;
                  setMostrarNotificaciones(false);
                  // Recordatorio/alerta con navegar
                  if (esAlerta && notif.navegar) {
                    setSeccion(notif.navegar);
                    if (notif.expandViajeId) { setExpandedViaje(notif.expandViajeId); setTimeout(() => document.getElementById(`viaje-${notif.expandViajeId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150); }
                    if (notif.expandRetornoId) { setExpandedRetorno(notif.expandRetornoId); setTimeout(() => document.getElementById(`retorno-${notif.expandRetornoId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150); }
                    cerrarToast(); return;
                  }
                  // Nueva cotización → solicitudes + expandir acordeón
                  if (notif.tipo === 'nueva_cotizacion' && notif.datos?.solicitudId) {
                    setSeccion('solicitudes');
                    setExpandedSolicitud(notif.datos.solicitudId);
                    setTimeout(() => document.getElementById(`sol-${notif.datos.solicitudId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
                    cerrarToast(); return;
                  }
                  // Chat mensaje → abrir ChatModal directamente
                  if (notif.tipo === 'chat_mensaje' && notif.datos?.viajeId) {
                    if (notif.contraparte) {
                      setChatModal({ viajeId: notif.datos.viajeId, contraparte: notif.contraparte });
                    } else {
                      const vid = notif.datos.viajeId;
                      setSeccion('viajes'); setExpandedViaje(vid);
                      setTimeout(() => document.getElementById(`viaje-${vid}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
                    }
                    cerrarToast(); return;
                  }
                  // Status viaje → viajes + expandir acordeón
                  if (notif.datos?.viajeId && (notif.tipo?.startsWith('status_') || notif.tipo === 'entrega_completada')) {
                    setSeccion('viajes'); setExpandedViaje(notif.datos.viajeId);
                    setTimeout(() => document.getElementById(`viaje-${notif.datos.viajeId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
                    cerrarToast(); return;
                  }
                  // Retorno → fletes + expandir acordeón
                  if (notif.datos?.retornoId) {
                    setSeccion('fletes'); setExpandedRetorno(notif.datos.retornoId);
                    setTimeout(() => document.getElementById(`retorno-${notif.datos.retornoId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
                    cerrarToast(); return;
                  }
                  if (seccionDestino) setSeccion(seccionDestino);
                  cerrarToast();
                }}
              >
                <p className="font-bold text-gray-800">{notif.titulo}</p>
                <p className="text-gray-600 text-sm mt-1">{notif.mensaje}</p>
                {(notif.tipo === 'incidencia_cliente' || notif.tipo === 'evidencia_entrega') && notif.datos?.foto && (
                  <img
                    src={notif.datos.foto} alt="Evidencia"
                    className="mt-3 w-full max-h-40 object-cover rounded-lg cursor-pointer hover:opacity-80"
                    onClick={e => { e.stopPropagation(); setFotoLightbox(notif.datos.foto); }}
                    title="Ver en grande"
                  />
                )}
                {notif.fecha && (
                  <p className="text-gray-400 text-xs mt-2">
                    {new Date(notif.fecha).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}
                    {' · '}
                    {new Date(notif.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
                  </p>
                )}
                {esNavegable && tocaColor && <p className={`${tocaColor} text-xs font-semibold mt-3`}>Toca para ir a atender →</p>}
              </div>
            </div>
          </div>
        );
      })()}
      {mostrarNotificaciones && PanelNotificaciones()}

      {/* Modal del mapa — fuera de cualquier overflow */}
      {mapaAbierto && (
        <MapPickerModal
          titulo={mapaAbierto === 'origen' ? 'Seleccionar punto de Origen' : 'Seleccionar punto de Destino'}
          coordInicial={mapaAbierto === 'origen' ? (origenCoords || ciudadCoordsInicial) : (destinoCoords || ciudadCoordsInicial)}
          onConfirm={(coords) => {
            if (mapaAbierto === 'origen') setOrigenCoords(coords);
            else setDestinoCoords(coords);
            setMapaAbierto(null);
          }}
          onClose={() => setMapaAbierto(null)}
        />
      )}

      {/* Mapa para oferta de retorno vacío */}
      {mapaAbiertoOferta && (
        <MapPickerModal
          titulo={mapaAbiertoOferta === 'origen' ? 'Punto de recogida de la carga' : 'Punto de entrega de la carga'}
          coordInicial={mapaAbiertoOferta === 'origen' ? (formOferta.origenCoords || ciudadCoordsInicialOferta) : (formOferta.destinoCoords || ciudadCoordsInicialOferta)}
          onConfirm={(coords) => {
            if (mapaAbiertoOferta === 'origen') setFormOferta(f => ({ ...f, origenCoords: coords }));
            else setFormOferta(f => ({ ...f, destinoCoords: coords }));
            setMapaAbiertoOferta(null);
          }}
          onClose={() => setMapaAbiertoOferta(null)}
        />
      )}

      {/* GPS obligatorio al aceptar contraoferta */}
      {gpsContraoferta && (
        <MapPickerModal
          titulo={gpsContraoferta.tipo === 'origen' ? '📦 Marca el punto exacto de recogida' : '🏁 Marca el punto exacto de entrega'}
          coordInicial={gpsContraoferta.tipo === 'origen' ? gpsContraoferta.origenCoords : gpsContraoferta.destinoCoords}
          onConfirm={(coords) => {
            const actualizado = gpsContraoferta.tipo === 'origen'
              ? { ...gpsContraoferta, origenCoords: coords, tipo: 'destino' }
              : { ...gpsContraoferta, destinoCoords: coords, tipo: 'hecho' };
            if (actualizado.tipo === 'hecho') {
              actualizarCoordsOferta(actualizado.retornoId, actualizado.ofertaId, actualizado.origenCoords, actualizado.destinoCoords);
              setRetornoPagar({ retorno: actualizado.retorno, oferta: actualizado.oferta });
              setPagoRetornoCompletado(false);
              setGpsContraoferta(null);
            } else {
              setGpsContraoferta(actualizado);
            }
          }}
          onClose={() => {
            // Permite saltar GPS y ir directo al pago
            setRetornoPagar({ retorno: gpsContraoferta.retorno, oferta: gpsContraoferta.oferta });
            setPagoRetornoCompletado(false);
            setGpsContraoferta(null);
          }}
        />
      )}

      {/* Overlay móvil */}
      {sidebarAbierto && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarAbierto(false)} />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-30 w-72 bg-blue-900 text-white p-4 pb-20 md:pb-4 flex flex-col overflow-y-auto
        transform transition-transform duration-300 ease-in-out
        ${sidebarAbierto ? 'translate-x-0' : '-translate-x-full'}
        md:relative md:translate-x-0 md:w-64 md:z-auto
      `}>
        <div className="mb-8 flex items-start justify-between">
          <div>
            <h1 className="text-3xl font-black text-orange-400 leading-none">Choyero!</h1>
            <p className="text-xs font-semibold text-blue-200 tracking-widest uppercase mt-0.5">Marketplace Logístico</p>
            <div className="mt-3 px-2 py-1 bg-orange-500 rounded text-xs font-semibold inline-block">
              CLIENTE
            </div>
          </div>
          <button onClick={abrirNotificaciones} className="relative mt-1 p-2 rounded-lg hover:bg-gray-50 transition">
            <Bell size={20} className="text-white" />
            {notifsPendientes.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
                {notifsPendientes.length}
              </span>
            )}
          </button>
        </div>
        
        <nav className="space-y-2 flex-1">
          {menu.map(item => (
            <button
              key={item.id}
              onClick={() => { setSeccion(item.id); setSidebarAbierto(false); }}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition ${
                seccion === item.id ? 'bg-blue-600' : 'hover:bg-blue-800'
              }`}
            >
              <item.icon size={20} />
              <span>{item.label}</span>
              {item.id === 'solicitudes' && misSolicitudes.filter(s => ['cotizando', 'en_cotizacion', 'abierta'].includes(s.status)).length > 0 && (
                <span className="ml-auto bg-yellow-500 text-blue-900 text-xs px-2 py-1 rounded-full font-bold">
                  {misSolicitudes.filter(s => ['cotizando', 'en_cotizacion', 'abierta'].includes(s.status)).length}
                </span>
              )}
              {item.id === 'viajes' && viajesActivos.length > 0 && (
                <span className="ml-auto bg-yellow-500 text-blue-900 text-xs px-2 py-1 rounded-full font-bold">
                  {viajesActivos.length}
                </span>
              )}
              {item.badge > 0 && item.id !== 'solicitudes' && item.id !== 'viajes' && (
                <span className="ml-auto bg-orange-500 text-white text-xs px-2 py-1 rounded-full font-bold">{item.badge}</span>
              )}
            </button>
          ))}
        </nav>

        {/* Resumen rápido */}
        <div className="p-4 bg-blue-800 rounded-xl mb-3">
          <p className="text-xs text-blue-300 mb-1">Viajes activos</p>
          <p className="text-2xl font-bold text-yellow-400">{viajesActivos.length}</p>
        </div>
        <div className="p-4 bg-blue-800 rounded-xl mb-4">
          <p className="text-xs text-blue-300 mb-2 font-semibold uppercase tracking-wide">Gasto en Fletes</p>
          <div className="flex justify-between items-baseline mb-1">
            <p className="text-xs text-blue-400">Hoy</p>
            <p className="text-base font-bold text-blue-200">${gastoHoy.toLocaleString()}</p>
          </div>
          <div className="flex justify-between items-baseline">
            <p className="text-xs text-blue-400">Este mes</p>
            <p className="text-xl font-bold text-yellow-400">${gastoMes.toLocaleString()}</p>
          </div>
        </div>

        {/* Usuario */}
        <div className="pt-4 border-t border-blue-700">
          <div className="flex items-center space-x-3 px-4 py-3">
            <label className="cursor-pointer group relative flex-shrink-0" title="Cambiar foto de perfil">
              <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center font-bold text-blue-900 overflow-hidden">
                {(() => {
                  const foto = store.usuarioPerfil?.avatar || usuario?.avatar;
                  return foto
                    ? <img src={foto} alt="foto" className="w-full h-full object-cover" />
                    : (usuario?.nombre?.slice(0, 2)?.toUpperCase() || 'CL');
                })()}
              </div>
              <div className="absolute inset-0 rounded-full bg-black bg-opacity-0 group-hover:bg-opacity-40 flex items-center justify-center transition">
                <span className="text-white text-xs opacity-0 group-hover:opacity-100">📷</span>
              </div>
              <input type="file" accept="image/*" className="hidden" onChange={handleAvatarChange} />
            </label>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm truncate">{usuario?.nombre || 'Cliente'}</p>
              <p className="text-xs text-gray-400 truncate">{usuario?.email}</p>
            </div>
          </div>
          {(() => {
            const ids = store.usuarioPerfil?.insigniasCliente || [];
            const insignias = ids.map(id => CATALOGO_INSIGNIAS_CLIENTE.find(b => b.id === id)).filter(Boolean);
            if (insignias.length === 0) return null;
            return (
              <div className="px-4 pb-2 flex flex-wrap gap-1">
                {insignias.map(ins => (
                  <span key={ins.id} title={ins.desc} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${ins.color}`}>
                    {ins.emoji} {ins.label}
                  </span>
                ))}
              </div>
            );
          })()}
          <button
            onClick={onLogout}
            className="w-full flex items-center space-x-2 px-4 py-2 text-gray-400 hover:text-white hover:bg-blue-800 rounded-lg transition text-sm"
          >
            <LogOut size={16} />
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </div>

      {/* Contenido Principal */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header móvil */}
        <div className="md:hidden flex items-center justify-between px-4 py-3 bg-blue-900 text-white flex-shrink-0">
          <button onClick={() => setSidebarAbierto(true)} className="p-2 rounded-lg hover:bg-gray-50">
            <Menu size={22} />
          </button>
          <span className="font-black text-orange-400 text-lg">Choyero!</span>
          <button onClick={abrirNotificaciones} className="relative p-2 rounded-lg hover:bg-gray-50">
            <Bell size={22} className="text-white" />
            {notifsPendientes.length > 0 && (
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold">
                {notifsPendientes.length}
              </span>
            )}
          </button>
        </div>
        {/* Banner: verificación de email pendiente */}
        {usuario?.emailVerificado === false && (
          <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-3 flex flex-wrap items-center justify-between gap-2 flex-shrink-0">
            <div className="flex items-center gap-2 text-sm text-yellow-800">
              <AlertCircle size={16} className="flex-shrink-0 text-yellow-600" />
              <span>Confirma tu dirección de email para asegurar tu cuenta. Si no te llegó, revisa tu carpeta de <strong>spam o correo no deseado</strong>.</span>
            </div>
            <button
              disabled={reenvioVerifLoading || reenvioVerifOk}
              onClick={async () => {
                setReenvioVerifLoading(true);
                try {
                  await apiResendVerification();
                  setReenvioVerifOk(true);
                } catch {
                  // silencioso — el usuario puede reintentar
                } finally {
                  setReenvioVerifLoading(false);
                }
              }}
              className="text-xs font-semibold px-3 py-1.5 rounded-lg border border-yellow-400 text-yellow-800 hover:bg-yellow-100 disabled:opacity-60 whitespace-nowrap"
            >
              {reenvioVerifOk ? '✓ Email enviado' : reenvioVerifLoading ? 'Enviando…' : 'Reenviar email'}
            </button>
          </div>
        )}

        <div className="flex-1 min-w-0 overflow-y-auto overflow-x-hidden p-4 pb-24 md:p-8">

        {/* DASHBOARD */}
        {seccion === 'dashboard' && (
          <div>
            <div className="flex flex-wrap justify-between items-center gap-3 mb-6 md:mb-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-800">¡Bienvenido, {usuario?.nombre?.split(' ')[0]}!</h2>
                <p className="text-gray-600 text-sm md:text-base">Gestiona tus envíos de carga en la Península de Baja California</p>
              </div>
              <div className="flex gap-3">
                {(store.plantillasRutas || []).filter(p => p.clienteId === usuario?.id).length > 0 && (
                  <button
                    onClick={() => setMostrarPlantillas(true)}
                    className="px-4 py-3 bg-white border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 flex items-center space-x-2 shadow"
                  >
                    <RotateCcw size={18} />
                    <span>Desde plantilla</span>
                  </button>
                )}
              </div>
            </div>

            {/* Estadísticas */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-500 text-sm">Solicitudes Activas</p>
                    <p className="text-3xl font-bold text-gray-800">{misSolicitudes.filter(s => ['cotizando', 'en_cotizacion', 'abierta'].includes(s.status)).length}</p>
                  </div>
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                    <FileText size={24} className="text-blue-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-500 text-sm">Viajes en Curso</p>
                    <p className="text-3xl font-bold text-gray-800">{viajesActivos.length}</p>
                  </div>
                  <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
                    <Truck size={24} className="text-orange-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-500 text-sm">Viajes Completados</p>
                    <p className="text-3xl font-bold text-gray-800">{historial.filter(h => !h.esCancelado).length}</p>
                  </div>
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                    <CheckCircle size={24} className="text-green-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-gray-500 text-sm font-semibold">Gasto en Fletes</p>
                  <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center">
                    <DollarSign size={20} className="text-blue-600" />
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between items-baseline">
                    <span className="text-xs text-gray-400">Hoy</span>
                    <span className="text-lg font-bold text-gray-800">${gastoHoy.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-baseline">
                    <span className="text-xs text-gray-400">Este mes</span>
                    <span className="text-2xl font-bold text-gray-800">${gastoMes.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-baseline border-t border-gray-200 pt-1 mt-1">
                    <span className="text-xs text-gray-400">Total histórico</span>
                    <span className="text-sm font-semibold text-gray-500">${gastoTotal.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Widget MLM — solo para referidores */}
            {usuario?.esReferidor && (() => {
              const misComisiones = (store.comisionesRed || []).filter(c => c.userId === usuario.id);
              if (!store.configPlataforma?.redMercadeo?.habilitada && misComisiones.length === 0) return null;
              const saldoDisp  = misComisiones.filter(c => c.status === 'disponible').reduce((s, c) => s + c.monto, 0);
              const enEspera   = misComisiones.filter(c => ['bloqueada','pendiente'].includes(c.status)).reduce((s, c) => s + c.monto, 0);
              const totalGanado = misComisiones.filter(c => ['disponible','pagada'].includes(c.status)).reduce((s, c) => s + c.monto, 0);
              const n1Count = (store.misReferidosN1 || store.misReferidos || []).length;
              const n2Count = (store.misReferidosN2 || []).length;
              const n3Count = (store.misReferidosN3 || []).length;
              const totalRed = n1Count + n2Count + n3Count;
              return (
                <div className="mb-8 bg-gradient-to-br from-indigo-50 to-purple-50 border border-indigo-100 rounded-2xl p-5 shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <span className="text-lg">🎁</span>
                      <h3 className="font-bold text-gray-800">Programa de Referidos</h3>
                    </div>
                    <button onClick={() => setSeccion('compartir')} className="text-xs text-indigo-600 font-semibold hover:underline">
                      Ver detalle →
                    </button>
                  </div>
                  <div className="grid grid-cols-3 gap-3 mb-4">
                    <div className="bg-white rounded-xl p-3 text-center shadow-sm border border-green-100">
                      <p className="text-xs text-gray-400 mb-1">Disponible</p>
                      <p className="text-xl font-black text-green-600">${saldoDisp.toLocaleString('es-MX')}</p>
                      <p className="text-xs text-gray-400">MXN</p>
                    </div>
                    <div className="bg-white rounded-xl p-3 text-center shadow-sm border border-yellow-100">
                      <p className="text-xs text-gray-400 mb-1">En espera</p>
                      <p className="text-xl font-black text-yellow-600">${enEspera.toLocaleString('es-MX')}</p>
                      <p className="text-xs text-gray-400">MXN</p>
                    </div>
                    <div className="bg-white rounded-xl p-3 text-center shadow-sm border border-blue-100">
                      <p className="text-xs text-gray-400 mb-1">Total ganado</p>
                      <p className="text-xl font-black text-blue-600">${totalGanado.toLocaleString('es-MX')}</p>
                      <p className="text-xs text-gray-400">MXN</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <p className="text-sm text-gray-600">
                      <span className="font-semibold text-gray-800">{totalRed}</span> personas en tu red
                      {n1Count > 0 && (
                        <span className="text-gray-400 ml-2">
                          · N1: {n1Count}{n2Count > 0 ? ` · N2: ${n2Count}` : ''}{n3Count > 0 ? ` · N3: ${n3Count}` : ''}
                        </span>
                      )}
                    </p>
                    {saldoDisp > 0 && (
                      <button
                        onClick={() => { setSeccion('compartir'); setAbrirRetiroDirecto(true); }}
                        className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-xl shadow transition-colors"
                      >
                        Solicitar retiro →
                      </button>
                    )}
                  </div>
                </div>
              );
            })()}

            {/* Widget de calificación del cliente */}
            {(() => {
              const cal = store.usuarioPerfil?.calificacion ?? usuario?.calificacion ?? null;
              const viajesTotal = historial.filter(h => !h.esCancelado).length;
              if (viajesTotal === 0) return null;
              return (
                <div className="bg-white rounded-xl shadow-lg p-5 mb-6 flex items-center gap-5">
                  <div className="w-14 h-14 bg-yellow-50 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Star size={28} className="text-yellow-400" fill="currentColor" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-gray-400 font-medium uppercase tracking-wide mb-0.5">Mi calificación como cliente</p>
                    <div className="flex items-baseline gap-2">
                      <span className="text-3xl font-black text-gray-800">{cal ? cal.toFixed(1) : '—'}</span>
                      <span className="text-sm text-gray-400">/ 5</span>
                    </div>
                    <div className="flex items-center gap-1 mt-1">
                      {[1,2,3,4,5].map(i => (
                        <Star key={i} size={14}
                          className={i <= Math.round(cal || 0) ? 'text-yellow-400' : 'text-gray-200'}
                          fill={i <= Math.round(cal || 0) ? 'currentColor' : 'none'} />
                      ))}
                      <span className="text-xs text-gray-400 ml-1">· {viajesTotal} viaje{viajesTotal !== 1 ? 's' : ''}</span>
                    </div>
                  </div>
                  {!cal && (
                    <p className="text-xs text-gray-400 text-right flex-shrink-0">Completa tu primer flete<br/>para obtener calificación</p>
                  )}
                </div>
              );
            })()}

            {/* Solicitudes pendientes de revisión */}
            {misSolicitudes.filter(s => ['cotizando', 'en_cotizacion', 'abierta'].includes(s.status) && (s.cotizaciones?.length ?? 0) > 0).length > 0 && (
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl shadow-lg p-6 mb-8 text-white">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="w-14 h-14 bg-white bg-opacity-20 rounded-xl flex items-center justify-center">
                      <Award size={28} />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold">¡Tienes cotizaciones pendientes!</h3>
                      <p className="text-blue-100">
                        {misSolicitudes.filter(s => ['cotizando', 'en_cotizacion', 'abierta'].includes(s.status) && (s.cotizaciones?.length ?? 0) > 0).length} solicitud(es) con ofertas de transportistas esperando tu decisión
                      </p>
                    </div>
                  </div>
                  <button 
                    onClick={() => setSeccion('solicitudes')}
                    className="px-6 py-3 bg-white text-blue-600 rounded-xl hover:bg-blue-50 font-semibold flex items-center space-x-2"
                  >
                    <span>Ver Cotizaciones</span>
                    <ArrowRight size={20} />
                  </button>
                </div>
              </div>
            )}

            {/* Viaje activo destacado */}
            {viajesActivos.length > 0 && (
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-4">Viaje en Curso</h3>
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-600">{viajesActivos[0].origen} → {viajesActivos[0].destino}</p>
                    <p className="font-semibold">{viajesActivos[0].transportista}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-500">ETA</p>
                    <p className="text-2xl font-bold text-blue-600">{viajesActivos[0].eta}</p>
                  </div>
                </div>
                <div className="mt-4">
                  <div className="flex justify-between text-sm mb-2">
                    <span className="text-gray-600">Progreso</span>
                    <span className="font-semibold">{viajesActivos[0].progreso}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3">
                    <div 
                      className="bg-blue-500 h-3 rounded-full transition-all" 
                      style={{ width: `${viajesActivos[0].progreso}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* MIS SOLICITUDES */}
        {seccion === 'solicitudes' && (
          <div>
            <div className="flex flex-wrap justify-between items-center gap-3 mb-2">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Mis Solicitudes</h2>
            </div>
            {(() => {
              const hintKey = `choyero_hint_sols_${usuario?.id}`;
              const hintVisto = typeof window !== 'undefined' && localStorage.getItem(hintKey);
              if (hintVisto || misSolicitudes.length === 0) return null;
              return (
                <div className="flex items-center gap-3 bg-blue-50 border border-blue-200 rounded-xl px-4 py-3 mb-4 text-sm text-blue-700">
                  <span className="text-lg">👆</span>
                  <span className="flex-1">Toca cualquier fila de la tabla para ver los detalles, cotizaciones recibidas y opciones de la solicitud.</span>
                  <button onClick={() => { localStorage.setItem(hintKey, '1'); window.dispatchEvent(new Event('choyero_sync')); }} className="text-blue-400 hover:text-blue-600 flex-shrink-0"><X size={16} /></button>
                </div>
              );
            })()}

            {misSolicitudes.length === 0 ? (
              <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                <FileText size={64} className="mx-auto text-gray-400 mb-4" />
                <h3 className="text-xl font-bold text-gray-800 mb-2">No tienes solicitudes</h3>
                <p className="text-gray-600 mb-6">Crea tu primera solicitud de flete y recibe cotizaciones de transportistas verificados</p>
                <button onClick={() => { setSolicitudParaRepetir(null); setOrigenCoords(null); setDestinoCoords(null); setMostrarFormulario(true); }} className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700">
                  Crear Solicitud
                </button>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase w-8"></th>
                      <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">ID</th>
                      <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ruta</th>
                      <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Carga</th>
                      <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Fecha</th>
                      <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Cotizaciones</th>
                      <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Estado</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {misSolicitudes.map(sol => {
                      const isExpanded = expandedSolicitud === sol.id;
                      const cotizacionesReales = (store.cotizaciones || []).filter(c => c.solicitudId === sol.id && c.status !== 'rechazada').length;
                      return (
                        <React.Fragment key={sol.id}>
                          {/* Fila compacta */}
                          <tr
                            id={`sol-${sol.id}`}
                            onClick={() => {
                              setExpandedSolicitud(isExpanded ? null : sol.id);
                              if (!isExpanded) localStorage.setItem(`choyero_hint_sols_${usuario?.id}`, '1');
                            }}
                            className={`cursor-pointer transition-colors ${isExpanded ? 'bg-blue-50' : 'hover:bg-blue-50'}`}
                          >
                            <td className="px-4 py-4 text-center">
                              <ChevronDown size={16} className={`mx-auto transition-transform ${isExpanded ? 'rotate-180 text-blue-600' : 'text-blue-400'}`} />
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              <p className="font-mono font-bold text-gray-800 text-sm">{sol.folio || sol.id.slice(0, 8).toUpperCase()}</p>
                            </td>
                            <td className="px-4 md:px-6 py-4">
                              <p className="text-sm font-medium text-gray-800">{sol.origen}</p>
                              <p className="text-xs text-gray-400">→ {sol.destino}</p>
                              {/* Info condensada solo en móvil */}
                              <div className="flex flex-wrap items-center gap-2 mt-1 md:hidden">
                                {cotizacionesReales > 0 ? (
                                  <span className="px-1.5 py-0.5 text-xs font-semibold rounded-full bg-green-100 text-green-700">{cotizacionesReales} cot.</span>
                                ) : (
                                  <span className="text-xs text-amber-500 flex items-center gap-1">
                                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse" />
                                    Esperando
                                  </span>
                                )}
                                <span className="text-xs text-gray-400">{sol.peso} t</span>
                              </div>
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              <p className="text-sm text-gray-600">{sol.descripcion || sol.carga}</p>
                              <p className="text-xs text-gray-400">{sol.peso} tons</p>
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              <p className="text-sm text-gray-600">
                                {(sol.creadoEn || sol.fechaCreacion || sol.fecha)
                                  ? new Date(sol.creadoEn || sol.fechaCreacion || sol.fecha).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                  : '—'}
                              </p>
                              {(sol.creadoEn || sol.fechaCreacion) && (
                                <p className="text-xs text-gray-400">
                                  {new Date(sol.creadoEn || sol.fechaCreacion).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
                                </p>
                              )}
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              {cotizacionesReales > 0 ? (
                                <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-700">
                                  {cotizacionesReales} recibidas
                                </span>
                              ) : (
                                <span className="text-xs text-gray-400 flex items-center gap-1">
                                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse" />
                                  Esperando...
                                </span>
                              )}
                            </td>
                            <td className="px-4 md:px-6 py-4">
                              <span className={`px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(sol.status)}`}>
                                {getStatusText(sol.status)}
                              </span>
                            </td>
                          </tr>

                          {/* Panel expandible */}
                          {isExpanded && (
                            <tr>
                              <td colSpan={7} className="bg-blue-50">
                                <div className="px-4 py-4 md:px-8 md:py-6">
                                  {/* Ruta detallada */}
                                  <div className="grid grid-cols-2 gap-4 mb-5">
                                    <div className="bg-white rounded-lg shadow p-4 border border-blue-100">
                                      <p className="text-xs text-gray-500 flex items-center mb-1"><MapPin size={12} className="mr-1" /> Origen</p>
                                      <p className="font-semibold text-gray-800">{sol.origen}</p>
                                    </div>
                                    <div className="bg-white rounded-lg shadow p-4 border border-blue-100">
                                      <p className="text-xs text-gray-500 flex items-center mb-1"><MapPin size={12} className="mr-1" /> Destino</p>
                                      <p className="font-semibold text-gray-800">{sol.destino}</p>
                                    </div>
                                  </div>

                                  {/* Detalle carga */}
                                  <div className="bg-white rounded-lg shadow p-4 border border-blue-100 mb-5">
                                    <div className="flex gap-6 text-sm flex-wrap">
                                      <div><p className="text-xs text-gray-500">Carga</p><p className="font-semibold">{sol.descripcion || sol.carga}</p></div>
                                      <div><p className="text-xs text-gray-500">Peso</p><p className="font-semibold">{sol.peso} tons</p></div>
                                      {sol.distancia && <div><p className="text-xs text-gray-500">Distancia</p><p className="font-semibold">{sol.distancia}</p></div>}
                                      <div>
                                        <p className="text-xs text-gray-500">Prioridad</p>
                                        <span className={`px-2 py-0.5 text-xs font-semibold rounded-full ${sol.prioridad === 'urgente' ? 'bg-red-100 text-red-700' : sol.prioridad === 'alta' ? 'bg-amber-100 text-amber-700' : 'bg-gray-100 text-gray-600'}`}>
                                          {sol.prioridad === 'urgente' ? 'Urgente' : sol.prioridad === 'alta' ? 'Alta' : 'Normal'}
                                        </span>
                                      </div>
                                      {sol.notas && <div className="flex-1"><p className="text-xs text-gray-500">Notas</p><p className="font-semibold text-blue-700">{sol.notas}</p></div>}
                                    </div>
                                  </div>


                                  {/* Cotizaciones / acciones */}
                                  {['cotizando', 'en_cotizacion', 'abierta'].includes(sol.status) && (() => {
                                    const msEsperando = (sol.fechaCreacion || sol.creadoEn) ? Date.now() - new Date(sol.fechaCreacion || sol.creadoEn).getTime() : 0;
                                    const hrsEsperando = Math.floor(msEsperando / 3600000);
                                    const minEsperando = Math.floor((msEsperando % 3600000) / 60000);
                                    const tiempoLabel = hrsEsperando > 0 ? `${hrsEsperando}h ${minEsperando}m` : `${minEsperando} min`;
                                    const vistas = (store.cotizaciones || []).filter(c => c.solicitudId === sol.id).length || sol.cotizaciones || 0;
                                    return (
                                    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                                      <div>
                                        {vistas > 0 ? (
                                          <>
                                            <p className="text-sm text-gray-600">
                                              <span className="font-bold text-blue-600">{vistas}</span> cotizaciones recibidas
                                            </p>
                                            <p className="text-xl font-bold text-green-600">
                                              Mejor oferta: ${sol.mejorOferta?.toLocaleString()} MXN
                                            </p>
                                          </>
                                        ) : (
                                          <div>
                                            <p className="text-gray-600 text-sm font-medium flex items-center gap-2">
                                              <span className="inline-block w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
                                              Esperando cotizaciones de transportistas...
                                            </p>
                                            {sol.fechaCreacion && (
                                              <p className="text-xs text-gray-400 mt-1">
                                                ⏱ Publicada hace <span className="font-semibold text-gray-500">{tiempoLabel}</span>
                                                {sol.vistas > 0 && <> · <span className="font-semibold text-gray-500">{sol.vistas} transportistas</span> la vieron</>}
                                              </p>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex flex-wrap gap-2">
                                        {vistas > 0 && (
                                          <button
                                            onClick={(e) => { e.stopPropagation(); verCotizaciones(sol); }}
                                            className="flex-1 md:flex-none px-5 py-2.5 bg-blue-600 text-white rounded-xl hover:bg-blue-700 font-semibold flex items-center justify-center space-x-2 text-sm"
                                          >
                                            <Eye size={16} />
                                            <span>Ver Cotizaciones</span>
                                          </button>
                                        )}
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (window.confirm('¿Editar esta solicitud?\n\nSi hay cotizaciones recibidas se eliminarán y los transportistas podrán cotizar de nuevo con los datos actualizados.')) {
                                              setSolicitudEditando(sol);
                                              setSolicitudParaRepetir(null);
                                              setOrigenCoords(sol.origenCoords || null);
                                              setDestinoCoords(sol.destinoCoords || null);
                                              setFotosFormulario(sol.fotos || []);
                                              setMostrarFormulario(true);
                                            }
                                          }}
                                          className="flex-1 md:flex-none px-4 py-2.5 border border-blue-300 text-blue-600 rounded-xl hover:bg-blue-50 font-semibold flex items-center justify-center gap-2 text-sm"
                                        >
                                          <Pencil size={15} />
                                          <span>Editar</span>
                                        </button>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setMotivoCancelacion('');
                                            setModalCancelarSolicitud({ sol });
                                          }}
                                          className="flex-1 md:flex-none px-4 py-2.5 border border-red-300 text-red-600 rounded-xl hover:bg-red-50 font-semibold flex items-center justify-center gap-2 text-sm"
                                        >
                                          <Trash2 size={15} />
                                          <span>Cancelar</span>
                                        </button>
                                      </div>
                                    </div>
                                    );
                                  })()}

                                  {sol.status === 'asignado' && (
                                    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                      <p className="text-purple-600 font-semibold flex items-center text-sm">
                                        <CheckCircle size={16} className="mr-2 flex-shrink-0" />
                                        Transportista asignado — Esperando inicio del viaje
                                      </p>
                                      <button
                                        onClick={(e) => { e.stopPropagation(); setSeccion('viajes'); }}
                                        className="w-full sm:w-auto px-6 py-2.5 bg-purple-600 text-white rounded-xl hover:bg-purple-700 font-semibold text-sm text-center"
                                      >
                                        Ver en Viajes
                                      </button>
                                    </div>
                                  )}

                                  {['aceptada', 'en_curso'].includes(sol.status) && (() => {
                                    const viajeSol = (store.viajes || []).find(v => v.solicitudId === sol.id);
                                    return (
                                      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                        <p className="text-green-700 font-semibold flex items-center gap-2 text-sm">
                                          <CheckCircle size={16} />
                                          {sol.status === 'en_curso' ? 'Viaje en curso' : 'Transportista confirmado'}
                                          {viajeSol?.transportistaNombre || viajeSol?.transportista
                                            ? ` · ${viajeSol.transportistaNombre || viajeSol.transportista}`
                                            : ''}
                                        </p>
                                        <div className="flex flex-wrap gap-2">
                                          {viajeSol && (
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                const _cm = { viajeId: viajeSol.id, contraparte: { id: viajeSol.transportistaId, nombre: viajeSol.transportistaNombre || viajeSol.transportista || 'Transportista', rol: 'transportista' } };
                                                chatModalRef.current = _cm; setChatModal(_cm);
                                                setUnreadByChatKey(prev => { const n = {...prev}; delete n[`${viajeSol.id}_transportista`]; delete n[`${viajeSol.id}_admin`]; return n; });
                                              }}
                                              className="flex-1 sm:flex-none relative flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-purple-300 text-purple-700 hover:bg-purple-50 font-semibold text-sm"
                                            >
                                              <MessageCircle size={15} />
                                              Chat con {viajeSol.transportistaNombre || viajeSol.transportista || 'Transportista'}
                                              {((unreadByChatKey[`${viajeSol.id}_transportista`] || 0) + (unreadByChatKey[`${viajeSol.id}_admin`] || 0)) > 0 && (
                                                <span className="ml-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                                                  {((unreadByChatKey[`${viajeSol.id}_transportista`] || 0) + (unreadByChatKey[`${viajeSol.id}_admin`] || 0)) > 9 ? '9+' : (unreadByChatKey[`${viajeSol.id}_transportista`] || 0) + (unreadByChatKey[`${viajeSol.id}_admin`] || 0)}
                                                </span>
                                              )}
                                            </button>
                                          )}
                                          <button
                                            onClick={(e) => { e.stopPropagation(); setSeccion('viajes'); }}
                                            className="flex-1 sm:flex-none px-4 py-2.5 bg-green-600 text-white rounded-xl hover:bg-green-700 font-semibold text-sm text-center"
                                          >
                                            Ver Viaje
                                          </button>
                                        </div>
                                      </div>
                                    );
                                  })()}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* VIAJES ACTIVOS */}
        {seccion === 'viajes' && (
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Viajes Activos</h2>
            <p className="text-gray-500 text-sm mb-5">Monitorea el progreso de tus envíos. Haz clic en una fila para ver los detalles.</p>

            {viajesActivos.length === 0 ? (
              <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                <Truck size={64} className="mx-auto text-gray-400 mb-4" />
                <h3 className="text-xl font-bold text-gray-800 mb-2">No hay viajes activos</h3>
                <p className="text-gray-600">Cuando selecciones un transportista, tus viajes aparecerán aquí</p>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase w-8"></th>
                      <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">ID</th>
                      <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ruta</th>
                      <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Transportista</th>
                      <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Progreso</th>
                      <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">ETA</th>
                      <th className="px-4 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Estado</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {viajesActivos.map(viaje => {
                      void tickMinuto; // reactiva el timer de 60s para ETAs
                      const isExpanded = expandedViaje === viaje.id;
                      const unreadTransportista = (unreadByChatKey[`${viaje.id}_transportista`] || 0) + (unreadByChatKey[`${viaje.id}_admin`] || 0);
                      const progreso = viaje.progreso ?? 0;
                      const PROGRESO_ORDEN = { en_camino_recogida: 10, cargando: 25, en_ruta: 50, llegada_destino: 75, descargando: 90, completada: 100 };
                      const isCompleted = (s) => progreso >= (PROGRESO_ORDEN[s] ?? 101);
                      const etapas = [
                        { label: 'Pago realizado',     completado: viaje.status !== 'pendiente_pago' },
                        { label: 'Chofer en camino',   completado: isCompleted('en_camino_recogida') },
                        { label: 'Recogiendo carga',   completado: isCompleted('cargando') },
                        { label: 'En ruta',            completado: isCompleted('en_ruta') },
                        { label: 'En destino',         completado: isCompleted('llegada_destino') },
                        { label: 'Entregado',          completado: isCompleted('completada') },
                      ];
                      const lastCompletedIdx = etapas.reduce((acc, e, i) => e.completado ? i : acc, 0);
                      const barWidth = Math.round((lastCompletedIdx / (etapas.length - 1)) * 100);
                      const necesitaAccion = viaje.status === 'completada' || viaje.status === 'entrega_confirmada';

                      const colorActivo = necesitaAccion
                        ? 'bg-green-50 hover:bg-green-100 border-l-4 border-green-500'
                        : progreso >= 50
                          ? 'bg-blue-50 hover:bg-blue-100 border-l-4 border-blue-500'
                          : 'bg-yellow-50 hover:bg-yellow-100 border-l-4 border-yellow-400';

                      return (
                        <React.Fragment key={viaje.id}>
                          {/* Fila compacta */}
                          <tr
                            id={`viaje-${viaje.id}`}
                            onClick={() => setExpandedViaje(isExpanded ? null : viaje.id)}
                            className={`cursor-pointer transition-colors ${isExpanded ? 'bg-blue-100 border-l-4 border-blue-600' : colorActivo}`}
                          >
                            <td className="px-4 py-4 text-center">
                              <ChevronDown size={16} className={`text-gray-400 transition-transform mx-auto ${isExpanded ? 'rotate-180' : ''}`} />
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              <p className="font-mono font-bold text-gray-800 text-sm">{viaje.folio || viaje.id.slice(0, 8).toUpperCase()}</p>
                              {necesitaAccion && (
                                <span className="inline-block w-2 h-2 rounded-full bg-amber-400 mt-1" title="Requiere acción" />
                              )}
                            </td>
                            <td className="px-4 md:px-6 py-4">
                              <p className="text-sm font-medium text-gray-800">{viaje.origen}</p>
                              <p className="text-xs text-gray-400">→ {viaje.destino}</p>
                              {/* Transportista condensado solo en móvil */}
                              <p className="text-xs text-gray-500 mt-0.5 md:hidden">{viaje.empresa?.nombre || viaje.transportista || viaje.transportistaNombre}</p>
                            </td>
                            <td className="hidden md:table-cell px-6 py-4 text-sm text-gray-600">{viaje.empresa?.nombre || viaje.transportista || viaje.transportistaNombre}</td>
                            <td className="px-4 md:px-6 py-4">
                              <div className="flex items-center gap-2">
                                <div className="w-16 md:w-24 bg-gray-200 rounded-full h-1.5">
                                  <div className="bg-blue-500 h-1.5 rounded-full transition-all" style={{ width: `${progreso}%` }} />
                                </div>
                                <span className="text-xs font-semibold text-blue-600">{progreso}%</span>
                              </div>
                            </td>
                            <td className="hidden md:table-cell px-6 py-4">
                              {viaje.eta ? (
                                <p className="text-sm font-semibold text-blue-600">{viaje.eta}</p>
                              ) : (
                                <p className="text-sm text-gray-400">—</p>
                              )}
                              {viaje.fechaCreacion && ['asignada','en_proceso','en_camino_recogida','cargando','en_ruta','llegada_destino','descargando'].includes(viaje.status) && (() => {
                                const msViaje = Date.now() - new Date(viaje.fechaCreacion).getTime();
                                const hrsViaje = Math.floor(msViaje / 3600000);
                                const minViaje = Math.floor((msViaje % 3600000) / 60000);
                                const label = hrsViaje > 0 ? `${hrsViaje}h ${minViaje}m` : `${minViaje} min`;
                                return <p className="text-xs text-gray-400 mt-0.5" title="Tiempo transcurrido desde inicio">⏱ {label}</p>;
                              })()}
                            </td>
                            <td className="px-4 md:px-6 py-4">
                              <span className={`px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(viaje.status)}`}>
                                {getStatusText(viaje.status)}
                              </span>
                            </td>
                          </tr>

                          {/* Panel expandible */}
                          {isExpanded && (
                            <tr>
                              <td colSpan={7} className="bg-blue-50">
                                <div className="px-4 py-4 md:px-8 md:py-6">
                                  {/* Info carga + chofer */}
                                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5">
                                    {[
                                      { label: 'Carga',   val: viaje.solicitud?.descripcion || viaje.carga || viaje.retorno?.ofertas?.[0]?.descripcion || (viaje.retornoId ? 'Flete retorno' : undefined) },
                                      { label: 'Peso',    val: (() => { const p = viaje.solicitud?.peso ?? viaje.peso ?? viaje.retorno?.ofertas?.[0]?.peso; return p != null ? `${p} tons` : undefined; })() },
                                      { label: 'Chofer',  val: viaje.choferNombre || (viaje.ordenesChofer||[])[0]?.choferNombre || viaje.chofer || 'Por asignar' },
                                      { label: 'Unidad',  val: viaje.cotizacion?.unidadOfrecida || viaje.solicitud?.tipoVehiculo || viaje.retorno?.tipoVehiculo || viaje.unidad, mono: true },
                                    ].map(({ label, val, mono }) => (
                                      <div key={label} className="bg-white rounded-lg shadow p-3 border border-blue-100">
                                        <p className="text-xs text-gray-500">{label}</p>
                                        <p className={`font-semibold text-sm mt-0.5 ${mono ? 'font-mono' : ''}`}>{val || '—'}</p>
                                      </div>
                                    ))}
                                  </div>

                                  {/* Checkpoints */}
                                  <div className="mb-5">
                                    <div className="flex justify-between text-xs text-gray-500 mb-1">
                                      <span className="font-medium">Progreso del viaje</span>
                                      <span className="font-bold text-blue-600">{progreso}%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2 mb-3">
                                      <div className="bg-gradient-to-r from-blue-500 to-blue-600 h-2 rounded-full transition-all" style={{ width: `${barWidth}%` }} />
                                    </div>
                                    <div className="flex items-start justify-between">
                                      {etapas.map((etapa, idx) => (
                                        <div key={idx} className="flex flex-col items-center flex-1">
                                          <div className={`w-7 h-7 rounded-full flex items-center justify-center mb-1 ${etapa.completado ? 'bg-blue-600' : 'bg-gray-200'}`}>
                                            {etapa.completado
                                              ? <CheckCircle size={14} className="text-white" />
                                              : <span className="text-gray-400 text-xs">{idx + 1}</span>}
                                          </div>
                                          <p className={`text-center leading-tight ${etapa.completado ? 'text-blue-700 font-semibold' : 'text-gray-400'}`} style={{ fontSize: '10px' }}>
                                            {etapa.label}
                                          </p>
                                        </div>
                                      ))}
                                    </div>
                                  </div>

                                  {/* Reintentar pago — cuando el viaje quedó pendiente de pago */}
                                  {viaje.status === 'pendiente_pago' && (
                                    speiPendienteViajeId === viaje.id ? (
                                      <div className="bg-amber-50 border-2 border-amber-400 rounded-xl p-4 mb-4">
                                        <div className="flex items-center space-x-3">
                                          <span className="text-2xl flex-shrink-0">🏦</span>
                                          <div>
                                            <p className="font-semibold text-amber-800 text-sm">Transferencia SPEI en proceso</p>
                                            <p className="text-xs text-amber-700 mt-0.5">Tu transferencia fue iniciada. La confirmación llega automáticamente en unos minutos — no necesitas hacer nada más.</p>
                                            <p className="text-xs text-amber-600 mt-1">Si no se confirma en 24 horas, contacta a tu banco o intenta con otro método de pago.</p>
                                          </div>
                                        </div>
                                        <button
                                          onClick={() => setSpeiPendienteViajeId(null)}
                                          className="mt-3 text-xs text-amber-600 underline hover:text-amber-800"
                                        >
                                          Pagar con otro método
                                        </button>
                                      </div>
                                    ) : (
                                      <div className="bg-blue-50 border-2 border-blue-400 rounded-xl p-4 mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                        <div className="flex items-center space-x-3">
                                          <CreditCard size={20} className="text-blue-600 flex-shrink-0" />
                                          <div>
                                            <p className="font-semibold text-blue-800 text-sm">Pago pendiente</p>
                                            <p className="text-xs text-blue-600">Completa el pago para activar tu flete.</p>
                                          </div>
                                        </div>
                                        <button
                                          onClick={async (e) => {
                                            e.stopPropagation();
                                            try {
                                              const resultado = await apiCrearPreferenciaMercadoPago(viaje.id);
                                              if (resultado.bypass) { await recargar(); return; }
                                              try { sessionStorage.setItem('choyero_viaje_pago', viaje.id); } catch (_) {}
                                              const url = resultado.paymentUrl || (process.env.NODE_ENV === 'production' ? resultado.initPoint : resultado.sandboxInitPoint);
                                              window.location.href = url;
                                            } catch (err) {
                                              mostrarNotificacion(err.message || 'Error al generar el pago', 'error');
                                            }
                                          }}
                                          className="w-full sm:w-auto px-5 py-2.5 bg-blue-600 text-white rounded-xl hover:bg-blue-700 font-semibold flex items-center justify-center space-x-2 text-sm"
                                        >
                                          <CreditCard size={15} />
                                          <span>Pagar con MercadoPago</span>
                                        </button>
                                      </div>
                                    )
                                  )}

                                  {/* Cancelar viaje — solo si aún no comenzó el trayecto */}
                                  {['pendiente_pago', 'activo'].includes(viaje.status) && (
                                    <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                      <div className="flex items-center space-x-3">
                                        <XCircle size={20} className="text-red-500 flex-shrink-0" />
                                        <div>
                                          <p className="font-semibold text-red-800 text-sm">¿Necesitas cancelar?</p>
                                          <p className="text-xs text-red-600">Solo puedes cancelar antes de que el chofer inicie el trayecto.</p>
                                        </div>
                                      </div>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const precioTotal = viaje.precio || viaje.costoFinal || viaje.costo || 0;
                                          // El escrow de MercadoPago solo retiene lo realmente cobrado: en dos_pagos
                                          // es el 50% de anticipo, no el precio total del flete (igual que el backend
                                          // en POST /viajes/:id/cancelar — montoCobradoReal).
                                          const montoCobrado = viaje.flujoPago === 'dos_pagos' ? parseFloat((precioTotal * 0.5).toFixed(2)) : precioTotal;
                                          setCancelarViajeModal({ id: viaje.id, origen: viaje.origen, destino: viaje.destino, monto: montoCobrado, tieneEscrow: viaje.status === 'activo' });
                                          setCancelarMotivo('');
                                        }}
                                        className="w-full sm:w-auto px-4 py-2 bg-red-100 text-red-700 border border-red-300 rounded-xl hover:bg-red-200 font-semibold text-sm flex items-center justify-center space-x-2"
                                      >
                                        <XCircle size={15} />
                                        <span>Cancelar viaje</span>
                                      </button>
                                    </div>
                                  )}

                                  {/* Confirmar entrega — visible ANTES de las evidencias */}
                                  {viaje.status === 'completada' && (
                                    <div className="bg-green-50 border-2 border-green-400 rounded-xl p-4 mb-4">
                                      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                        <div className="flex items-center space-x-3">
                                          <CheckCircle size={22} className="text-green-600 flex-shrink-0" />
                                          <div>
                                            <p className="font-semibold text-green-800">El chofer reportó la entrega</p>
                                            <p className="text-sm text-green-600">¿Confirmas que recibiste tu carga correctamente?</p>
                                          </div>
                                        </div>
                                        <button
                                          onClick={(e) => { e.stopPropagation(); setConfirmarEntregaViajeId(viaje.id); }}
                                          className="w-full sm:w-auto px-5 py-2.5 bg-green-600 text-white rounded-xl hover:bg-green-700 font-semibold flex items-center justify-center space-x-2 text-sm"
                                        >
                                          <CheckCircle size={16} />
                                          <span>Confirmar de Recibido</span>
                                        </button>
                                      </div>
                                    </div>
                                  )}

                                  {/* Evidencias y firma del chofer */}
                                  {((viaje.evidenciasEntrega || []).length > 0 || viaje.firmaEntrega) && (
                                    <div className="mb-5 rounded-xl border border-green-200 bg-green-50 p-4">
                                      <p className="text-sm font-bold text-green-700 mb-3">📸 Evidencias de entrega</p>
                                      {(viaje.evidenciasEntrega || []).length > 0 && (
                                        <div className="flex gap-3 flex-wrap mb-3">
                                          {(viaje.evidenciasEntrega || []).map((ev, i) => (
                                            <div key={i} className="text-center">
                                              <img src={ev.url || ev.base64} alt={ev.nombre} className="w-20 h-20 object-cover rounded-xl border border-green-200 cursor-pointer hover:opacity-80 transition-opacity" onClick={e => { e.stopPropagation(); setFotoLightbox(ev.url || ev.base64); }} title="Ver en grande" />
                                              <p className="text-xs text-gray-500 mt-1">{ev.nombre}</p>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                      {viaje.firmaEntrega && (
                                        <div className={`${(viaje.evidenciasEntrega || []).length > 0 ? 'border-t border-green-200 pt-3' : ''}`}>
                                          <p className="text-xs font-semibold text-green-700 mb-2">✍️ Firma de recepción</p>
                                          <img src={viaje.firmaEntrega} alt="Firma" className="w-full max-w-xs h-24 object-contain bg-white rounded-lg shadow border-green-200 px-2 cursor-pointer hover:opacity-80 transition-opacity" onClick={e => { e.stopPropagation(); setFotoLightbox(viaje.firmaEntrega); }} title="Ver en grande" />
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  {/* Calificar */}
                                  {viaje.status === 'entrega_confirmada' && (
                                    <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                      <div className="flex items-center space-x-3">
                                        <Star size={22} className="text-yellow-500" fill="currentColor" />
                                        <div>
                                          <p className="font-semibold text-yellow-800">¡Entrega confirmada!</p>
                                          <p className="text-sm text-yellow-600">Califica el servicio para ayudar a otros usuarios</p>
                                        </div>
                                      </div>
                                      <button
                                        onClick={(e) => { e.stopPropagation(); setCalificacionLocal(0); setComentarioLocal(''); setMostrarCalificar({ id: viaje.id, ruta: `${viaje.origen} → ${viaje.destino}`, transportista: viaje.transportistaNombre, transportistaId: viaje.transportistaId, choferId: viaje.choferId }); }}
                                        className="w-full sm:w-auto px-5 py-2.5 bg-yellow-500 text-white rounded-xl hover:bg-yellow-600 font-semibold flex items-center justify-center space-x-2 text-sm"
                                      >
                                        <Star size={16} />
                                        <span>Calificar Servicio</span>
                                      </button>
                                    </div>
                                  )}

                                  {/* Solicitar factura — viajes confirmados */}
                                  {(viaje.status === 'confirmado' || viaje.status === 'entrega_confirmada') && (
                                    viaje.solicitudFactura ? (
                                      <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 mb-4 flex items-center gap-3 text-sm text-blue-700">
                                        <FileCheck size={16} className="flex-shrink-0" />
                                        {viaje.solicitudFactura.status === 'subida' ? (
                                          <div className="flex flex-wrap items-center justify-between flex-1 gap-2">
                                            <span>✅ Factura disponible</span>
                                            <div className="flex gap-2">
                                              <a href={viaje.solicitudFactura.pdfUrl} download={`factura-${viaje.id}.pdf`}
                                                className="px-3 py-1 bg-blue-600 text-white text-xs font-semibold rounded-lg hover:bg-blue-700">
                                                PDF
                                              </a>
                                              {viaje.solicitudFactura.xmlUrl && (
                                                <a href={viaje.solicitudFactura.xmlUrl} download={`factura-${viaje.id}.xml`}
                                                  className="px-3 py-1 bg-indigo-600 text-white text-xs font-semibold rounded-lg hover:bg-indigo-700">
                                                  XML
                                                </a>
                                              )}
                                            </div>
                                          </div>
                                        ) : (
                                          <span>Solicitud de factura enviada — en espera del transportista</span>
                                        )}
                                      </div>
                                    ) : (
                                      <div className="mb-4">
                                        <button
                                          onClick={(e) => { e.stopPropagation(); const uF = store.usuarioPerfil?.id === usuario?.id ? { ...usuario, ...store.usuarioPerfil } : usuario; setFormSolicitarFactura({ rfcReceptor: uF?.rfc || '', nombreReceptor: uF?.razonSocial || uF?.nombre || '', regimenFiscal: uF?.regimenFiscal || '', cpFiscal: uF?.cpFiscal || '', usoCfdi: uF?.usoCfdi || 'S01', notas: '' }); setModalSolicitarFactura({ viajeId: viaje.id, viaje }); }}
                                          className="flex items-center gap-2 px-4 py-2 border border-blue-300 text-blue-700 bg-blue-50 rounded-xl hover:bg-blue-100 text-sm font-semibold"
                                        >
                                          <FileCheck size={15} />
                                          <span>Solicitar Factura</span>
                                        </button>
                                      </div>
                                    )
                                  )}

                                  {/* Contacto en destino + Carta Porte en una fila */}
                                  <div className="flex flex-col md:flex-row gap-3 mb-4">
                                  <div className="flex-1">
                                    {editandoContacto === viaje.id ? (
                                      <div className="bg-orange-50 border border-orange-200 rounded-xl p-4">
                                        <p className="text-sm font-bold text-orange-800 mb-3 flex items-center gap-2"><Phone size={15} /> Contacto en destino</p>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                          <div>
                                            <label className="text-xs font-semibold text-gray-600 mb-1 block">Nombre de quien recibe *</label>
                                            <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-orange-400 focus:outline-none" value={contactoForm.contactoDestino} onChange={e => setContactoForm(f => ({ ...f, contactoDestino: e.target.value }))} placeholder="Ej: Juan García / Almacén Central" />
                                          </div>
                                          <div>
                                            <label className="text-xs font-semibold text-gray-600 mb-1 block">Teléfono de contacto</label>
                                            <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-orange-400 focus:outline-none" value={contactoForm.telefonoDestino} onChange={e => setContactoForm(f => ({ ...f, telefonoDestino: e.target.value.replace(/\D/g, '').slice(0, 10) }))} maxLength={10} inputMode="numeric" placeholder="6641234567" />
                                          </div>
                                        </div>
                                        <div className="flex gap-2 mt-3 justify-end">
                                          <button onClick={() => setEditandoContacto(null)} className="px-4 py-1.5 text-xs border border-gray-300 rounded-lg bg-white text-gray-600 hover:bg-gray-50">Cancelar</button>
                                          <button
                                            disabled={guardandoContacto || !contactoForm.contactoDestino}
                                            onClick={async () => {
                                              setGuardandoContacto(true);
                                              try {
                                                await apiGuardarContactoDestino(viaje.id, contactoForm);
                                                recargar();
                                                setEditandoContacto(null);
                                                mostrarNotificacion('Contacto guardado correctamente', 'success');
                                              } catch (e) {
                                                mostrarNotificacion(e.message || 'Error al guardar', 'error');
                                              } finally { setGuardandoContacto(false); }
                                            }}
                                            className="px-4 py-1.5 text-xs bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-semibold disabled:opacity-50"
                                          >{guardandoContacto ? 'Guardando...' : 'Guardar'}</button>
                                        </div>
                                      </div>
                                    ) : viaje.contactoDestino ? (
                                      <div className="bg-orange-50 border border-orange-200 rounded-xl p-3 flex items-center justify-between">
                                        <div className="flex items-center gap-2 text-sm">
                                          <Phone size={15} className="text-orange-600" />
                                          <span className="font-semibold text-orange-800">{viaje.contactoDestino}</span>
                                          {viaje.telefonoDestino && <span className="text-orange-600">· {viaje.telefonoDestino}</span>}
                                        </div>
                                        <button onClick={(e) => { e.stopPropagation(); setContactoForm({ contactoDestino: viaje.contactoDestino, telefonoDestino: viaje.telefonoDestino || '' }); setEditandoContacto(viaje.id); }} className="text-xs text-orange-600 hover:underline">Editar</button>
                                      </div>
                                    ) : (
                                      <button
                                        onClick={(e) => { e.stopPropagation(); setContactoForm({ contactoDestino: '', telefonoDestino: '' }); setEditandoContacto(viaje.id); }}
                                        className="w-full py-3 px-4 border-2 border-dashed border-orange-300 rounded-xl text-orange-600 hover:bg-orange-50 text-sm font-semibold flex items-center justify-center gap-2 transition"
                                      >
                                        <Phone size={16} /> Agregar contacto en destino (para el chofer)
                                      </button>
                                    )}
                                  </div>

                                  {/* Carta Porte */}
                                  <div className="flex-1">
                                    {viaje.cartaPorte ? (
                                      <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4">
                                        <div className="flex items-center justify-between mb-3">
                                          <p className="text-sm font-bold text-indigo-800 flex items-center gap-2">
                                            <FileText size={16} /> Carta Porte registrada
                                          </p>
                                          <button onClick={(e) => { e.stopPropagation(); const cp = viaje.cartaPorte; const cpNorm = { ...cp, mercancias: Array.isArray(cp.mercancias) ? cp.mercancias : [cp.mercancias], operador: cp.operador || { nombre: '', licencia: '', curp: '' }, vehiculo: cp.vehiculo || { placas: '', configuracion: '', descripcion: '', numeroRemolque: '', numEconomico: '' } }; setCartaPorteForm(JSON.parse(JSON.stringify(cpNorm))); setModalCartaPorte({ viajeId: viaje.id, cartaPorte: cpNorm }); }} className="text-xs text-indigo-600 hover:underline">Editar</button>
                                        </div>
                                        <div className="grid grid-cols-3 gap-3 text-xs text-gray-600">
                                          <div><p className="font-semibold text-gray-500">Mercancías</p><p>{Array.isArray(viaje.cartaPorte.mercancias) ? `${viaje.cartaPorte.mercancias.length} producto(s)` : (viaje.cartaPorte.mercancias?.descripcion || '—')}</p></div>
                                          <div><p className="font-semibold text-gray-500">Remitente</p><p>{viaje.cartaPorte.remitente?.nombre || '—'}</p></div>
                                          <div><p className="font-semibold text-gray-500">Destinatario</p><p>{viaje.cartaPorte.destinatario?.nombre || '—'}</p></div>
                                        </div>
                                      </div>
                                    ) : (
                                      <button
                                        onClick={(e) => { e.stopPropagation(); const uF = store.usuarioPerfil?.id === usuario?.id ? { ...usuario, ...store.usuarioPerfil } : usuario; const ord0 = (viaje.ordenesChofer || [])[0]; setCartaPorteForm({ mercancias: [{ descripcion: '', claveSAT: '', pesoKg: '', unidadMedida: 'KGM', tipoEmbalaje: 'AT', cantidad: '', valorDeclarado: '' }], remitente: { nombre: uF?.razonSocial || uF?.nombre || '', rfc: uF?.rfc || '', calle: '', numero: '', colonia: '', municipio: '', estado: '', cp: uF?.cpFiscal || '' }, destinatario: { nombre: '', rfc: '', calle: '', numero: '', colonia: '', municipio: '', estado: '', cp: '' }, operador: { nombre: ord0?.choferNombre || '', licencia: '', curp: '' }, vehiculo: { placas: '', configuracion: '', descripcion: ord0?.unidadLabel || '', numeroRemolque: '', numEconomico: '' } }); setModalCartaPorte({ viajeId: viaje.id, cartaPorte: null }); }}
                                        className="w-full py-3 px-4 border-2 border-dashed border-indigo-300 rounded-xl text-indigo-600 hover:bg-indigo-50 text-sm font-semibold flex items-center justify-center gap-2 transition"
                                      >
                                        <FileText size={16} /> Registrar datos de Carta Porte
                                      </button>
                                    )}
                                  </div>
                                  </div>{/* fin flex contacto + carta porte */}

                                  {/* Acciones */}
                                  {viaje.transportistaId && viaje.status !== 'cancelado' && (
                                    <div className="flex flex-wrap gap-3">
                                      {viaje.transportistaId && (
                                        <button
                                          onClick={(e) => { e.stopPropagation(); const _cm = { viajeId: viaje.id, contraparte: { id: viaje.transportistaId, nombre: viaje.transportistaNombre || viaje.transportista || 'Transportista', rol: 'transportista' } }; chatModalRef.current = _cm; setChatModal(_cm); setUnreadByChatKey(prev => { const n = {...prev}; delete n[`${viaje.id}_transportista`]; delete n[`${viaje.id}_admin`]; return n; }); setLastSeenMessages(prev => { const next = {...prev, [viaje.id]: new Date().toISOString()}; sessionStorage.setItem(_chatSeenKey, JSON.stringify(next)); return next; }); }}
                                          className="relative flex items-center space-x-2 px-4 py-2.5 rounded-xl border border-purple-300 text-purple-700 hover:bg-purple-50 font-medium text-sm"
                                        >
                                          <MessageCircle size={16} />
                                          <span>Chat con {viaje.transportistaNombre || viaje.transportista || 'Transportista'}</span>
                                          {unreadTransportista > 0 && (
                                            <span className="ml-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">{unreadTransportista > 9 ? '9+' : unreadTransportista}</span>
                                          )}
                                        </button>
                                      )}
                                      {(viaje.choferNombre || viaje.chofer || (viaje.ordenesChofer||[])[0]?.choferNombre) && viaje.status !== 'pendiente_asignar' && (
                                        <button
                                          onClick={(e) => { e.stopPropagation(); setVerMapaViajeId(verMapaViajeId === viaje.id ? null : viaje.id); }}
                                          className={`flex items-center space-x-2 px-4 py-2.5 rounded-xl border font-medium text-sm transition-colors ${verMapaViajeId === viaje.id ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-300 hover:bg-blue-50'}`}
                                        >
                                          <Navigation size={16} />
                                          <span>{verMapaViajeId === viaje.id ? 'Ocultar GPS' : 'Ver GPS del chofer'}</span>
                                        </button>
                                      )}
                                      {(viaje.choferNombre || viaje.chofer || (viaje.ordenesChofer||[])[0]?.choferNombre) && viaje.status !== 'pendiente_asignar' && (() => {
                                        const org = viaje.origenCoords ? `${viaje.origenCoords.lat},${viaje.origenCoords.lng}` : encodeURIComponent(viaje.origen);
                                        const dst = viaje.destinoCoords ? `${viaje.destinoCoords.lat},${viaje.destinoCoords.lng}` : encodeURIComponent(viaje.destino);
                                        return (
                                          <a
                                            href={`https://www.google.com/maps/dir/?api=1&origin=${org}&destination=${dst}&travelmode=driving`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                            className="flex items-center space-x-2 px-4 py-2.5 rounded-xl border border-green-300 text-green-700 hover:bg-green-50 font-medium text-sm"
                                          >
                                            <MapPin size={16} />
                                            <span>Abrir en Maps</span>
                                          </a>
                                        );
                                      })()}
                                    </div>
                                  )}

                                  {/* Reportar problema / Ver respuesta soporte */}
                                  {viaje.status !== 'pendiente_pago' && (
                                    <div className="mt-2 flex flex-wrap gap-3 items-center">
                                      <button
                                        onClick={(e) => { e.stopPropagation(); setModalTicket({ viajeId: viaje.id, origen: viaje.origen, destino: viaje.destino }); setTicketTipo(''); setTicketDescripcion(''); }}
                                        className="flex items-center gap-2 text-sm text-red-600 hover:text-red-800 underline underline-offset-2"
                                      >
                                        <AlertCircle size={14} /> Reportar un problema con este viaje
                                      </button>
                                      {viajesConTicket.includes(viaje.id) && (
                                        <button
                                          onClick={(e) => { e.stopPropagation(); const _cm = { viajeId: viaje.id, contraparte: { id: 'admin', nombre: 'Soporte Choyero', rol: 'admin' } }; chatModalRef.current = _cm; setChatModal(_cm); }}
                                          className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800 font-medium bg-blue-50 border border-blue-200 px-3 py-1.5 rounded-lg"
                                        >
                                          💬 Ver respuesta de soporte
                                        </button>
                                      )}
                                    </div>
                                  )}

                                  {/* Mapa GPS */}
                                  {(viaje.choferNombre || viaje.chofer || (viaje.ordenesChofer||[])[0]?.choferNombre) && verMapaViajeId === viaje.id && (() => {
                                    const ordenActiva = (viaje.ordenesChofer||[])[0];
                                    const ordenViajeId = ordenActiva?.id;
                                    const liveGps = choferGpsLive[viaje.id] || (ordenViajeId ? choferGpsLive[ordenViajeId] : null);
                                    const ultimaPos = ordenActiva?.ultimaLat && ordenActiva?.ultimaLng
                                      ? { lat: ordenActiva.ultimaLat, lng: ordenActiva.ultimaLng, en: ordenActiva.ultimaPosicionEn }
                                      : null;
                                    const choferGps = liveGps
                                      ? { lat: liveGps.lat, lng: liveGps.lng }
                                      : ultimaPos ? { lat: ultimaPos.lat, lng: ultimaPos.lng } : null;
                                    const tieneCoords = viaje.origenCoords || viaje.destinoCoords || choferGps;
                                    const tiempoRelativo = (fecha) => {
                                      if (!fecha) return '';
                                      const mins = Math.floor((Date.now() - new Date(fecha)) / 60000);
                                      if (mins < 1) return 'hace un momento';
                                      if (mins < 60) return `hace ${mins} min`;
                                      const hrs = Math.floor(mins / 60);
                                      return hrs < 24 ? `hace ${hrs}h` : `hace ${Math.floor(hrs/24)}d`;
                                    };
                                    if (!tieneCoords) return (
                                      <div className="mt-4 rounded-xl border border-blue-200 bg-blue-50 p-4 text-sm text-blue-700">
                                        <p className="font-semibold mb-1">📡 Esperando señal GPS del chofer...</p>
                                        <p className="text-xs text-blue-500">El chofer debe iniciar la orden desde su app para activar el GPS.</p>
                                      </div>
                                    );
                                    return (
                                      <div className="rounded-xl overflow-hidden border border-blue-200 mt-4">
                                        <ViajeMapView
                                          origenCoords={viaje.origenCoords}
                                          destinoCoords={viaje.destinoCoords}
                                          progreso={progreso}
                                          choferGps={choferGps}
                                          choferNombre={viaje.choferNombre || viaje.chofer}
                                        />
                                        <div className="bg-gray-50 px-4 py-2 flex gap-6 text-xs text-gray-600">
                                          {viaje.origenCoords && <span><span className="font-semibold text-green-700">📦</span> {viaje.origenCoords.direccion || viaje.origen}</span>}
                                          {viaje.destinoCoords && <span><span className="font-semibold text-red-600">🏁</span> {viaje.destinoCoords.direccion || viaje.destino}</span>}
                                        </div>
                                        {liveGps
                                          ? <div className="bg-blue-50 px-4 py-2 text-xs text-blue-600">📡 Posición GPS en tiempo real del chofer</div>
                                          : ultimaPos
                                            ? <div className="bg-amber-50 px-4 py-2 text-xs text-amber-700">🕐 Última posición conocida · {tiempoRelativo(ultimaPos.en)}</div>
                                            : null
                                        }
                                      </div>
                                    );
                                  })()}

                                  {/* Evidencias de entrega compartidas por el transportista */}
                                  {(() => {
                                    const evsViaje = (store.notificaciones || []).filter(
                                      n => n.tipo === 'evidencia_entrega' && n.destinatarioId === usuario?.id && n.datos?.viajeId === viaje.id
                                    );
                                    if (evsViaje.length === 0) return null;
                                    return (
                                      <div className="mt-4 rounded-xl border border-green-200 bg-green-50 p-4">
                                        <p className="text-sm font-bold text-green-700 mb-3 flex items-center gap-2">
                                          📸 Evidencias de entrega ({evsViaje.length})
                                        </p>
                                        <div className="flex gap-3 flex-wrap">
                                          {evsViaje.map(n => (
                                            <div key={n.id} className="text-center">
                                              <img
                                                src={n.datos.foto} alt={n.datos.nombre}
                                                className="w-20 h-20 object-cover rounded-xl cursor-pointer hover:opacity-80"
                                                onClick={e => { e.stopPropagation(); setFotoLightbox(n.datos.foto); }}
                                                title="Ver en grande"
                                              />
                                              <p className="text-xs text-gray-500 mt-1">{n.datos.nombre}</p>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    );
                                  })()}

                                  {/* Incidencias compartidas por el transportista */}
                                  {(() => {
                                    const incsViaje = (store.notificaciones || []).filter(
                                      n => n.tipo === 'incidencia_cliente' && n.destinatarioId === usuario?.id && n.datos?.viajeId === viaje.id
                                    );
                                    if (incsViaje.length === 0) return null;
                                    return (
                                      <div className="mt-4 rounded-xl border border-orange-200 bg-orange-50 p-4">
                                        <p className="text-sm font-bold text-orange-700 mb-3 flex items-center gap-2">
                                          <AlertCircle size={16} /> Novedades de tu flete ({incsViaje.length})
                                        </p>
                                        <div className="space-y-3">
                                          {incsViaje.map(n => (
                                            <div key={n.id} className="bg-white rounded-lg shadow border-orange-100 p-3">
                                              <div className="flex items-start gap-3">
                                                {n.datos?.foto && (
                                                  <img
                                                    src={n.datos.foto} alt="Evidencia"
                                                    className="w-16 h-16 object-cover rounded-lg flex-shrink-0 cursor-pointer hover:opacity-80"
                                                    onClick={e => { e.stopPropagation(); setFotoLightbox(n.datos.foto); }}
                                                    title="Ver en grande"
                                                  />
                                                )}
                                                <div className="flex-1 min-w-0">
                                                  <p className="text-sm font-semibold text-orange-800">{n.titulo}</p>
                                                  <p className="text-sm text-gray-700 mt-0.5">{n.mensaje}</p>
                                                  <p className="text-xs text-gray-400 mt-1">
                                                    {new Date(n.creadoEn).toLocaleString('es-MX', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    );
                                  })()}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* ========== FLETES EN OFERTA (RETORNOS VACÍOS) ========== */}
        {seccion === 'fletes' && (
          <div>
            <div className="mb-6">
              <h2 className="text-3xl font-bold text-gray-800">Fletes Retorno</h2>
              <p className="text-gray-500 text-sm mt-1">Espacio disponible en rutas de retorno. Acuerda el precio directamente con el transportista.</p>
            </div>

            {retornosDisponibles.length === 0 ? (
              <div className="bg-white rounded-xl shadow-lg p-12 text-center text-gray-400">
                <RotateCcw size={48} className="mx-auto mb-4 opacity-30" />
                <p className="text-lg font-medium">Sin fletes disponibles ahora</p>
                <p className="text-sm mt-1">Cuando un transportista publique un retorno vacío en tu zona, aparecerá aquí</p>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 w-8"></th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Ruta</th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Empresa</th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Unidad</th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Precio</th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Tiempo</th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Mi Oferta</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-300">
                {retornosDisponibles.map(ret => {
                  const precio = precioConDescuento(ret);
                  const tieneDescuento = precio < ret.precioBase;
                  const expira = new Date(ret.fechaExpiracion || ret.expiresAt);
                  const minutosRestantes = Math.max(0, Math.round((expira - Date.now()) / 60000));
                  // Tomar la oferta más reciente del cliente (puede haber varias tras rechazos)
                  const miOferta = (ret.ofertas || [])
                    .filter(o => o.clienteId === usuario?.id)
                    .sort((a, b) => new Date(b.creadoEn) - new Date(a.creadoEn))[0];
                  const isExpanded = expandedRetorno === ret.id;
                  const ofertaBadge = !miOferta ? null :
                    miOferta.status === 'pendiente' ? { txt: '⏳ Pendiente', cls: 'bg-yellow-100 text-yellow-700' } :
                    miOferta.status === 'rechazada' ? { txt: '❌ Rechazada', cls: 'bg-red-100 text-red-700' } :
                    miOferta.status === 'perdida' ? { txt: '😔 Eligieron a otro', cls: 'bg-gray-100 text-gray-600' } :
                    (miOferta.status === 'contraoferta' || miOferta.status === 'contrapropuesta') ? { txt: '🔄 Contraoferta', cls: 'bg-orange-100 text-orange-700' } :
                    miOferta.status === 'aceptada' && !miOferta.pagado ? { txt: '✅ Aceptada', cls: 'bg-green-100 text-green-700' } :
                    miOferta.status === 'aceptada' && miOferta.pagado ? { txt: '💳 Pagado', cls: 'bg-blue-100 text-blue-700' } : null;
                  return (
                    <React.Fragment key={ret.id}>
                      {/* Fila compacta */}
                      <tr
                        id={`retorno-${ret.id}`}
                        onClick={() => setExpandedRetorno(isExpanded ? null : ret.id)}
                        className={`cursor-pointer transition-colors ${isExpanded ? 'bg-blue-50' : miOferta?.pagado ? 'bg-blue-50/40 hover:bg-blue-50' : 'hover:bg-gray-50'}`}
                      >
                        <td className="px-4 py-3 text-center">
                          <ChevronDown size={15} className={`text-gray-400 mx-auto transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
                        </td>
                        <td className="px-4 py-3">
                          <p className="font-mono text-xs font-bold text-gray-500">{ret.id}</p>
                          <p className="text-sm font-semibold text-gray-800">{(ret.origenActual || ret.origen)} → {ret.destino}</p>
                          {(ret.ciudadesEnRuta?.length || 0) > 0 && <p className="text-xs text-blue-500 truncate max-w-xs">📍 {ret.ciudadesEnRuta.slice(0,3).join(' · ')}{ret.ciudadesEnRuta.length > 3 ? '…' : ''}</p>}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          <p>{ret.empresaNombre}</p>
                          {ret.retornosCompletados > 0 && (
                            <p className="text-xs text-emerald-600 font-medium mt-0.5">✅ {ret.retornosCompletados} retorno{ret.retornosCompletados !== 1 ? 's' : ''} completado{ret.retornosCompletados !== 1 ? 's' : ''}</p>
                          )}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">🚛 {ret.tipoUnidad}</td>
                        <td className="px-4 py-3">
                          {tieneDescuento && <p className="text-xs line-through text-gray-400">${(ret.precioBase || 0).toLocaleString()}</p>}
                          <p className={`text-sm font-bold ${tieneDescuento ? 'text-orange-500' : 'text-green-600'}`}>${precio.toLocaleString()}</p>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-500">⏱ {void tickMinuto}{formatTiempoRestante(expira)}</td>
                        <td className="px-4 py-3">
                          {ofertaBadge
                            ? <span className={`text-xs font-semibold px-2 py-1 rounded-full ${ofertaBadge.cls}`}>{ofertaBadge.txt}</span>
                            : <span className="text-xs text-gray-400">Sin oferta</span>}
                        </td>
                      </tr>

                      {/* Panel expandible */}
                      {isExpanded && (
                        <tr>
                          <td colSpan={7} className="bg-gray-50 border-b border-gray-100">
                            <div className="px-6 py-5">
                              {ret.descripcion && <p className="text-sm text-gray-500 italic mb-4">"{ret.descripcion}"</p>}

                        {/* Estado de mi oferta */}
                        {miOferta && (
                          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                            <p className="text-sm font-semibold text-blue-800 mb-1">Tu oferta: ${(miOferta.monto ?? miOferta.precio ?? 0).toLocaleString()}</p>
                            {miOferta.status === 'pendiente' && <p className="text-xs text-blue-600">⏳ Esperando respuesta del transportista...</p>}
                            {miOferta.status === 'rechazada' && <p className="text-xs text-red-600">❌ El transportista rechazó tu oferta directamente</p>}
                            {miOferta.status === 'perdida' && <p className="text-xs text-gray-600">😔 El transportista eligió a otro cliente. Puedes buscar otro flete de retorno disponible.</p>}
                            {miOferta.status === 'aceptada' && (
                              miOferta.pagado ? (
                                (() => {
                                  const ordenRetorno = (store.ordenesChofer || []).find(o => o.retornoId === ret.id);
                                  const entregaConfirmada = ret.status === 'entrega_confirmada';
                                  const progresoR = entregaConfirmada ? 100 : (ordenRetorno?.progreso || 0);
                                  const choferNombreR = ordenRetorno ? (store.usuarios?.find(u => u.id === ordenRetorno.choferId)?.nombre || ordenRetorno.cliente || 'Chofer asignado') : null;
                                  return (
                                    <div className="mt-3 bg-green-50 border border-green-200 rounded-xl p-4">
                                      <div className="flex items-center justify-between gap-3 flex-wrap">
                                        <div className="flex items-center gap-3">
                                          <CheckCircle size={20} className="text-green-600 flex-shrink-0" />
                                          <div>
                                            <p className="font-semibold text-green-800 text-sm">Servicio confirmado</p>
                                            <p className="text-xs text-green-600 mt-0.5">
                                              {entregaConfirmada ? '✅ Entregado' : choferNombreR ? `Chofer: ${choferNombreR} · ${progresoR}% completado` : 'Esperando asignación de chofer'}
                                            </p>
                                          </div>
                                        </div>
                                        <button
                                          onClick={() => setSeccion('viajes')}
                                          className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 whitespace-nowrap flex-shrink-0"
                                        >
                                          Ver en Viajes Activos →
                                        </button>
                                      </div>
                                      {/* Barra de progreso compacta */}
                                      {progresoR > 0 && (
                                        <div className="mt-3">
                                          <div className="w-full bg-gray-200 rounded-full h-1.5">
                                            <div className="bg-green-500 h-1.5 rounded-full transition-all" style={{ width: `${progresoR}%` }} />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })()
                              ) : (
                                <div className="space-y-2">
                                  <p className="text-xs text-green-700 font-semibold">✅ ¡Oferta aceptada! Procede al pago para reservar el servicio.</p>
                                  <div className="flex gap-2">
                                    <button onClick={() => { setRetornoPagar({ retorno: ret, oferta: miOferta }); setPagoRetornoCompletado(false); }}
                                      className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-semibold hover:bg-green-700">
                                      💳 Pagar y confirmar servicio
                                    </button>
                                    <button onClick={async () => {
                                        if (!window.confirm('¿Cancelar esta oferta? El transportista será notificado.')) return;
                                        try {
                                          await apiCancelarOfertaRetorno(miOferta.id);
                                          mostrarNotificacion('Oferta cancelada.', 'info');
                                          setExpandedRetorno(null);
                                          recargar();
                                        } catch (e) { mostrarNotificacion(e.message || 'Error al cancelar', 'error'); }
                                      }}
                                      className="px-4 py-2 bg-white border border-red-300 text-red-600 rounded-lg text-sm font-medium hover:bg-red-50 whitespace-nowrap">
                                      Cancelar oferta
                                    </button>
                                  </div>
                                </div>
                              )
                            )}
                            {(miOferta.status === 'contraoferta' || miOferta.status === 'contrapropuesta') && (
                              <div>
                                <p className="text-sm text-blue-700 font-medium mb-2">🔄 El transportista propone <span className="font-bold">${(miOferta.montoContra ?? miOferta.contrapropuesta ?? 0).toLocaleString()}</span></p>
                                {miOferta.mensaje && <p className="text-xs text-gray-600 italic mb-2">"{miOferta.mensaje}"</p>}
                                <div className="flex gap-2 mt-2">
                                  <button onClick={async () => {
                                      try {
                                        await apiClienteResponderContraoferta(miOferta.id, 'aceptada');
                                        aceptarContraofertaRetorno(ret.id, miOferta.id);
                                        const ofertaFinal = { ...miOferta, monto: miOferta.montoContra || miOferta.monto };
                                        if (!miOferta.origenCoords || !miOferta.destinoCoords) {
                                          const tipoFaltante = !miOferta.origenCoords ? 'origen' : 'destino';
                                          setGpsContraoferta({ retornoId: ret.id, ofertaId: miOferta.id, tipo: tipoFaltante, origenCoords: miOferta.origenCoords || null, destinoCoords: miOferta.destinoCoords || null, retorno: ret, oferta: ofertaFinal });
                                        } else {
                                          setRetornoPagar({ retorno: ret, oferta: ofertaFinal });
                                          setPagoRetornoCompletado(false);
                                        }
                                        recargar();
                                      } catch (e) { mostrarNotificacion(e.message || 'Error al aceptar contraoferta', 'error'); }
                                    }}
                                    className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700">
                                    ✅ Aceptar ${(miOferta.montoContra ?? miOferta.contrapropuesta ?? 0).toLocaleString()}
                                  </button>
                                  <button onClick={async () => {
                                      try {
                                        await apiClienteResponderContraoferta(miOferta.id, 'rechazada');
                                        rechazarContraofertaCliente(ret.id, miOferta.id);
                                        mostrarNotificacion('Contraoferta rechazada. El transportista ha sido notificado.', 'error');
                                        recargar();
                                      } catch (e) { mostrarNotificacion(e.message || 'Error al rechazar contraoferta', 'error'); }
                                    }}
                                    className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700">
                                    ❌ Rechazar
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                              {/* Botón negociar precio */}
                              {!miOferta && (
                                <button onClick={(e) => { e.stopPropagation(); setOfertaRetornoId(ret.id); setFormOferta({ monto: '', mensaje: '', ciudadCliente: '', destinoEntrega: '', peso: '', volumen: '', fotos: [], origenCoords: null, destinoCoords: null }); }}
                                  className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold">
                                  💰 Negociar precio
                                </button>
                              )}
                              {miOferta && miOferta.status === 'rechazada' && (
                                <button onClick={(e) => { e.stopPropagation(); setOfertaRetornoId(ret.id); setFormOferta({ monto: miOferta.precio ? String(miOferta.precio) : '', mensaje: miOferta.descripcion || '', ciudadCliente: miOferta.origen || '', destinoEntrega: miOferta.destino || '', peso: miOferta.peso || '', volumen: miOferta.volumen || '', fotos: miOferta.fotos || [], origenCoords: miOferta.origenCoords || null, destinoCoords: miOferta.destinoCoords || null }); }}
                                  className="w-full px-4 py-3 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 font-semibold mt-2">
                                  🔄 Negociar de nuevo
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
                  </tbody>
                </table>
              </div>
            )}

            {/* Modal negociar precio */}
            {ofertaRetornoId && (() => {
              const ret = retornosDisponibles.find(r => r.id === ofertaRetornoId);
              if (!ret) return null;
              const precioRef = precioConDescuento(ret);
              return (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
                  <div className="bg-white shadow-2xl rounded-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
                    <div className="p-6 border-b flex justify-between items-center">
                      <div>
                        <h3 className="text-xl font-bold">Proponer tu precio</h3>
                        <p className="text-sm text-gray-500">{(ret.origenActual || ret.origen)} → {ret.destino} · {ret.tipoUnidad}</p>
                      </div>
                      <button onClick={() => { setOfertaRetornoId(null); setFormOferta({ monto: '', mensaje: '', ciudadCliente: '', destinoEntrega: '', peso: '', volumen: '', fotos: [], origenCoords: null, destinoCoords: null }); }} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
                    </div>
                    <div className="p-6 space-y-4">
                      {/* Ciudad de origen de la carga */}
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Ciudad donde recoge la carga *</label>
                        <select value={formOferta.ciudadCliente}
                          onChange={e => setFormOferta({...formOferta, ciudadCliente: e.target.value, destinoEntrega: '', origenCoords: null})}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400">
                          <option value="">Seleccionar...</option>
                          {(() => { const cr = ret.ciudadesEnRuta?.length ? ret.ciudadesEnRuta : calcCiudadesEnRuta((ret.origenActual || ret.origen), ret.destino); return [(ret.origenActual || ret.origen), ...cr].map(c => <option key={c} value={c}>{c}</option>); })()}
                        </select>
                        <button type="button"
                          onClick={() => abrirMapaOferta('origen', formOferta.ciudadCliente)}
                          disabled={!formOferta.ciudadCliente}
                          className={`mt-2 w-full flex items-center justify-center space-x-2 px-3 py-2 rounded-lg border text-sm font-medium transition
                            ${formOferta.origenCoords ? 'bg-green-50 border-green-400 text-green-700 hover:bg-green-100' : 'bg-red-50 border-red-300 text-red-600 hover:bg-red-100 hover:border-red-400'}
                            disabled:opacity-40 disabled:cursor-not-allowed`}>
                          <MapPin size={15} />
                          <span>{formOferta.origenCoords ? '📍 Punto de recogida confirmado' : '* Obligatorio: Marcar punto exacto en mapa'}</span>
                        </button>
                        {formOferta.origenCoords?.direccion && (
                          <p className="text-xs text-green-600 mt-1 truncate">{formOferta.origenCoords.direccion}</p>
                        )}
                      </div>

                      {/* Destino de entrega — ciudades después del origen elegido */}
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Ciudad de entrega *</label>
                        {(() => {
                          const _cr = ret.ciudadesEnRuta?.length ? ret.ciudadesEnRuta : calcCiudadesEnRuta((ret.origenActual || ret.origen), ret.destino); const rutaCompleta = [(ret.origenActual || ret.origen), ..._cr, ret.destino];
                          const idxOrigen = rutaCompleta.indexOf(formOferta.ciudadCliente);
                          const opcionesDestino = idxOrigen >= 0 ? rutaCompleta.slice(idxOrigen + 1) : rutaCompleta.slice(1);
                          return (
                            <select value={formOferta.destinoEntrega}
                              onChange={e => setFormOferta({...formOferta, destinoEntrega: e.target.value, destinoCoords: null})}
                              disabled={!formOferta.ciudadCliente}
                              className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 disabled:bg-gray-100">
                              <option value="">Seleccionar...</option>
                              {opcionesDestino.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                          );
                        })()}
                        <p className="text-xs text-gray-400 mt-1">Solo ciudades que el camión pasará después de recoger tu carga</p>
                        <button type="button"
                          onClick={() => abrirMapaOferta('destino', formOferta.destinoEntrega)}
                          disabled={!formOferta.destinoEntrega}
                          className={`mt-2 w-full flex items-center justify-center space-x-2 px-3 py-2 rounded-lg border text-sm font-medium transition
                            ${formOferta.destinoCoords ? 'bg-green-50 border-green-400 text-green-700 hover:bg-green-100' : 'bg-red-50 border-red-300 text-red-600 hover:bg-red-100 hover:border-red-400'}
                            disabled:opacity-40 disabled:cursor-not-allowed`}>
                          <MapPin size={15} />
                          <span>{formOferta.destinoCoords ? '📍 Punto de entrega confirmado' : '* Obligatorio: Marcar punto exacto en mapa'}</span>
                        </button>
                        {formOferta.destinoCoords?.direccion && (
                          <p className="text-xs text-green-600 mt-1 truncate">{formOferta.destinoCoords.direccion}</p>
                        )}
                      </div>

                      {/* Peso y Volumen */}
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-1">Peso de la carga *</label>
                          <div className="relative">
                            <input type="number" min="0" step="0.1" value={formOferta.peso}
                              onChange={e => setFormOferta({...formOferta, peso: e.target.value})}
                              onWheel={e => e.target.blur()}
                              placeholder="0.0"
                              className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 pr-12" />
                            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-400">ton</span>
                          </div>
                        </div>
                        <div>
                          <label className="block text-sm font-semibold text-gray-700 mb-1">Volumen (opcional)</label>
                          <div className="relative">
                            <input type="number" min="0" step="0.1" value={formOferta.volumen}
                              onChange={e => setFormOferta({...formOferta, volumen: e.target.value})}
                              onWheel={e => e.target.blur()}
                              placeholder="0.0"
                              className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 pr-12" />
                            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-400">m³</span>
                          </div>
                        </div>
                      </div>

                      {/* Fotos del flete */}
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Fotos del flete (opcional)</label>
                        <label className="block w-full cursor-pointer">
                          <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 hover:bg-blue-50 transition">
                            <Package size={24} className="mx-auto text-gray-400 mb-1" />
                            <p className="text-sm text-gray-500">Haz clic para agregar fotos</p>
                            <p className="text-xs text-gray-400">JPG, PNG — {5 - (formOferta.fotos?.length||0)} foto{5-(formOferta.fotos?.length||0)!==1?'s':''} restante{5-(formOferta.fotos?.length||0)!==1?'s':''}</p>
                          </div>
                          <input type="file" accept="image/*" multiple className="hidden"
                            onChange={e => {
                              const files = Array.from(e.target.files || []);
                              const readers = files.map(file => new Promise(res => {
                                const r = new FileReader();
                                r.onload = ev => res(ev.target.result);
                                r.readAsDataURL(file);
                              }));
                              Promise.all(readers)
                                .then(nuevas => setFormOferta(f => ({...f, fotos: [...(f.fotos||[]), ...nuevas].slice(0, 5)})))
                                .catch(e => { console.warn('[Cliente] Error leyendo fotos:', e.message); });
                              e.target.value = '';
                            }} />
                        </label>
                        {(formOferta.fotos?.length || 0) > 0 && (
                          <div className="flex gap-2 mt-2 flex-wrap">
                            {formOferta.fotos.map((f, i) => (
                              <div key={i} className="relative group">
                                <img src={f} alt={`foto-${i}`} className="w-16 h-16 object-cover rounded-lg border" />
                                <button onClick={() => setFormOferta(fo => ({...fo, fotos: fo.fotos.filter((_, j) => j !== i)}))}
                                  className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100">×</button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Precio */}
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">
                          Tu oferta (MXN) *
                          <span className="ml-2 text-xs font-normal text-gray-400">Precio actual: ${precioRef.toLocaleString()}</span>
                        </label>
                        <input type="number" min="1" value={formOferta.monto}
                          onChange={e => setFormOferta({...formOferta, monto: e.target.value})}
                          onWheel={e => e.target.blur()}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400" />
                        <p className="text-xs text-gray-400 mt-1">Si tu oferta iguala o supera el precio mínimo del transportista, se acepta automáticamente</p>
                      </div>

                      {/* Mensaje */}
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Descripción del flete *</label>
                        <textarea rows={2} value={formOferta.mensaje}
                          onChange={e => setFormOferta({...formOferta, mensaje: e.target.value})}
                          placeholder="Ej. Carga lista para mañana a las 9am, mercancía embalada..."
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 resize-none" />
                      </div>

                      <div className="flex space-x-3 pt-2">
                        <button onClick={() => { setOfertaRetornoId(null); setFormOferta({ monto: '', mensaje: '', ciudadCliente: '', destinoEntrega: '', peso: '', volumen: '', fotos: [], origenCoords: null, destinoCoords: null }); }} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 hover:bg-gray-50">Cancelar</button>
                        <button onClick={async () => {
                          if (!formOferta.mensaje?.trim()) { mostrarNotificacion('Escribe una descripción del flete.', 'error'); return; }
                          if (!formOferta.ciudadCliente) { mostrarNotificacion('Selecciona la ciudad donde recoges la carga.', 'error'); return; }
                          if (!formOferta.destinoEntrega) { mostrarNotificacion('Selecciona la ciudad de entrega.', 'error'); return; }
                          if (!formOferta.origenCoords) { mostrarNotificacion('Debes marcar el punto exacto de recogida en el mapa.', 'error'); return; }
                          if (!formOferta.destinoCoords) { mostrarNotificacion('Debes marcar el punto exacto de entrega en el mapa.', 'error'); return; }
                          if (!formOferta.peso || Number(formOferta.peso) <= 0) { mostrarNotificacion('Ingresa el peso de la carga.', 'error'); return; }
                          if (!formOferta.monto) { mostrarNotificacion('Ingresa el monto de tu oferta.', 'error'); return; }
                          try {
                            await apiOfertarRetorno(ret.id, { precio: Number(formOferta.monto), origen: formOferta.ciudadCliente, destino: formOferta.destinoEntrega, descripcion: formOferta.mensaje, peso: formOferta.peso || null, volumen: formOferta.volumen || null, fotos: formOferta.fotos || [], origenCoords: formOferta.origenCoords || null, destinoCoords: formOferta.destinoCoords || null });
                            hacerOfertaRetorno(ret.id, usuario?.id, usuario?.nombre, formOferta.ciudadCliente, Number(formOferta.monto), formOferta.mensaje, { peso: formOferta.peso, volumen: formOferta.volumen, fotos: formOferta.fotos, destinoEntrega: formOferta.destinoEntrega, origenCoords: formOferta.origenCoords, destinoCoords: formOferta.destinoCoords });
                            await recargar();
                            // Leer el store fresco para detectar auto-aceptación
                            const storeActual = getStore();
                            const retActualizado = (storeActual.retornosVacios || []).find(r => r.id === ret.id);
                            const ofertaAceptada = (retActualizado?.ofertas || []).find(o => o.clienteId === usuario?.id && o.status === 'aceptada');
                            if (ofertaAceptada) {
                              setRetornoPagar({ retorno: retActualizado, oferta: ofertaAceptada });
                              setPagoRetornoCompletado(false);
                            }
                            setOfertaRetornoId(null);
                            setFormOferta({ monto: '', mensaje: '', ciudadCliente: '', destinoEntrega: '', peso: '', volumen: '', fotos: [], origenCoords: null, destinoCoords: null });
                          } catch (e) { mostrarNotificacion(e.message || 'Error al enviar la oferta', 'error'); }
                        }} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold">
                          Enviar Oferta
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        {/* HISTORIAL */}
        {seccion === 'historial' && (
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Historial de Viajes</h2>
            <p className="text-gray-600 mb-6">Consulta todos tus viajes completados y califica el servicio</p>

            {historial.length === 0 ? (
              <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                <Clock size={64} className="mx-auto text-gray-400 mb-4" />
                <h3 className="text-xl font-bold text-gray-800 mb-2">Sin historial</h3>
                <p className="text-gray-600">Tus viajes completados aparecerán aquí</p>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="overflow-x-auto">
                <table className="w-full min-w-[700px]">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">ID</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Fecha</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ruta</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Estado</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Transportista</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Costo</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Calificación</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {historial.map(viaje => (
                      <tr key={viaje.id} className={`hover:bg-gray-50 border-l-4 ${viaje.esCancelado ? 'bg-red-50/30 border-red-200 opacity-75' : 'bg-gray-50 border-gray-300'}`}>
                        <td className="px-6 py-4">
                          <span className="font-mono font-semibold text-gray-500">{viaje.folio || viaje.id?.slice(0, 8).toUpperCase()}</span>
                        </td>
                        <td className="px-6 py-4 text-gray-400">
                          {viaje.fecha ? new Date(viaje.fecha).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
                        </td>
                        <td className="px-6 py-4 font-medium text-gray-500">
                          {viaje.ruta}
                          {viaje.motivoCancelacion && (
                            <p className="text-xs text-red-500 mt-0.5 italic">"{viaje.motivoCancelacion}"</p>
                          )}
                        </td>
                        <td className="px-6 py-4">
                          {viaje.esCancelado ? (
                            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${viaje.esVencida ? 'bg-gray-100 text-gray-600' : 'bg-red-100 text-red-700'}`}>
                              {viaje.esVencida ? '⏰ Vencida' : viaje.tipo === 'solicitud_cancelada' ? '🚫 Sin transportista' : '❌ Cancelado'}
                            </span>
                          ) : (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700">
                              ✅ Completado
                            </span>
                          )}
                        </td>
                        <td className="px-6 py-4 text-gray-500">{viaje.transportista}</td>
                        <td className="px-6 py-4">
                          <span className="font-bold text-gray-500">${(viaje.costoFinal || viaje.precio || viaje.costo || 0).toLocaleString()} MXN</span>
                        </td>
                        <td className="px-6 py-4">
                          {viaje.esCancelado ? (
                            <span className="text-gray-300 text-sm">—</span>
                          ) : viaje.calificacion ? (
                            <div className="flex items-center space-x-1">
                              {[1,2,3,4,5].map(i => (
                                <Star
                                  key={i}
                                  size={16}
                                  className={i <= viaje.calificacion ? 'text-yellow-400' : 'text-gray-400'}
                                  fill={i <= viaje.calificacion ? 'currentColor' : 'none'}
                                />
                              ))}
                            </div>
                          ) : (
                            <span className="text-gray-400 text-sm">Sin calificar</span>
                          )}
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex flex-col gap-1">
                            {!viaje.esCancelado && (!viaje.clienteConfirmo && viaje.status !== 'entrega_confirmada' && viaje.status !== 'confirmado') ? (
                              <button
                                onClick={() => setConfirmarEntregaViajeId(viaje.id)}
                                className="px-3 py-1 bg-green-100 text-green-800 rounded-lg hover:bg-green-200 font-medium text-sm flex items-center space-x-1"
                              >
                                <CheckCircle size={14} />
                                <span>Confirmar de recibido</span>
                              </button>
                            ) : !viaje.esCancelado && viaje.calificacion ? (
                              <span className="text-gray-400 text-sm">✓ Calificado</span>
                            ) : !viaje.esCancelado ? (
                              <button
                                onClick={() => { setCalificacionLocal(0); setComentarioLocal(''); setMostrarCalificar(viaje); }}
                                className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-lg hover:bg-yellow-200 font-medium text-sm flex items-center space-x-1"
                              >
                                <Star size={14} />
                                <span>Calificar</span>
                              </button>
                            ) : null}
                            {!viaje.esCancelado && (
                              <button
                                onClick={() => generarComprobante(viaje)}
                                className="px-3 py-1 bg-gray-100 border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-200 font-medium text-sm flex items-center space-x-1"
                              >
                                <Download size={14} />
                                <span>Comprobante</span>
                              </button>
                            )}
                            {viajesConTicket.includes(viaje.id) && (
                              <button
                                onClick={() => { const _cm = { viajeId: viaje.id, contraparte: { id: 'admin', nombre: 'Soporte Choyero', rol: 'admin' } }; chatModalRef.current = _cm; setChatModal(_cm); }}
                                className="px-3 py-1 bg-blue-50 border border-blue-200 text-blue-700 rounded-lg hover:bg-blue-100 font-medium text-sm flex items-center space-x-1"
                              >
                                <MessageCircle size={14} />
                                <span>Soporte</span>
                              </button>
                            )}
                            {(viaje.solicitudData || viaje.origen) && (
                              <button
                                onClick={() => {
                                  const sd = viaje.solicitudData;
                                  setSolicitudParaRepetir(sd || { origen: viaje.origen, destino: viaje.destino });
                                  setOrigenCoords(sd?.origenCoords || null);
                                  setDestinoCoords(sd?.destinoCoords || null);
                                  setFotosFormulario([]);
                                  setMostrarFormulario(true);
                                }}
                                className="px-3 py-1 bg-indigo-50 border border-indigo-200 text-indigo-700 rounded-lg hover:bg-indigo-100 font-medium text-sm flex items-center space-x-1"
                              >
                                <Plus size={14} />
                                <span>Repetir</span>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
              </div>
            )}
          </div>
        )}

        {/* COMPARTIR / INVITAR AMIGOS — solo Persona Física */}
        {seccion === 'compartir' && (store.usuarioPerfil?.esReferidor ?? usuario?.esReferidor) && (() => {
          // Marcar comisiones como vistas al entrar a la sección
          try { sessionStorage.setItem(_redSeenKey, new Date().toISOString()); } catch (_) {}
          const cfg = store.configPlataforma?.redMercadeo || {};
          const misComisionesReales = (store.comisionesRed || []).filter(c => c.userId === usuario.id);
          const saldoMLM = {
            disponible: misComisionesReales.filter(c => c.status === 'disponible').reduce((s, c) => s + c.monto, 0),
            pendiente: misComisionesReales.filter(c => c.status === 'pendiente').reduce((s, c) => s + c.monto, 0),
            congelado: misComisionesReales.filter(c => c.status === 'congelada').reduce((s, c) => s + c.monto, 0),
            bloqueado: misComisionesReales.filter(c => c.status === 'bloqueada').reduce((s, c) => s + c.monto, 0),
            historico: misComisionesReales,
            totalGanado: misComisionesReales.filter(c => c.status === 'disponible' || c.status === 'pagada').reduce((s, c) => s + c.monto, 0),
          };
          const misReferidosReales = store.misReferidos || [];
          const empresasN1 = misReferidosReales.map(r => ({
            id: r.empresaId || r.id,
            userId: r.id,
            nombre: r.empresa?.nombre || r.nombre,
            esClienteMoral: r.rol === 'cliente',
            primerFlete: (store.comisionesRed || []).some(c => c.userId === usuario.id && c.empresaId === (r.empresaId || r.id) && c.tipo === 'flete'),
            status: r.empresa?.status || null,
          }));
          const subRed = [];
          const comisionesMLM = misComisionesReales.sort((a, b) => new Date(b.creadoEn || b.fecha) - new Date(a.creadoEn || a.fecha));
          const colorEstado = (s) => ({ disponible: 'bg-green-100 text-green-700', pendiente: 'bg-yellow-100 text-yellow-700', pagada: 'bg-blue-100 text-blue-700', revertida: 'bg-red-100 text-red-700', congelada: 'bg-gray-100 text-gray-600', bloqueada: 'bg-orange-100 text-orange-700', expirada: 'bg-red-50 text-red-400' }[s] || 'bg-gray-100 text-gray-600');
          const labelEstado = (s) => ({ pendiente: 'Pendiente', disponible: 'Disponible', pagada: 'Pagada', revertida: 'Revertida', congelada: 'Congelada', bloqueada: 'Bloqueada', expirada: 'Expirada' }[s] || s);

          return (
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Programa de Referidos</h2>
            <p className="text-gray-600 mb-4">Invita empresas a Choyero y gana comisiones por multinivel</p>

            {/* Reglas — acordeón colapsable */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl mb-6 text-sm text-blue-700 overflow-hidden">
              <button
                onClick={() => setReglasReferidosAbiertas(v => !v)}
                className="w-full flex items-center justify-between px-4 py-3 font-bold hover:bg-blue-100 transition-colors text-left"
              >
                <span>📋 Reglas de comisión multinivel</span>
                <span className="text-blue-400 text-xs ml-2">{reglasReferidosAbiertas ? '▲ ocultar' : '▼ ver reglas'}</span>
              </button>
              {reglasReferidosAbiertas && (
                <div className="px-4 pb-4 border-t border-blue-200 pt-3">
                  <p className="font-semibold text-blue-800 mb-2">💰 Cómo ganar</p>
                  <div className="space-y-1 mb-4">
                    <p>• Invita a <strong>transportistas, empresas o amigos</strong> — todos generan comisión cuando hacen un flete en Choyero</p>
                    <p>• Al unirse una <strong>empresa o transportista</strong>, recibes un <strong>bono de bienvenida</strong> que se libera cuando completan su primer flete</p>
                    <p>• Ganas comisión recurrente cada vez que tu referido <strong>completa un flete</strong> — calculada sobre la comisión de Choyero, no sobre el valor del viaje</p>
                    <p>• Tu red crece hasta <strong>3 niveles</strong> — ganas también de las personas que inviten tus referidos</p>
                  </div>
                  <p className="font-semibold text-blue-800 mb-2">🔓 ¿Cuándo se liberan tus ganancias?</p>
                  <div className="space-y-1">
                    <p>• Asegúrate de tener al menos <strong>{cfg.minimoReferidosActivos ?? 1} referido activo</strong> con fletes en los últimos <strong>{cfg.diasInactividadReferido ?? 60} días</strong></p>
                    <p>• Sigue invitando — al menos <strong>1 persona nueva</strong> cada <strong>{cfg.diasActividadReferidor ?? 60} días</strong> mantiene tu red activa</p>
                    <p>• Mantén tu red activa para que tus ganancias fluyan sin interrupciones — se reactivan automáticamente cuando vuelves a tener actividad</p>
                    <p>• Te avisamos con <strong>{cfg.diasAvisoExpiracion ?? 7} días de anticipación</strong> para que puedas actuar a tiempo</p>
                  </div>
                </div>
              )}
            </div>

            {/* Banner de comisiones bloqueadas */}
            {saldoMLM.bloqueado > 0 && (
              <div className="bg-orange-50 border border-orange-300 rounded-xl p-4 mb-6 flex items-start space-x-3">
                <span className="text-2xl">🔒</span>
                <div className="flex-1">
                  <p className="font-bold text-orange-800">Tienes ${saldoMLM.bloqueado.toLocaleString('es-MX')} MXN bloqueados</p>
                  <p className="text-sm text-orange-700 mt-1">
                    Para desbloquear estas comisiones debes: (1) tener al menos {cfg.minimoReferidosActivos ?? 1} transportista o empresa con fletes recientes, y (2) haber invitado a alguien nuevo en los últimos {cfg.diasActividadReferidor ?? 60} días.
                  </p>
                  <p className="text-xs text-orange-500 mt-1">Las comisiones bloqueadas expiran si no cumples los requisitos a tiempo. Comparte tu código de invitación con transportistas activos.</p>
                </div>
              </div>
            )}

            {/* Banner de referidos */}
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 mb-8 text-white">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h3 className="text-2xl font-bold mb-2">🎁 Tu código de invitación</h3>
                  <p className="text-blue-100 mb-4">Compártelo con amigos, transportistas o empresas. Ganas comisión cada vez que hagan un flete.</p>
                  <div className="flex items-center space-x-3 flex-wrap gap-2">
                    <div className="bg-white bg-opacity-20 rounded-lg px-4 py-2">
                      <p className="text-xs text-blue-100">Código</p>
                      <p className="font-mono font-bold text-lg">{codigoReferido}</p>
                    </div>
                    <div className="flex flex-col gap-1.5">
                      {[
                        { tipo: 'landing',        label: '🌐 Ver Choyero primero', desc: 'Prospecto nuevo' },
                        { tipo: 'cliente',        label: '📦 Para cliente',        desc: 'Envía mercancía' },
                        { tipo: 'transportista',  label: '🚚 Para transportista',  desc: 'Ofrece servicios' },
                        { tipo: 'referidor',      label: '🎁 Para referidor MLM',  desc: 'Gana comisiones' },
                      ].map(({ tipo, label, desc }) => (
                        <button
                          key={tipo}
                          onClick={() => copiarLinkReferido(tipo)}
                          className={`px-3 py-2 rounded-lg font-semibold flex items-center gap-2 transition text-sm ${
                            linkCopiado === tipo ? 'bg-green-500 text-white' : 'bg-white text-blue-700 hover:bg-blue-50'
                          }`}
                        >
                          {linkCopiado === tipo ? <Check size={15} /> : <Copy size={15} />}
                          <span>{linkCopiado === tipo ? '¡Copiado!' : label}</span>
                          {linkCopiado !== tipo && <span className="text-xs text-blue-400 font-normal">{desc}</span>}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="hidden sm:flex flex-col items-end gap-2 ml-4">
                  <p className="text-xs text-blue-200 font-semibold">Compartir</p>
                  <div className="flex gap-2">
                    <button onClick={() => compartirEnRed('facebook')} title="Facebook" className="w-10 h-10 bg-blue-700 hover:bg-blue-800 rounded-full flex items-center justify-center transition">
                      <Facebook size={18} className="text-white" />
                    </button>
                    <button onClick={() => compartirEnRed('twitter')} title="Twitter / X" className="w-10 h-10 bg-sky-500 hover:bg-sky-600 rounded-full flex items-center justify-center transition">
                      <Twitter size={18} className="text-white" />
                    </button>
                    <button onClick={() => compartirEnRed('whatsapp')} title="WhatsApp" className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center transition">
                      <MessageCircle size={18} className="text-white" />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Saldo MLM */}
            {(cfg.habilitada !== false || misComisionesReales.length > 0) && (
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                <div className="bg-green-50 border border-green-200 rounded-2xl p-4 text-center">
                  <p className="text-xs text-green-600 font-semibold mb-1">Disponible</p>
                  <p className="text-2xl font-bold text-green-700">${saldoMLM.disponible.toLocaleString()}</p>
                  <p className="text-xs text-green-500 mt-1">Listo para retirar</p>
                </div>
                <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-4 text-center">
                  <p className="text-xs text-yellow-600 font-semibold mb-1">En espera</p>
                  <p className="text-2xl font-bold text-yellow-700">${saldoMLM.pendiente.toLocaleString()}</p>
                  <p className="text-xs text-yellow-500 mt-1">Se libera al primer flete de tu referido</p>
                </div>
                {saldoMLM.congelado > 0 && (
                  <div className="bg-gray-50 border border-gray-300 rounded-2xl p-4 text-center">
                    <p className="text-xs text-gray-500 font-semibold mb-1">Congelado</p>
                    <p className="text-2xl font-bold text-gray-600">${saldoMLM.congelado.toLocaleString()}</p>
                    <p className="text-xs text-gray-400 mt-1">En revisión admin</p>
                  </div>
                )}
                <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4 text-center">
                  <p className="text-xs text-blue-600 font-semibold mb-1">Pagado</p>
                  <p className="text-2xl font-bold text-blue-700">${(saldoMLM.historico || []).filter(c => c.status === 'pagada').reduce((s, c) => s + c.monto, 0).toLocaleString()}</p>
                  <p className="text-xs text-blue-500 mt-1">Ya transferido en retiros anteriores</p>
                </div>
                <div className="bg-purple-50 border border-purple-200 rounded-2xl p-4 text-center">
                  <p className="text-xs text-purple-600 font-semibold mb-1">Total ganado</p>
                  <p className="text-2xl font-bold text-purple-700">${saldoMLM.totalGanado.toLocaleString()}</p>
                  <p className="text-xs text-purple-500 mt-1">Disponible + Pagado (histórico)</p>
                </div>
              </div>
            )}

            {/* ── Solicitar retiro ── */}
            {(() => {
              const uClabe = store.usuarioPerfil?.id === usuario?.id ? store.usuarioPerfil : usuario;
              return <SeccionRetiroReferidos saldoDisponible={saldoMLM.disponible} usuarioId={usuario?.id} comisionesRaw={misComisionesReales} clabeGuardada={uClabe?.clabe || ''} bancoGuardado={uClabe?.banco || ''} usuario={uClabe} autoOpen={abrirRetiroDirecto} onAutoOpenDone={() => setAbrirRetiroDirecto(false)} setSeccionExterna={setSeccion} setAbrirClabeExterna={setAbrirClabeDirecto} />;
            })()}

            {/* Estructura de comisiones por nivel */}
            {cfg.habilitada && (
              <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                <h3 className="font-bold text-gray-800 mb-4">Estructura de comisiones por nivel</h3>
                <div className="grid grid-cols-3 gap-3">
                  {[
                    { n: 1, bg: '#eff6ff', border: '#bfdbfe', txt: '#1d4ed8' },
                    { n: 2, bg: '#faf5ff', border: '#d8b4fe', txt: '#7c3aed' },
                    { n: 3, bg: '#fff7ed', border: '#fed7aa', txt: '#c2410c' },
                  ].map(({ n, bg, border, txt }) => {
                    const bonoCliente = cfg[`bonoClienteN${n}`] || 0;
                    const bonoTrans = cfg[`bonoTransN${n}`] || 0;
                    const pct = cfg[`pctFleteN${n}`] || 0;
                    const pctCliente = cfg[`pctFleteClienteN${n}`] || 0;
                    const ganado = comisionesMLM.filter(x => x.nivel === n && (x.status === 'disponible' || x.status === 'pagada')).reduce((s, x) => s + x.monto, 0);
                    const pendiente = comisionesMLM.filter(x => x.nivel === n && x.status === 'pendiente').reduce((s, x) => s + x.monto, 0);
                    return (
                      <div key={n} style={{ background: bg, borderColor: border }} className="border rounded-xl p-4">
                        <div style={{ color: txt }} className="text-xs font-bold mb-2 uppercase tracking-wide">Nivel {n}</div>
                        <div className="space-y-1.5 text-xs">
                          <div className="flex justify-between">
                            <span className="text-gray-400">Bono cliente</span>
                            <span style={{ color: txt }} className="font-bold">${bonoCliente.toLocaleString()}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-400">Bono transportista</span>
                            <span style={{ color: txt }} className="font-bold">${bonoTrans.toLocaleString()}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-400">% flete (transportista)</span>
                            <span style={{ color: txt }} className="font-bold">{pct}%</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-400">% flete (cliente)</span>
                            <span style={{ color: txt }} className="font-bold">{pctCliente}%</span>
                          </div>
                          <div className="border-t border-gray-200 pt-1.5 mt-1.5 space-y-0.5">
                            <div className="flex justify-between text-green-700">
                              <span>Ganado</span>
                              <span className="font-bold">${ganado.toLocaleString()}</span>
                            </div>
                            <div className="flex justify-between text-yellow-600">
                              <span>En espera</span>
                              <span className="font-bold">${pendiente.toLocaleString()}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Red de referidos */}
            <SeccionMiRedReferidos store={store} usuario={usuario} codigoReferido={codigoReferido} />

            {/* ── Panel de ganancias detallado ── */}
            {(cfg.habilitada !== false || comisionesMLM.length > 0) && (() => {
              const esBono = (c) => c.tipo?.includes('bono') || c.tipo?.includes('registro');
              const esFlete = (c) => c.tipo?.includes('flete');
              const nombreEmpresa = (c) =>
                c.empresa?.nombre
                || [...(store.misReferidosN1||store.misReferidos||[]), ...(store.misReferidosN2||[]), ...(store.misReferidosN3||[])]
                    .find(u => u.empresaId === c.empresaId)?.empresa?.nombre
                || c.empresaId?.slice(0,8) || '—';
              const totalS = (fn) => comisionesMLM.filter(fn).reduce((s,c)=>s+c.monto,0);
              const totales = {
                disponible: totalS(c=>c.status==='disponible'),
                pendiente:  totalS(c=>c.status==='pendiente'),
                pagado:     totalS(c=>c.status==='pagada'),
                bonos:      totalS(c=>esBono(c)&&c.status!=='revertida'),
                fletes:     totalS(c=>esFlete(c)&&c.status!=='revertida'),
                n1:         totalS(c=>c.nivel===1&&c.status!=='revertida'),
                n2:         totalS(c=>c.nivel===2&&c.status!=='revertida'),
                n3:         totalS(c=>c.nivel===3&&c.status!=='revertida'),
              };
              return (
                <GananciasDetalle
                  comisiones={comisionesMLM}
                  nombreEmpresa={nombreEmpresa}
                  esBono={esBono}
                  esFlete={esFlete}
                  totales={totales}
                  colorEstado={colorEstado}
                  labelEstado={labelEstado}
                />
              );
            })()}

          </div>
          );
        })()}


        {seccion === 'actividad' && <SeccionMiActividad />}
        {seccion === 'pagos' && <SeccionMisPagosCliente usuario={usuario} dispatch={dispatch} store={store} onConfirmarEntrega={setConfirmarEntregaViajeId} refreshKey={pagosRefreshKey} autoOpenClabe={abrirClabeDirecto} onAutoOpenClabeDone={() => setAbrirClabeDirecto(false)} />}

        {seccion === 'facturas' && (() => {
          const uF = store.usuarioPerfil?.id === usuario?.id ? { ...usuario, ...store.usuarioPerfil } : usuario;
          const datosFiscalesCompletos = uF?.rfc && uF?.razonSocial && uF?.regimenFiscal && uF?.cpFiscal;
          const viajesCompletados = historial.filter(v => v.tipo === 'flete');
          const viajesConFactura = (store.viajes || []).filter(v => v.solicitudFactura).sort((a, b) => new Date(b.solicitudFactura.creadoEn) - new Date(a.solicitudFactura.creadoEn));
          const idsConFactura = new Set(viajesConFactura.map(v => v.id));
          const viajesSinFactura = viajesCompletados.filter(v => v.tipo !== 'retorno' && !idsConFactura.has(v.id));

          const abrirSolicitarFactura = (viaje) => {
            setFormSolicitarFactura({
              rfcReceptor: uF?.rfc || '',
              nombreReceptor: uF?.razonSocial || uF?.nombre || '',
              regimenFiscal: uF?.regimenFiscal || '',
              cpFiscal: uF?.cpFiscal || '',
              usoCfdi: uF?.usoCfdi || 'G03',
              notas: ''
            });
            setModalSolicitarFactura({ viajeId: viaje.id, viaje });
          };

          return (
            <div>
              <div className="flex items-center justify-between mb-2">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Mis Facturas</h2>
                <div className="flex items-center gap-2">
                  {/* Botón subir CSF */}
                  <label className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition cursor-pointer">
                    <Upload size={15} />
                    {uF?.csfUrl ? 'Actualizar CSF' : 'Subir CSF'}
                    <input type="file" accept="application/pdf" className="hidden" onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      if (file.size > 5 * 1024 * 1024) { mostrarNotificacion('El archivo no debe superar 5MB', 'error'); return; }
                      const reader = new FileReader();
                      reader.onload = async (ev) => {
                        try {
                          const actualizado = await apiActualizarPerfil({ csfUrl: ev.target.result });
                          if (actualizado) dispatch(s => ({ ...s, usuarioPerfil: { ...(s.usuarioPerfil || {}), ...actualizado } }));
                          mostrarNotificacion('CSF subida correctamente', 'success');
                        } catch (err) {
                          mostrarNotificacion(err.message || 'Error al subir la CSF', 'error');
                        }
                      };
                      reader.readAsDataURL(file);
                    }} />
                  </label>
                  {uF?.csfUrl && (
                    <button
                      onClick={async () => {
                        const val = uF.csfUrl;
                        const url = val.startsWith('https://') ? val : await apiGetDownloadUrl(val).catch(() => null);
                        if (url) window.open(url, '_blank');
                      }}
                      className="flex items-center gap-2 px-3 py-2 border border-green-300 rounded-lg text-sm text-green-700 hover:bg-green-50 transition">
                      <Download size={15} /> Ver CSF
                    </button>
                  )}
                  <button
                    onClick={() => {
                      setFormDatosFiscales({ rfc: uF?.rfc || '', razonSocial: uF?.razonSocial || '', regimenFiscal: uF?.regimenFiscal || '', cpFiscal: uF?.cpFiscal || '', usoCfdi: uF?.usoCfdi || 'G03' });
                      setMsgDatosFiscales(null);
                      setModalDatosFiscales(true);
                    }}
                    className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition"
                  >
                    <Settings size={15} /> Datos fiscales
                  </button>
                </div>
              </div>
              <p className="text-gray-500 text-sm mb-4">Solicita facturas por tus fletes y descárgalas cuando estén listas.</p>

              {!datosFiscalesCompletos && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-6 flex items-start gap-3">
                  <AlertCircle size={18} className="text-yellow-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-sm font-semibold text-yellow-800">Completa tus datos fiscales</p>
                    <p className="text-xs text-yellow-700 mt-0.5">Guarda tu RFC, razón social, régimen y CP fiscal para solicitar facturas con un solo clic.</p>
                    <button onClick={() => { setFormDatosFiscales({ rfc: uF?.rfc || '', razonSocial: uF?.razonSocial || '', regimenFiscal: uF?.regimenFiscal || '', cpFiscal: uF?.cpFiscal || '', usoCfdi: uF?.usoCfdi || 'G03' }); setMsgDatosFiscales(null); setModalDatosFiscales(true); }} className="mt-2 text-xs font-semibold text-yellow-800 underline">Completar ahora →</button>
                  </div>
                </div>
              )}

              {/* Viajes sin factura */}
              {viajesSinFactura.length > 0 && (
                <div className="mb-8">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">Viajes sin factura</h3>
                  <div className="space-y-3">
                    {viajesSinFactura.map(viaje => (
                      <div key={viaje.id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex items-center justify-between gap-4">
                        <div className="min-w-0">
                          <p className="font-semibold text-gray-800 truncate">{viaje.ruta}</p>
                          <p className="text-xs text-gray-400">{viaje.transportista} · ${(viaje.costo || 0).toLocaleString('es-MX')} MXN · {viaje.fecha ? new Date(viaje.fecha).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}</p>
                        </div>
                        <button
                          onClick={() => abrirSolicitarFactura(viaje)}
                          className="flex-shrink-0 flex items-center gap-1.5 px-3 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition"
                        >
                          <FileCheck size={14} /> Solicitar factura
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Facturas solicitadas */}
              <div>
                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">Facturas solicitadas</h3>
                {viajesConFactura.length === 0 ? (
                  <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-10 text-center">
                    <FileCheck size={40} className="mx-auto text-gray-300 mb-3" />
                    <p className="text-gray-400 text-sm">Aún no has solicitado ninguna factura</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {viajesConFactura.map(viaje => {
                      const sol = viaje.solicitudFactura;
                      return (
                        <div key={sol.id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
                          <div className="flex items-start justify-between gap-4 mb-3">
                            <div>
                              <p className="font-bold text-gray-800">{viaje.origen} → {viaje.destino}</p>
                              <p className="text-sm text-gray-500">{viaje.transportistaNombre || viaje.transportista || '—'} · ${(viaje.costoFinal ?? viaje.precio ?? 0).toLocaleString('es-MX')} MXN</p>
                              <p className="text-xs text-gray-400 mt-0.5">{new Date(sol.creadoEn).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}</p>
                            </div>
                            <span className={`px-3 py-1 rounded-full text-xs font-semibold flex-shrink-0 ${sol.status === 'subida' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                              {sol.status === 'subida' ? '✅ Disponible' : '⏳ Pendiente'}
                            </span>
                          </div>
                          <div className="bg-gray-50 rounded-lg p-3 mb-3 grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
                            <div><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">RFC</p><p className="font-mono text-gray-800">{sol.rfcReceptor}</p></div>
                            <div><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">Razón Social</p><p className="text-gray-800 truncate">{sol.nombreReceptor}</p></div>
                            {sol.regimenFiscal && <div><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">Régimen</p><p className="text-gray-800">{sol.regimenFiscal}</p></div>}
                            <div><p className="text-xs text-gray-400 font-semibold uppercase mb-0.5">Uso CFDI</p><p className="text-gray-800">{sol.usoCfdi || 'G03'}</p></div>
                          </div>
                          {sol.status === 'subida' ? (
                            <div className="flex flex-wrap gap-3">
                              <a href={sol.pdfUrl} download={`factura-${viaje.id}.pdf`} className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700">
                                <Download size={15} /> Descargar PDF
                              </a>
                              {sol.xmlUrl && (
                                <a href={sol.xmlUrl} download={`factura-${viaje.id}.xml`} className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white text-sm font-semibold rounded-lg hover:bg-indigo-700">
                                  <Download size={15} /> Descargar XML
                                </a>
                              )}
                            </div>
                          ) : (
                            <p className="text-sm text-gray-400 italic">El transportista aún no ha subido la factura.</p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          );
        })()}

        {seccion === 'perfil' && (() => {
          // Merge prop usuario con datos frescos del store (se actualiza al guardar sin F5)
          const uBase = usuario || {};
          const uStore = store.usuarioPerfil?.id === uBase.id ? store.usuarioPerfil : {};
          const u = { ...uBase, ...uStore };

          const fletesCompletados = (store.viajes || []).filter(v => v.clienteId === u.id && v.status === 'completada').length;

          // Parser de dirección: soporta formato nuevo "calle | ciudad" y viejo "calle, Ciudad, ESTADO"
          const _parseDireccion = (dir) => {
            if (!dir) return { calle: '', ciudad: '' };
            const pipeIdx = dir.indexOf(' | ');
            if (pipeIdx >= 0) return { calle: dir.slice(0, pipeIdx), ciudad: dir.slice(pipeIdx + 3) };
            // Formato viejo: detectar si el último segmento es código de estado (2-4 letras mayúsculas)
            const partes = dir.split(',').map(p => p.trim()).filter(Boolean);
            const ultimo = partes[partes.length - 1] || '';
            if (/^[A-ZÁÉÍÓÚ]{2,4}$/.test(ultimo) && partes.length >= 2) {
              return { calle: partes.slice(0, -2).join(', '), ciudad: partes.slice(-2).join(', ') };
            }
            return { calle: '', ciudad: dir };
          };
          const { calle: calleInicial, ciudad: ciudadInicial } = _parseDireccion(u.direccion);

          const iniciarEdicion = () => {
            setFormPerfil({
              nombre: u.nombre || '',
              telefono: u.telefono || '',
              calle: calleInicial,
              ciudad: ciudadInicial,
              curp: u.curp || '',
              rfc: u.rfc || '',
              representante: u.representante || '',
            });
            setEditandoPerfil(true);
            setPerfilGuardado(false);
          };
          const guardar = async () => {
            // Guardar con separador " | " para que ciudad con comas no rompa el parsing
            const direccion = formPerfil.calle
              ? `${formPerfil.calle} | ${formPerfil.ciudad}`
              : formPerfil.ciudad;
            const cambios = {
              nombre: formPerfil.nombre,
              telefono: formPerfil.telefono,
              ciudad: formPerfil.ciudad || null,
              direccion,
              rfc: formPerfil.rfc,
              ...(u.tipoPersona === 'fisica' ? { curp: formPerfil.curp } : {}),
              ...(u.tipoPersona === 'moral' ? { representante: formPerfil.representante } : {}),
            };
            try {
              const actualizado = await apiActualizarPerfil(cambios);
              // Actualizar store local para que la vista se refresque sin F5
              if (actualizado) dispatch(s => ({ ...s, usuarioPerfil: { ...(s.usuarioPerfil || {}), ...actualizado } }));
            } catch (_) {}
            actualizarPerfilCliente(u.id, cambios);
            setEditandoPerfil(false);
            setPerfilGuardado(true);
            setTimeout(() => setPerfilGuardado(false), 3000);
          };
          return (
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-2">Mi Perfil</h2>
              <p className="text-gray-600 mb-6">Administra tu información personal</p>

              <div className="max-w-2xl">
                {/* Avatar */}
                <div className="bg-white rounded-2xl shadow-lg p-6 mb-6 flex items-center space-x-5">
                  <label className="relative cursor-pointer group flex-shrink-0" title="Cambiar foto de perfil">
                    <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center text-white overflow-hidden">
                      {(u.avatar || u.foto)
                        ? <img src={u.avatar || u.foto} alt="avatar" className="w-full h-full object-cover" />
                        : <User size={36} />}
                    </div>
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 rounded-full flex items-center justify-center transition-all">
                      <span className="text-white text-xs font-semibold opacity-0 group-hover:opacity-100">Cambiar</span>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleAvatarChange}
                    />
                  </label>
                  <div>
                    <p className="text-xl font-bold text-gray-800">{u.nombre}</p>
                    <p className="text-gray-500 text-sm">{u.email}</p>
                    <div className="flex items-center space-x-3 mt-1">
                      <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-semibold">
                        {u.tipoPersona === 'moral' ? 'Persona Moral' : 'Persona Física'}
                      </span>
                      <span className="text-gray-400 text-xs">•</span>
                      <span className="text-gray-500 text-sm">{fletesCompletados} fletes completados</span>
                    </div>
                    <p className="text-xs text-gray-400 mt-1">Haz clic en la foto para cambiarla</p>
                  </div>
                </div>

                {/* Datos */}
                <div className="bg-white rounded-2xl shadow-lg p-6">
                  <div className="flex justify-between items-center mb-5">
                    <h3 className="text-lg font-bold text-gray-800">Datos de la cuenta</h3>
                    {!editandoPerfil ? (
                      <button onClick={iniciarEdicion} className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium transition">
                        <Edit2 size={15} />
                        <span>Editar</span>
                      </button>
                    ) : (
                      <div className="flex space-x-2">
                        <button onClick={() => setEditandoPerfil(false)} className="px-4 py-2 border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50 text-sm transition">
                          Cancelar
                        </button>
                        <button onClick={guardar} className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm font-medium transition">
                          <Save size={15} />
                          <span>Guardar</span>
                        </button>
                      </div>
                    )}
                  </div>

                  {perfilGuardado && (
                    <div className="flex items-center space-x-2 bg-green-50 border border-green-200 rounded-lg px-4 py-3 mb-5 text-green-700 text-sm">
                      <CheckCircle size={16} />
                      <span>Perfil actualizado correctamente</span>
                    </div>
                  )}

                  <div className="space-y-4">
                    {/* Nombre */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">
                        {u.tipoPersona === 'moral' ? 'Razón Social' : 'Nombre completo'}
                      </label>
                      {editandoPerfil ? (
                        <input type="text" value={formPerfil.nombre} onChange={e => setFormPerfil(p => ({ ...p, nombre: e.target.value }))}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                      ) : (
                        <p className="text-gray-800">{u.nombre || '—'}</p>
                      )}
                    </div>

                    {/* Email (readonly) */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">Correo electrónico</label>
                      <p className="text-gray-800">{u.email}</p>
                    </div>

                    {/* Teléfono */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">Teléfono</label>
                      {editandoPerfil ? (
                        <input type="tel" value={formPerfil.telefono}
                          onChange={e => setFormPerfil(p => ({ ...p, telefono: e.target.value.replace(/\D/g, '').slice(0, 10) }))}
                          maxLength={10} inputMode="numeric" placeholder="6641234567"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                      ) : (
                        <p className="text-gray-800">{u.telefono || '—'}</p>
                      )}
                    </div>

                    {/* Calle y número */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">Calle y número <span className="text-gray-400 font-normal">(opcional)</span></label>
                      {editandoPerfil ? (
                        <input type="text" value={formPerfil.calle} onChange={e => setFormPerfil(p => ({ ...p, calle: e.target.value }))}
                          placeholder="Ej. Av. Revolución #123"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                      ) : (
                        <p className="text-gray-800">{calleInicial || '—'}</p>
                      )}
                    </div>

                    {/* Ciudad */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">Ciudad</label>
                      {editandoPerfil ? (
                        <CiudadCombobox
                          defaultValue={formPerfil.ciudad}
                          placeholder="Selecciona tu ciudad"
                          onChange={val => setFormPerfil(p => ({ ...p, ciudad: val }))}
                          strictList
                        />
                      ) : (
                        <p className="text-gray-800">{ciudadInicial || '—'}</p>
                      )}
                    </div>

                    {/* CURP (persona física) */}
                    {u.tipoPersona === 'fisica' && (
                      <div>
                        <label className="text-sm font-semibold text-gray-600 block mb-1">CURP</label>
                        {editandoPerfil ? (
                          <input type="text" value={formPerfil.curp}
                            onChange={e => setFormPerfil(p => ({ ...p, curp: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 18) }))}
                            maxLength={18} placeholder="LOPM850615MBCPRR09"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono" />
                        ) : (
                          <p className="text-gray-800">{u.curp || '—'}</p>
                        )}
                      </div>
                    )}

                    {/* RFC (todos los usuarios) */}
                    <div>
                      <label className="text-sm font-semibold text-gray-600 block mb-1">RFC</label>
                      {editandoPerfil ? (
                        <input type="text" value={formPerfil.rfc}
                          onChange={e => setFormPerfil(p => ({ ...p, rfc: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 13) }))}
                          maxLength={13} placeholder={u.tipoPersona === 'moral' ? 'DPA850615XXX' : 'LOPM850615H07'}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono" />
                      ) : (
                        <p className="text-gray-800">{u.rfc || '—'}</p>
                      )}
                    </div>

                    {/* Representante Legal (persona moral) */}
                    {u.tipoPersona === 'moral' && (
                      <div>
                        <label className="text-sm font-semibold text-gray-600 block mb-1">Representante Legal</label>
                        {editandoPerfil ? (
                          <input type="text" value={formPerfil.representante} onChange={e => setFormPerfil(p => ({ ...p, representante: e.target.value }))}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                        ) : (
                          <p className="text-gray-800">{u.representante || '—'}</p>
                        )}
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </div>
          );
        })()}

      </div>
      </div>

      {/* MODAL: Plantillas de rutas */}
      {mostrarPlantillas && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
          <div className="bg-white shadow-2xl rounded-2xl w-full max-w-lg">
            <div className="p-6 border-b flex justify-between items-center">
              <div>
                <h3 className="text-xl font-bold text-gray-800">Mis Plantillas de Ruta</h3>
                <p className="text-sm text-gray-500">Selecciona una para pre-llenar el formulario</p>
              </div>
              <button onClick={() => setMostrarPlantillas(false)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
            </div>
            <div className="p-6 space-y-3 max-h-96 overflow-y-auto">
              {(store.plantillasRutas || []).filter(p => p.clienteId === usuario?.id).length === 0 ? (
                <p className="text-gray-400 text-center py-8">No tienes plantillas guardadas aún</p>
              ) : (store.plantillasRutas || []).filter(p => p.clienteId === usuario?.id).map(p => (
                <div key={p.id} className="flex items-center gap-4 p-4 border border-gray-200 rounded-xl hover:border-blue-300 hover:bg-blue-50 transition">
                  <div className="flex-1">
                    <p className="font-semibold text-gray-800">{p.nombre}</p>
                    <p className="text-sm text-gray-500">{p.origen} → {p.destino}</p>
                    <p className="text-xs text-gray-400">{p.carga} · {p.peso} tons</p>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => {
                        setSolicitudParaRepetir({ origen: p.origen, destino: p.destino, carga: p.carga, peso: p.peso, tipoUnidad: p.tipoUnidad || '', origenCoords: p.origenCoords || null, destinoCoords: p.destinoCoords || null });
                        setOrigenCoords(p.origenCoords || null);
                        setDestinoCoords(p.destinoCoords || null);
                        setFotosFormulario([]);
                        setMostrarPlantillas(false);
                        setMostrarFormulario(true);
                      }}
                      className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700"
                    >
                      Usar
                    </button>
                    <button
                      onClick={() => eliminarPlantillaRuta(p.id)}
                      className="p-2 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* MODALES */}
      {mostrarFormulario && (
        <FormularioSolicitudModal
          onClose={() => { setMostrarFormulario(false); setSolicitudParaRepetir(null); setSolicitudEditando(null); }}
          onSubmit={solicitudEditando ? editarSolicitud : crearSolicitud}
          onAbrirMapa={abrirMapa}
          origenCoords={origenCoords}
          destinoCoords={destinoCoords}
          fotosFormulario={fotosFormulario}
          setFotosFormulario={setFotosFormulario}
          setOrigenCoords={setOrigenCoords}
          setDestinoCoords={setDestinoCoords}
          solicitudBase={solicitudEditando
            ? { ...solicitudEditando, carga: solicitudEditando.descripcion || solicitudEditando.carga }
            : solicitudParaRepetir}
          modoEditar={!!solicitudEditando}
        />
      )}
      {mostrarCotizaciones && ModalCotizaciones()}
      {mostrarComparador && ModalComparador()}
      {mostrarConfirmacion && ModalConfirmacion()}
      
      {/* Modal: Pasarela de Pago */}
      {mostrarPasarelaPago && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
          <div className="bg-white shadow-2xl rounded-xl max-w-lg w-full">
            {!pagoCompletado ? (
              <>
                <div className="p-6 border-b">
                  <div className="flex justify-between items-center">
                    <div>
                      <h3 className="text-xl font-bold text-gray-800">Pago Seguro</h3>
                      <p className="text-gray-500 text-sm">Completa el pago para confirmar tu flete</p>
                    </div>
                    {!procesandoPago && (
                      <button onClick={() => setMostrarPasarelaPago(false)} className="text-gray-400 hover:text-gray-600">
                        <X size={24} />
                      </button>
                    )}
                  </div>
                </div>

                <div className="p-6">
                  {/* Resumen del pago */}
                  <div className="bg-gray-50 rounded-xl p-4 mb-6">
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-gray-600">Transportista:</span>
                      <span className="font-semibold">{cotizacionGanadora?.transportista}</span>
                    </div>
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-gray-600">Ruta:</span>
                      <span className="font-medium">{solicitudSeleccionada?.origen} → {solicitudSeleccionada?.destino}</span>
                    </div>
                    <div className="border-t pt-3 mt-3">
                      <div className="flex justify-between items-center">
                        <span className="text-lg font-semibold">Total a pagar:</span>
                        <span className="text-2xl font-bold text-green-600">${cotizacionGanadora?.precio.toLocaleString()} MXN</span>
                      </div>
                    </div>
                  </div>


                  {/* Pago con MercadoPago */}
                  {!procesandoPago ? (
                    <div className="space-y-3">
                      <p className="text-sm text-gray-500 mb-4 text-center">Serás redirigido a MercadoPago para completar el pago de forma segura.</p>
                      <button
                        onClick={procesarPago}
                        className="w-full p-4 bg-[#009EE3] hover:bg-[#0080C0] text-white rounded-xl transition flex items-center justify-center space-x-3 font-semibold text-lg"
                      >
                        <img src="https://http2.mlstatic.com/frontend-assets/mp-web-navigation/ui-navigation/5.21.22/mercadopago/logo__large@2x.png" alt="MercadoPago" className="h-6" onError={e => e.target.style.display='none'} />
                        <span>Pagar con MercadoPago</span>
                      </button>
                      <p className="text-xs text-gray-400 text-center">Acepta tarjetas, OXXO, SPEI y más</p>
                    </div>
                  ) : (
                    <div className="text-center py-8">
                      <div className="w-16 h-16 border-4 border-[#009EE3] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                      <p className="text-lg font-semibold text-gray-800">Preparando pago...</p>
                      <p className="text-gray-400">Serás redirigido a MercadoPago</p>
                    </div>
                  )}

                  {/* Seguridad */}
                  <div className="mt-6 flex items-center justify-center space-x-2 text-gray-500 text-sm">
                    <Lock size={16} />
                    <span>Pago seguro encriptado con SSL</span>
                    <ShieldCheck size={16} className="text-green-500" />
                  </div>
                </div>
              </>
            ) : (
              <div className="p-8 text-center">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle size={48} className="text-green-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-2">¡Pago Exitoso!</h3>
                <p className="text-gray-600 mb-4">Tu pago ha sido procesado correctamente.</p>
                <div className="bg-green-50 rounded-xl p-4 mb-4">
                  <p className="text-sm text-green-700">
                    <strong>{cotizacionGanadora?.transportista}</strong> ha sido notificado y te contactará en breve para coordinar la recolección.
                  </p>
                </div>
                <p className="text-sm text-gray-500">Redirigiendo a tus viajes activos...</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal: Calificar Servicio */}
      {mostrarCalificar && (
        ModalCalificar()
      )}


      {/* Modal: Chat */}
      {chatModal && (
        <ChatModal
          viajeId={chatModal.viajeId}
          usuarioId={usuario?.id}
          usuarioNombre={usuario?.nombre || 'Cliente'}
          usuarioRol="cliente"
          contraparte={chatModal.contraparte}
          onClose={() => { chatModalRef.current = null; setLastSeenMessages(prev => { const next = {...prev, [chatModal.viajeId]: new Date().toISOString()}; sessionStorage.setItem(_chatSeenKey, JSON.stringify(next)); return next; }); setChatModal(null); }}
        />
      )}

      {/* Modal: Confirmar Entrega */}
      {/* ── Modal: Cancelar viaje ── */}
      {cancelarViajeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
          <div className="bg-white shadow-2xl rounded-2xl p-8 max-w-md w-full">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <XCircle size={36} className="text-red-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Cancelar viaje</h2>
              <p className="text-gray-600 text-sm">Esta acción no se puede deshacer. Revisa las condiciones antes de confirmar.</p>
            </div>

            <div className="bg-gray-50 rounded-xl p-4 mb-4 text-sm text-gray-700 space-y-1">
              <p><span className="font-semibold">Ruta:</span> {cancelarViajeModal.origen} → {cancelarViajeModal.destino}</p>
            </div>

            {/* Penalización si ya hay pago en escrow */}
            {cancelarViajeModal.tieneEscrow && cancelarViajeModal.monto > 0 && (
              <div className="bg-orange-50 border border-orange-200 rounded-xl px-4 py-3 mb-4">
                <p className="text-sm font-bold text-orange-700 mb-2">⚠️ Penalización por cancelación</p>
                <div className="space-y-1">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Monto pagado</span>
                    <span className="font-semibold">${cancelarViajeModal.monto.toLocaleString('es-MX')} MXN</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-red-600">Penalización (10%)</span>
                    <span className="font-semibold text-red-600">-${Math.round(cancelarViajeModal.monto * 0.10).toLocaleString('es-MX')} MXN</span>
                  </div>
                  <div className="flex justify-between text-sm border-t border-orange-200 pt-1 mt-1">
                    <span className="text-green-700 font-semibold">Recibirás de reembolso</span>
                    <span className="font-bold text-green-700">${Math.round(cancelarViajeModal.monto * 0.90).toLocaleString('es-MX')} MXN</span>
                  </div>
                  <p className="text-xs text-orange-500 mt-1">El reembolso se procesa en 1–5 días hábiles.</p>
                </div>
              </div>
            )}

            {/* Indicador de límite de cancelaciones */}
            <div className="flex items-center gap-2 bg-yellow-50 border border-yellow-200 rounded-xl px-4 py-2.5 mb-4">
              <span className="text-yellow-600 text-base">⚠️</span>
              <p className="text-xs text-yellow-700">Límite: <strong>3 cancelaciones cada 30 días.</strong> Úsalas con cuidado.</p>
            </div>

            {/* Error — chofer en camino u otro bloqueo */}
            {cancelModalError && (
              <div className="bg-red-50 border border-red-300 rounded-xl px-4 py-3 mb-4">
                <p className="text-sm font-bold text-red-700 mb-1">❌ No se puede cancelar</p>
                <p className="text-sm text-red-600">{cancelModalError}</p>
                <button
                  onClick={async () => {
                    const viajeId = cancelarViajeModal.id;
                    const ruta = `${cancelarViajeModal.origen} → ${cancelarViajeModal.destino}`;
                    // Enviar ticket automático para que aparezca en panel Soporte del admin
                    await apiEnviarMensaje({
                      viajeId,
                      texto: `[TICKET - Cancelación bloqueada] Necesito ayuda para cancelar el viaje ${ruta}. El chofer ya está en camino.`,
                      destinatarioRol: 'admin'
                    }).catch(() => {});
                    setCancelarViajeModal(null);
                    setCancelModalError(null);
                    const _cm = { viajeId, contraparte: { id: 'admin', nombre: 'Soporte Choyero', rol: 'admin' } };
                    chatModalRef.current = _cm;
                    setChatModal(_cm);
                  }}
                  className="mt-2 w-full flex items-center justify-center gap-2 px-3 py-2 bg-blue-50 hover:bg-blue-100 border border-blue-200 text-blue-700 text-sm font-semibold rounded-lg transition"
                >
                  💬 Contactar soporte ahora
                </button>
              </div>
            )}

            {!cancelModalError && (
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Motivo de cancelación <span className="text-gray-400 font-normal">(opcional)</span></label>
                <textarea
                  value={cancelarMotivo}
                  onChange={e => setCancelarMotivo(e.target.value)}
                  placeholder="Ej: Ya no necesito el servicio, encontré otra opción..."
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-red-300"
                  rows={3}
                  maxLength={300}
                />
              </div>
            )}

            <div className="flex space-x-3">
              <button
                onClick={() => { setCancelarViajeModal(null); setCancelarMotivo(''); setCancelModalError(null); }}
                disabled={cancelandoViaje}
                className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 font-semibold disabled:opacity-50"
              >
                {cancelModalError ? 'Cerrar' : 'Volver'}
              </button>
              {!cancelModalError && (
                <button
                  disabled={cancelandoViaje}
                  onClick={async () => {
                    setCancelndoViaje(true);
                    setCancelModalError(null);
                    try {
                      await apiCancelarViaje(cancelarViajeModal.id, cancelarMotivo.trim() || undefined);
                      dispatch(s => ({
                        ...s,
                        viajes: (s.viajes || []).map(v =>
                          v.id === cancelarViajeModal.id ? { ...v, status: 'cancelado' } : v
                        )
                      }));
                      recargar();
                      setCancelarViajeModal(null);
                      setCancelarMotivo('');
                      setNotificacion({ tipo: 'success', mensaje: 'Viaje cancelado correctamente.' });
                      setTimeout(() => setNotificacion(null), 2500);
                    } catch (err) {
                      const msg = err?.message || 'No se pudo cancelar el viaje.';
                      // Si es límite de cancelaciones, mostrar dentro del modal (no desaparece)
                      if (msg.toLowerCase().includes('límite') || msg.toLowerCase().includes('limite') || msg.toLowerCase().includes('cancelaciones')) {
                        setCancelModalError(msg);
                      } else {
                        setNotificacion({ tipo: 'error', mensaje: msg });
                        setTimeout(() => setNotificacion(null), 3000);
                      }
                    } finally {
                      setCancelndoViaje(false);
                    }
                  }}
                  className="flex-1 px-4 py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 font-bold flex items-center justify-center space-x-2 disabled:opacity-50"
                >
                  {cancelandoViaje ? <span className="animate-spin">⏳</span> : <XCircle size={18} />}
                  <span>{cancelandoViaje ? 'Cancelando...' : 'Confirmar cancelación'}</span>
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── Modal: Pagar Contra Entrega ── */}
      {modalContraEntrega && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[1100]">
          <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CreditCard size={32} className="text-blue-600" />
              </div>
              <h2 className="text-xl font-bold text-gray-800 mb-2">Pago contra entrega</h2>
              <p className="text-gray-600 text-sm">Tu mercancía fue entregada. Realiza el pago final para completar el flete.</p>
            </div>
            <div className="bg-blue-50 rounded-xl p-4 mb-6 text-center">
              <p className="text-xs text-blue-600 font-semibold uppercase mb-1">Monto a pagar</p>
              <p className="text-3xl font-black text-blue-800">${(modalContraEntrega.monto || 0).toLocaleString('es-MX', { minimumFractionDigits: 0 })} MXN</p>
            </div>
            <div className="flex gap-3">
              <button onClick={() => setModalContraEntrega(null)} className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 font-semibold text-sm">
                Pagar después
              </button>
              <button
                disabled={procesandoContraEntrega}
                onClick={async () => {
                  setProcesandoContraEntrega(true);
                  try {
                    const resultado = await apiCrearPreferenciaContraEntrega(modalContraEntrega.viajeId);
                    setModalContraEntrega(null);
                    if (resultado.bypass) { recargar(); return; }
                    const url = resultado.paymentUrl || (process.env.NODE_ENV === 'production' ? resultado.initPoint : resultado.sandboxInitPoint);
                    window.location.href = url;
                  } catch { mostrarNotificacion('Error al procesar el pago. Intenta de nuevo.', 'error'); }
                  finally { setProcesandoContraEntrega(false); }
                }}
                className="flex-1 px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold text-sm flex items-center justify-center gap-2 disabled:opacity-50"
              >
                {procesandoContraEntrega ? 'Procesando...' : <><CreditCard size={16} /> Pagar ahora</>}
              </button>
            </div>
          </div>
        </div>
      )}

      {confirmarEntregaViajeId && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
          <div className="bg-white shadow-2xl rounded-2xl p-8 max-w-md w-full">
            {(() => {
              const v = store.viajes.find(x => x.id === confirmarEntregaViajeId);
              const esDos = v?.flujoPago === 'dos_pagos';
              return (
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <CheckCircle size={36} className="text-green-600" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-2">Confirmar de Recibido</h2>
                  <p className="text-gray-600">
                    {esDos
                      ? 'Al confirmar, declaras que recibiste tu carga. A continuación realizarás el pago del 50% restante para liberar los fondos al transportista.'
                      : 'Al confirmar, declaras que recibiste tu carga en buen estado y el pago al transportista será liberado.'}
                  </p>
                  {esDos && <div className="mt-2 inline-flex items-center gap-1 text-xs bg-blue-50 text-blue-700 px-3 py-1 rounded-full font-semibold">💳 Se solicitará el pago contra entrega</div>}
                </div>
              );
            })()}
            <div className="bg-gray-50 rounded-xl p-4 mb-4 text-sm text-gray-700 space-y-1">
              <p><span className="font-semibold">Viaje:</span> {confirmarEntregaViajeId}</p>
              {(() => {
                const v = store.viajes.find(x => x.id === confirmarEntregaViajeId);
                return v ? (
                  <>
                    <p><span className="font-semibold">Ruta:</span> {v.origen} → {v.destino}</p>
                    <p><span className="font-semibold">Transportista:</span> {v.transportistaNombre || v.transportista}</p>
                  </>
                ) : null;
              })()}
            </div>
            <div className="flex space-x-3">
              <button
                onClick={() => setConfirmarEntregaViajeId(null)}
                className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 font-semibold"
              >
                Cancelar
              </button>
              <button
                onClick={async () => {
                  const viajeId = confirmarEntregaViajeId;
                  const v = store.viajes.find(x => x.id === viajeId);
                  setConfirmarEntregaViajeId(null);
                  if (v?.retornoId) {
                    confirmarEntregaCliente(viajeId);
                    apiConfirmarEntregaRetorno(v.retornoId)
                      .then(() => setPagosRefreshKey(k => k + 1))
                      .catch(() => mostrarNotificacion('Error al confirmar entrega. Por favor intenta de nuevo.', 'error'))
                      .finally(() => recargar());
                    return;
                  }
                  // Flete normal
                  try {
                    const resp = await apiConfirmarEntrega(viajeId);
                    if (resp?.flujo === 'dos_pagos' && resp?.contraEntrega) {
                      // Contra entrega pendiente — mostrar modal de pago
                      setModalContraEntrega({ viajeId, monto: resp.monto });
                      mostrarNotificacion('¡Mercancía confirmada! Ahora realiza el pago final.', 'success');
                    } else {
                      // Pago único — flujo normal
                      confirmarEntregaCliente(viajeId);
                      mostrarNotificacion('¡Entrega confirmada! El transportista ha sido notificado.', 'success');
                      setPagosRefreshKey(k => k + 1);
                      if (v && !yaCalificadoPorCliente(v.id)) {
                        setTimeout(() => setMostrarCalificar({
                          id: v.id, ruta: `${v.origen} → ${v.destino}`,
                          transportista: v.transportistaNombre || v.transportista,
                          transportistaId: v.transportistaId, choferId: v.choferId
                        }), 600);
                      }
                    }
                  } catch {
                    mostrarNotificacion('Error al confirmar entrega. Por favor intenta de nuevo.', 'error');
                  }
                  recargar();
                }}
                className="flex-1 px-4 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 font-bold flex items-center justify-center space-x-2"
              >
                <CheckCircle size={18} />
                <span>Confirmar de Recibido</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL: DIRECCIONES DE RECOGIDA Y ENTREGA ===== */}
      {formDirecciones.retornoId && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1100]">
          <div className="bg-white shadow-2xl rounded-xl max-w-md w-full">
            <div className="flex items-center justify-between p-5 border-b">
              <div>
                <h3 className="text-lg font-bold text-gray-800">📍 Direcciones del servicio</h3>
                <p className="text-xs text-gray-500 mt-0.5">El chofer necesita las direcciones exactas</p>
              </div>
              <button onClick={() => setFormDirecciones({ retornoId: null, ofertaId: null, origenDir: '', destinoDir: '' })} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Dirección de recogida *</label>
                <input type="text" value={formDirecciones.origenDir}
                  onChange={e => setFormDirecciones({...formDirecciones, origenDir: e.target.value})}
                  placeholder="Ej. Av. Revolución 450, Col. Centro, Ensenada, BC"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 text-sm" />
                <p className="text-xs text-gray-400 mt-1">Calle, número, colonia y ciudad donde se recogerá la carga</p>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Dirección de entrega *</label>
                <input type="text" value={formDirecciones.destinoDir}
                  onChange={e => setFormDirecciones({...formDirecciones, destinoDir: e.target.value})}
                  placeholder="Ej. Blvd. Lázaro Cárdenas 120, San Quintín, BC"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 text-sm" />
                <p className="text-xs text-gray-400 mt-1">Calle, número, colonia y ciudad de destino final</p>
              </div>
              <div className="flex space-x-3 pt-1">
                <button onClick={() => setFormDirecciones({ retornoId: null, ofertaId: null, origenDir: '', destinoDir: '' })}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-700 hover:bg-gray-50 text-sm">
                  Cancelar
                </button>
                <button
                  disabled={!formDirecciones.origenDir.trim() || !formDirecciones.destinoDir.trim()}
                  onClick={() => {
                    confirmarDireccionesRetorno(formDirecciones.retornoId, formDirecciones.ofertaId, formDirecciones.origenDir.trim(), formDirecciones.destinoDir.trim());
                    // Leer oferta actualizada para pasar a la pasarela
                    const st = getStore();
                    const retActual = (st.retornosVacios || []).find(r => r.id === formDirecciones.retornoId);
                    const ofertaActual = (retActual?.ofertas || []).find(o => o.id === formDirecciones.ofertaId);
                    if (retActual && ofertaActual) {
                      setRetornoPagar({ retorno: retActual, oferta: ofertaActual });
                      setPagoRetornoCompletado(false);
                    }
                    setFormDirecciones({ retornoId: null, ofertaId: null, origenDir: '', destinoDir: '' });
                  }}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
                  Confirmar y pagar →
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===== PASARELA DE PAGO: RETORNO VACÍO ===== */}
      {retornoPagar && (() => {
        const monto = Number(retornoPagar.oferta.contrapropuesta ?? retornoPagar.oferta.precio ?? retornoPagar.oferta.monto ?? 0);
        return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1100]">
          <div className="bg-white shadow-2xl rounded-xl max-w-lg w-full">
            <div className="p-6 border-b flex justify-between items-center">
              <div>
                <h3 className="text-xl font-bold text-gray-800">Pago Seguro — Flete Retorno</h3>
                <p className="text-gray-500 text-sm">Completa el pago para confirmar el flete</p>
              </div>
              <button onClick={() => setRetornoPagar(null)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
            </div>
            <div className="p-6">
              <div className="bg-gray-50 rounded-xl p-4 mb-6 space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Transportista:</span>
                  <span className="font-semibold">{retornoPagar.retorno.empresaNombre || retornoPagar.retorno.empresa?.nombre || '—'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Ruta:</span>
                  <span className="font-medium">{retornoPagar.retorno.origenActual || retornoPagar.retorno.origen} → {retornoPagar.retorno.destino}</span>
                </div>
                {(retornoPagar.retorno.tipoUnidad || retornoPagar.retorno.tipoVehiculo) && (
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-400">Unidad:</span>
                    <span>{retornoPagar.retorno.tipoUnidad || retornoPagar.retorno.tipoVehiculo}{retornoPagar.retorno.capacidadDisponible || retornoPagar.retorno.capacidad ? ` · ${retornoPagar.retorno.capacidadDisponible || retornoPagar.retorno.capacidad}` : ''}</span>
                  </div>
                )}
                {retornoPagar.oferta.peso && (
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-400">Tu carga:</span>
                    <span>{retornoPagar.oferta.peso} ton{retornoPagar.oferta.volumen ? ` · ${retornoPagar.oferta.volumen} m³` : ''}</span>
                  </div>
                )}
                <div className="border-t pt-3 mt-3 flex justify-between items-center">
                  <span className="text-lg font-semibold">Total a pagar:</span>
                  <span className="text-2xl font-bold text-green-600">${monto.toLocaleString()} MXN</span>
                </div>
              </div>
              {retornoPagar.oferta.fotos?.length > 0 && (
                <div className="mb-4">
                  <p className="text-xs font-semibold text-gray-500 mb-2">Fotos del flete adjuntas</p>
                  <div className="flex gap-2 flex-wrap">
                    {retornoPagar.oferta.fotos.map((f, i) => (
                      <img key={i} src={f} alt={`flete-${i}`} className="w-16 h-16 object-cover rounded-lg border" />
                    ))}
                  </div>
                </div>
              )}
              <button
                onClick={async () => {
                  try {
                    const resultado = await apiCrearPreferenciaRetorno(retornoPagar.retorno.id, retornoPagar.oferta.id);
                    if (resultado.bypass) {
                      confirmarPagoRetorno(retornoPagar.retorno.id, retornoPagar.oferta.id);
                      setRetornoPagar(null);
                      await recargar();
                      mostrarNotificacion(`✅ ¡Pago confirmado! ${retornoPagar.retorno.empresaNombre || 'El transportista'} ha sido notificado.`, 'success');
                      setSeccion('viajes');
                      if (resultado.viajeId) {
                        setExpandedViaje(resultado.viajeId);
                        setTimeout(() => document.getElementById(`viaje-${resultado.viajeId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 300);
                      }
                    } else {
                      try { sessionStorage.setItem('choyero_retorno_pago', JSON.stringify({ retornoId: retornoPagar.retorno.id, ofertaId: retornoPagar.oferta.id, viajeId: resultado.viajeId })); } catch (_) {}
                      const url = resultado.paymentUrl || (process.env.NODE_ENV === 'production' ? resultado.initPoint : resultado.sandboxInitPoint);
                      window.location.href = url;
                    }
                  } catch (e) {
                    mostrarNotificacion(e.message || 'Error al iniciar el pago. Intenta de nuevo.', 'error');
                  }
                }}
                className="w-full py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl flex items-center justify-center gap-3 text-lg transition-colors"
              >
                <CreditCard size={22} />
                Pagar con MercadoPago
              </button>
              <p className="text-xs text-center text-gray-400 mt-3">Visa · Mastercard · AMEX · OXXO · SPEI · Efectivo</p>
            </div>
          </div>
        </div>
        );
      })()}

      {/* ── Modal: Datos Fiscales REQUERIDOS antes de pagar ── */}
      {modalFiscalRequerido && (() => {
        const uF = store.usuarioPerfil?.id === usuario?.id ? { ...usuario, ...store.usuarioPerfil } : usuario;
        const datosFiscalesCompletos = uF?.rfc && uF?.razonSocial && uF?.regimenFiscal && uF?.cpFiscal;
        const csfSubido = !!uF?.csfUrl;
        const todoCompleto = datosFiscalesCompletos && csfSubido;

        const continuar = () => {
          setModalFiscalRequerido(false);
          setMostrarPasarelaPago(true);
          setPagoCompletado(false);
          setProcesandoPago(false);
        };

        return (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[1200] p-4">
            <div className="bg-white rounded-2xl w-full max-w-lg shadow-2xl">
              {/* Header */}
              <div className="bg-orange-50 border-b border-orange-100 px-6 py-4 rounded-t-2xl flex items-start gap-3">
                <div className="w-10 h-10 bg-orange-100 rounded-xl flex items-center justify-center shrink-0 mt-0.5">
                  <FileText size={20} className="text-orange-600" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 text-base">Completa tu información fiscal</h3>
                  <p className="text-gray-500 text-sm mt-0.5">Necesaria para emitir tu CFDI por este servicio.</p>
                </div>
              </div>

              <div className="px-6 py-5 space-y-5">
                {/* Sección: Datos fiscales */}
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <p className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                      {datosFiscalesCompletos
                        ? <><CheckCircle size={16} className="text-green-500" /> Datos fiscales</>
                        : <><AlertCircle size={16} className="text-orange-500" /> Datos fiscales</>}
                    </p>
                    {datosFiscalesCompletos && <span className="text-xs text-green-600 font-medium">Completo ✓</span>}
                  </div>
                  {!datosFiscalesCompletos && (
                    <div className="space-y-2">
                      <div className="grid grid-cols-2 gap-2">
                        <div>
                          <label className="block text-xs font-semibold text-gray-500 mb-1">RFC *</label>
                          <input value={formDatosFiscales.rfc} onChange={e => setFormDatosFiscales(p => ({ ...p, rfc: e.target.value.replace(/[^A-Za-z0-9]/g,'').toUpperCase().slice(0,13) }))} placeholder="XAXX010101000" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm font-mono focus:ring-2 focus:ring-orange-400 outline-none" />
                        </div>
                        <div>
                          <label className="block text-xs font-semibold text-gray-500 mb-1">CP Fiscal *</label>
                          <input value={formDatosFiscales.cpFiscal} onChange={e => setFormDatosFiscales(p => ({ ...p, cpFiscal: e.target.value.replace(/\D/g,'').slice(0,5) }))} placeholder="22000" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm font-mono focus:ring-2 focus:ring-orange-400 outline-none" />
                        </div>
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-gray-500 mb-1">Razón Social / Nombre fiscal *</label>
                        <input value={formDatosFiscales.razonSocial} onChange={e => setFormDatosFiscales(p => ({ ...p, razonSocial: e.target.value }))} placeholder="Empresa Ejemplo S.A. de C.V." className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-orange-400 outline-none" />
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-gray-500 mb-1">Régimen Fiscal *</label>
                        <select value={formDatosFiscales.regimenFiscal} onChange={e => setFormDatosFiscales(p => ({ ...p, regimenFiscal: e.target.value }))} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-orange-400 outline-none">
                          <option value="">Selecciona...</option>
                          <option value="601">601 – General de Ley Personas Morales</option>
                          <option value="612">612 – Personas Físicas con Act. Empresariales</option>
                          <option value="616">616 – Sin Obligaciones Fiscales</option>
                          <option value="621">621 – Incorporación Fiscal</option>
                          <option value="626">626 – Resico – Personas Físicas</option>
                        </select>
                      </div>
                      <button
                        disabled={!formDatosFiscales.rfc || !formDatosFiscales.razonSocial || !formDatosFiscales.regimenFiscal || !formDatosFiscales.cpFiscal}
                        onClick={() => {
                          const datos = { rfc: formDatosFiscales.rfc, razonSocial: formDatosFiscales.razonSocial, regimenFiscal: formDatosFiscales.regimenFiscal, cpFiscal: formDatosFiscales.cpFiscal, usoCfdi: formDatosFiscales.usoCfdi };
                          dispatch(s => ({ ...s, usuarioPerfil: { ...(s.usuarioPerfil || {}), ...datos } }));
                          actualizarPerfilCliente(usuario.id, datos);
                          apiActualizarPerfil(datos).catch(() => {});
                        }}
                        className="w-full py-2 bg-orange-500 hover:bg-orange-400 text-white text-sm font-semibold rounded-xl disabled:opacity-40 transition"
                      >
                        Guardar datos fiscales
                      </button>
                    </div>
                  )}
                </div>

                {/* Divider */}
                <div className="border-t border-gray-100" />

                {/* Sección: CSF */}
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <p className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                      {csfSubido
                        ? <><CheckCircle size={16} className="text-green-500" /> Constancia de Situación Fiscal (CSF)</>
                        : <><AlertCircle size={16} className="text-orange-500" /> Constancia de Situación Fiscal (CSF)</>}
                    </p>
                    {csfSubido && <span className="text-xs text-green-600 font-medium">Subida ✓</span>}
                  </div>
                  {!csfSubido && (
                    <label className="flex items-center justify-center gap-2 w-full border-2 border-dashed border-orange-300 hover:border-orange-400 rounded-xl py-4 cursor-pointer transition bg-orange-50/50">
                      {subiendoCsfPago
                        ? <span className="w-4 h-4 border-2 border-orange-400/40 border-t-orange-500 rounded-full animate-spin" />
                        : <Upload size={18} className="text-orange-400" />}
                      <span className="text-sm text-orange-600 font-medium">{subiendoCsfPago ? 'Subiendo...' : 'Subir CSF (solo PDF)'}</span>
                      <input type="file" accept="application/pdf" className="hidden" onChange={async e => {
                        const file = e.target.files?.[0]; if (!file) return;
                        setSubiendoCsfPago(true);
                        const reader = new FileReader();
                        reader.onload = async ev => {
                          try {
                            const actualizado = await apiActualizarPerfil({ csfUrl: ev.target.result });
                            if (actualizado) dispatch(s => ({ ...s, usuarioPerfil: { ...(s.usuarioPerfil || {}), csfUrl: actualizado.csfUrl || ev.target.result } }));
                            actualizarPerfilCliente(usuario.id, { csfUrl: actualizado?.csfUrl || ev.target.result });
                          } catch { mostrarNotificacion('Error al subir el CSF. Intenta de nuevo.', 'error'); }
                          finally { setSubiendoCsfPago(false); }
                        };
                        reader.readAsDataURL(file);
                        e.target.value = '';
                      }} />
                    </label>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="px-6 pb-5 flex gap-3">
                <button onClick={() => setModalFiscalRequerido(false)} className="flex-1 py-2.5 border border-gray-200 rounded-xl text-gray-500 text-sm hover:bg-gray-50 transition">
                  Cancelar
                </button>
                <button
                  onClick={continuar}
                  disabled={!todoCompleto}
                  className="flex-1 py-2.5 bg-blue-600 hover:bg-blue-500 text-white text-sm font-bold rounded-xl disabled:opacity-40 transition"
                >
                  {todoCompleto ? 'Continuar al pago →' : 'Completa los campos para continuar'}
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Modal: Datos Fiscales ── */}
      {modalDatosFiscales && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1100] p-4">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-gray-800">Mis Datos Fiscales</h3>
              <button onClick={() => setModalDatosFiscales(false)} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
            </div>
            <p className="text-xs text-gray-500 mb-4">Se usan para pre-llenar tus solicitudes de factura. El transportista los recibirá al solicitar.</p>
            <div className="space-y-3">
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">RFC *</label>
                <input value={formDatosFiscales.rfc} onChange={e => setFormDatosFiscales(p => ({ ...p, rfc: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 13) }))} placeholder="XAXX010101000" maxLength={13} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Razón Social / Nombre fiscal *</label>
                <input value={formDatosFiscales.razonSocial} onChange={e => setFormDatosFiscales(p => ({ ...p, razonSocial: e.target.value }))} placeholder="Empresa Ejemplo S.A. de C.V." className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Régimen Fiscal *</label>
                <select value={formDatosFiscales.regimenFiscal} onChange={e => setFormDatosFiscales(p => ({ ...p, regimenFiscal: e.target.value }))} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none">
                  <option value="">Selecciona...</option>
                  <option value="601">601 – General de Ley Personas Morales</option>
                  <option value="612">612 – Personas Físicas con Act. Empresariales</option>
                  <option value="616">616 – Sin Obligaciones Fiscales</option>
                  <option value="621">621 – Incorporación Fiscal</option>
                  <option value="626">626 – Resico – Personas Físicas</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Código Postal Fiscal *</label>
                <input value={formDatosFiscales.cpFiscal} onChange={e => setFormDatosFiscales(p => ({ ...p, cpFiscal: e.target.value.replace(/\D/g, '').slice(0, 5) }))} placeholder="22000" maxLength={5} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Uso del CFDI</label>
                <select value={formDatosFiscales.usoCfdi} onChange={e => setFormDatosFiscales(p => ({ ...p, usoCfdi: e.target.value }))} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none">
                  <option value="G01">G01 – Adquisición de mercancias</option>
                  <option value="G03">G03 – Gastos en general</option>
                  <option value="S01">S01 – Sin efectos fiscales</option>
                  <option value="P01">P01 – Por definir</option>
                </select>
              </div>
            </div>
            {msgDatosFiscales && <p className={`text-xs mt-3 ${msgDatosFiscales.tipo === 'ok' ? 'text-green-600' : 'text-red-500'}`}>{msgDatosFiscales.texto}</p>}
            <div className="flex gap-3 mt-5">
              <button onClick={() => setModalDatosFiscales(false)} className="flex-1 px-4 py-2 border border-gray-300 rounded-xl text-gray-600 text-sm hover:bg-gray-50 transition">Cancelar</button>
              <button
                disabled={!formDatosFiscales.rfc || !formDatosFiscales.razonSocial || !formDatosFiscales.regimenFiscal || !formDatosFiscales.cpFiscal}
                onClick={() => {
                  const datos = { rfc: formDatosFiscales.rfc, razonSocial: formDatosFiscales.razonSocial, regimenFiscal: formDatosFiscales.regimenFiscal, cpFiscal: formDatosFiscales.cpFiscal, usoCfdi: formDatosFiscales.usoCfdi };
                  // Optimista: actualiza store y cierra modal al instante
                  dispatch(s => ({ ...s, usuarioPerfil: { ...(s.usuarioPerfil || {}), ...datos } }));
                  actualizarPerfilCliente(usuario.id, datos);
                  setModalDatosFiscales(false);
                  setToastNotif(q => [...q, { tipo: 'alerta_ok', titulo: '✓ Datos fiscales guardados', mensaje: 'Tu información fiscal fue actualizada.' }]);
                  // Sincroniza con el servidor en segundo plano
                  apiActualizarPerfil(datos).catch(() => {
                    setToastNotif(q => [...q, { tipo: 'alerta_error', titulo: '✗ Error', mensaje: 'No se pudieron guardar los datos fiscales. Intenta de nuevo.' }]);
                  });
                }}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700 disabled:opacity-50 transition"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== MODAL CARTA PORTE ===== */}
      {/* ── Modal: Solicitar Factura ── */}
      {modalSolicitarFactura && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[1100] p-4">
          <div className="bg-white shadow-2xl rounded-2xl w-full max-w-md">
            <div className="p-6 border-b flex justify-between items-center">
              <div>
                <h3 className="text-xl font-bold text-gray-800">Solicitar Factura</h3>
                <p className="text-sm text-gray-500 mt-0.5">{modalSolicitarFactura.viaje?.ruta || `${modalSolicitarFactura.viaje?.origen} → ${modalSolicitarFactura.viaje?.destino}`}</p>
              </div>
              <button onClick={() => setModalSolicitarFactura(null)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-sm text-gray-600 bg-blue-50 border border-blue-200 rounded-lg p-3">El transportista recibirá tus datos fiscales y deberá subir el PDF de la factura a tu nombre.</p>
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">RFC del receptor <span className="text-red-500">*</span></label>
                <input type="text" value={formSolicitarFactura.rfcReceptor}
                  onChange={e => setFormSolicitarFactura(p => ({ ...p, rfcReceptor: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 13) }))}
                  maxLength={13} placeholder="XAXX010101000"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono" />
              </div>
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Razón Social / Nombre fiscal <span className="text-red-500">*</span></label>
                <input type="text" value={formSolicitarFactura.nombreReceptor}
                  onChange={e => setFormSolicitarFactura(p => ({ ...p, nombreReceptor: e.target.value }))}
                  placeholder="Empresa Ejemplo S.A. de C.V."
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-sm font-semibold text-gray-700 block mb-1">Régimen Fiscal</label>
                  <select value={formSolicitarFactura.regimenFiscal}
                    onChange={e => setFormSolicitarFactura(p => ({ ...p, regimenFiscal: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm">
                    <option value="">Seleccionar...</option>
                    <option value="601">601 – Personas Morales</option>
                    <option value="612">612 – Act. Empresariales</option>
                    <option value="616">616 – Sin Obligaciones</option>
                    <option value="621">621 – Incorporación</option>
                    <option value="626">626 – Resico</option>
                  </select>
                </div>
                <div>
                  <label className="text-sm font-semibold text-gray-700 block mb-1">CP Fiscal</label>
                  <input type="text" value={formSolicitarFactura.cpFiscal}
                    onChange={e => setFormSolicitarFactura(p => ({ ...p, cpFiscal: e.target.value.replace(/\D/g, '').slice(0, 5) }))}
                    maxLength={5} placeholder="22000"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono" />
                </div>
              </div>
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Uso del CFDI</label>
                <select value={formSolicitarFactura.usoCfdi}
                  onChange={e => setFormSolicitarFactura(p => ({ ...p, usoCfdi: e.target.value }))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm">
                  <option value="S01">S01 – Sin efectos fiscales</option>
                  <option value="G01">G01 – Adquisición de mercancias</option>
                  <option value="G03">G03 – Gastos en general</option>
                  <option value="P01">P01 – Por definir</option>
                </select>
              </div>
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Notas para el transportista <span className="text-gray-400 font-normal">(opcional)</span></label>
                <textarea rows={2} value={formSolicitarFactura.notas}
                  onChange={e => setFormSolicitarFactura(p => ({ ...p, notas: e.target.value }))}
                  placeholder="Ej: Requiero factura antes del viernes..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" />
              </div>
              <div className="flex gap-3 pt-2">
                <button onClick={() => setModalSolicitarFactura(null)} className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50 text-sm font-medium">Cancelar</button>
                <button
                  disabled={enviandoSolicitudFactura || !formSolicitarFactura.rfcReceptor || !formSolicitarFactura.nombreReceptor}
                  onClick={async () => {
                    setEnviandoSolicitudFactura(true);
                    try {
                      await apiSolicitarFactura(modalSolicitarFactura.viajeId, formSolicitarFactura);
                      setModalSolicitarFactura(null);
                      mostrarNotificacion('Solicitud de factura enviada al transportista', 'success');
                    } catch (e) {
                      mostrarNotificacion(e.message || 'Error al enviar la solicitud', 'error');
                    } finally {
                      setEnviandoSolicitudFactura(false);
                      recargar();
                    }
                  }}
                  className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-semibold disabled:opacity-50"
                >
                  {enviandoSolicitudFactura ? 'Enviando...' : 'Enviar Solicitud'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {modalCartaPorte && cartaPorteForm && (() => {
        const productosGuardados = cpGetGuardados('productos');
        const direccionesGuardadas = cpGetGuardados('direcciones');
        const ESTADOS = ['Baja California','Baja California Sur','Sonora','Sinaloa','Jalisco','Ciudad de México','Nuevo León','Chihuahua','Tamaulipas','Veracruz','Puebla','Guerrero','Oaxaca','Chiapas','Yucatán','Quintana Roo','Campeche','Tabasco','Michoacán','Guanajuato','San Luis Potosí','Zacatecas','Durango','Nayarit','Colima','Aguascalientes','Querétaro','Hidalgo','México','Morelos','Tlaxcala','Coahuila'];
        return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[1100] p-4">
          <div className="bg-white shadow-2xl rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between rounded-t-2xl">
              <div>
                <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2"><FileText size={20} className="text-indigo-600" /> Datos para elaboración de Carta Porte</h3>
                <p className="text-xs text-gray-500 mt-0.5">Esta información será visible para el transportista</p>
              </div>
              <button onClick={() => setModalCartaPorte(null)} className="text-gray-400 hover:text-gray-600"><X size={22} /></button>
            </div>

            <div className="p-6 space-y-6">
              {/* ── Mercancías ── */}
              <div>
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-bold text-gray-700 flex items-center gap-2 text-sm uppercase tracking-wide">
                    <span className="w-6 h-6 bg-indigo-100 text-indigo-700 rounded-full flex items-center justify-center text-xs font-bold">1</span> Mercancías
                  </h4>
                  <button type="button" onClick={() => setCartaPorteForm(f => ({ ...f, mercancias: [...f.mercancias, { descripcion: '', claveSAT: '', pesoKg: '', unidadMedida: 'KGM', tipoEmbalaje: 'AT', cantidad: '', valorDeclarado: '' }] }))} className="flex items-center gap-1 text-xs text-indigo-600 hover:text-indigo-800 font-semibold border border-indigo-300 rounded-lg px-3 py-1.5 hover:bg-indigo-50 transition">
                    <Plus size={13} /> Agregar producto
                  </button>
                </div>

                {/* Selector de producto guardado (si hay alguno) */}
                {productosGuardados.length > 0 && (
                  <div className="mb-3 p-3 bg-amber-50 border border-amber-200 rounded-xl">
                    <p className="text-xs font-semibold text-amber-700 mb-2 flex items-center gap-1"><Save size={12} /> Agregar desde productos guardados</p>
                    <div className="flex gap-2 flex-wrap">
                      {productosGuardados.map(p => (
                        <div key={p._id} className="flex items-center gap-1 bg-white border border-amber-300 rounded-lg px-2 py-1">
                          <button type="button" onClick={() => setCartaPorteForm(f => ({ ...f, mercancias: [...f.mercancias, { descripcion: p.descripcion, claveSAT: p.claveSAT || '', pesoKg: p.pesoKg || '', unidadMedida: p.unidadMedida || 'KGM', tipoEmbalaje: p.tipoEmbalaje || 'AT', cantidad: p.cantidad || '', valorDeclarado: p.valorDeclarado || '' }] }))} className="text-xs text-amber-800 hover:text-indigo-700 font-medium truncate max-w-[140px]">{p.descripcion}</button>
                          <button type="button" onClick={() => { cpDeleteProducto(p._id); mostrarNotificacion('Producto eliminado', 'info'); }} className="text-gray-400 hover:text-red-400 ml-1"><X size={11} /></button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {cartaPorteForm.mercancias.map((m, i) => (
                  <div key={i} className="border border-gray-200 rounded-xl p-4 mb-3 relative">
                    <div className="flex items-center justify-between mb-3">
                      <p className="text-xs font-bold text-gray-500">Producto {i + 1}</p>
                      <div className="flex items-center gap-2">
                        {m.descripcion && (
                          <button type="button" onClick={() => { const { _id, ...prod } = m; const ok = cpSaveProducto(prod); mostrarNotificacion(ok ? 'Producto guardado para futuras cartas porte' : 'Este producto ya está guardado', ok ? 'success' : 'info'); }} className="flex items-center gap-1 text-xs text-amber-600 hover:text-amber-800 font-semibold">
                            <Save size={12} /> Guardar
                          </button>
                        )}
                        {cartaPorteForm.mercancias.length > 1 && (
                          <button type="button" onClick={() => setCartaPorteForm(f => ({ ...f, mercancias: f.mercancias.filter((_, idx) => idx !== i) }))} className="text-red-400 hover:text-red-600"><Trash2 size={15} /></button>
                        )}
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="col-span-2">
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Descripción *</label>
                        <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={m.descripcion} onChange={e => setCartaPorteForm(f => { const ms = [...f.mercancias]; ms[i] = { ...ms[i], descripcion: e.target.value }; return { ...f, mercancias: ms }; })} placeholder="Ej: Cajas de electrodomésticos" />
                      </div>
                      <div>
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Clave SAT</label>
                        <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={m.claveSAT} onChange={e => setCartaPorteForm(f => { const ms = [...f.mercancias]; ms[i] = { ...ms[i], claveSAT: e.target.value }; return { ...f, mercancias: ms }; })} placeholder="Ej: 24102501" />
                      </div>
                      <div>
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Cantidad</label>
                        <input type="number" onWheel={e => e.target.blur()} className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={m.cantidad} onChange={e => setCartaPorteForm(f => { const ms = [...f.mercancias]; ms[i] = { ...ms[i], cantidad: e.target.value }; return { ...f, mercancias: ms }; })} placeholder="Ej: 10" />
                      </div>
                      <div>
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Peso bruto (kg)</label>
                        <input type="number" onWheel={e => e.target.blur()} className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={m.pesoKg} onChange={e => setCartaPorteForm(f => { const ms = [...f.mercancias]; ms[i] = { ...ms[i], pesoKg: e.target.value }; return { ...f, mercancias: ms }; })} placeholder="Ej: 500" />
                      </div>
                      <div>
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Unidad de medida</label>
                        <select className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={m.unidadMedida} onChange={e => setCartaPorteForm(f => { const ms = [...f.mercancias]; ms[i] = { ...ms[i], unidadMedida: e.target.value }; return { ...f, mercancias: ms }; })}>
                          <option value="KGM">KGM — Kilogramo</option>
                          <option value="TNE">TNE — Tonelada</option>
                          <option value="H87">H87 — Pieza</option>
                          <option value="LTR">LTR — Litro</option>
                          <option value="MTR">MTR — Metro</option>
                        </select>
                      </div>
                      <div>
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Tipo de embalaje</label>
                        <select className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={m.tipoEmbalaje} onChange={e => setCartaPorteForm(f => { const ms = [...f.mercancias]; ms[i] = { ...ms[i], tipoEmbalaje: e.target.value }; return { ...f, mercancias: ms }; })}>
                          <option value="AT">AT — Tarima</option>
                          <option value="1A">1A — Tambor de acero</option>
                          <option value="1C">1C — Bolsa</option>
                          <option value="4G">4G — Caja de cartón</option>
                          <option value="5M">5M — Barril</option>
                          <option value="MX">MX — Sin embalaje (granel)</option>
                        </select>
                      </div>
                      <div className="col-span-2">
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Valor declarado (MXN)</label>
                        <input type="number" onWheel={e => e.target.blur()} className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={m.valorDeclarado} onChange={e => setCartaPorteForm(f => { const ms = [...f.mercancias]; ms[i] = { ...ms[i], valorDeclarado: e.target.value }; return { ...f, mercancias: ms }; })} placeholder="Ej: 50000" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* ── Remitente & Destinatario ── */}
              {['remitente', 'destinatario'].map((tipo) => (
                <div key={tipo}>
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="font-bold text-gray-700 flex items-center gap-2 text-sm uppercase tracking-wide">
                      <span className="w-6 h-6 bg-indigo-100 text-indigo-700 rounded-full flex items-center justify-center text-xs font-bold">{tipo === 'remitente' ? '2' : '3'}</span>
                      {tipo === 'remitente' ? 'Remitente (quien envía)' : 'Destinatario (quien recibe)'}
                    </h4>
                    {cartaPorteForm[tipo].nombre && (
                      <button type="button" onClick={() => { const { _id, ...dir } = cartaPorteForm[tipo]; const ok = cpSaveDireccion(dir); mostrarNotificacion(ok ? 'Dirección guardada' : 'Esta dirección ya está guardada', ok ? 'success' : 'info'); }} className="flex items-center gap-1 text-xs text-amber-600 hover:text-amber-800 font-semibold">
                        <Save size={12} /> Guardar dirección
                      </button>
                    )}
                  </div>

                  {/* Selector de dirección guardada */}
                  {direccionesGuardadas.length > 0 && (
                    <div className="mb-3 p-3 bg-amber-50 border border-amber-200 rounded-xl">
                      <p className="text-xs font-semibold text-amber-700 mb-2 flex items-center gap-1"><Save size={12} /> Usar dirección guardada</p>
                      <div className="flex gap-2 flex-wrap">
                        {direccionesGuardadas.map(d => (
                          <div key={d._id} className="flex items-center gap-1 bg-white border border-amber-300 rounded-lg px-2 py-1">
                            <button type="button" onClick={() => { const { _id, ...dir } = d; setCartaPorteForm(f => ({ ...f, [tipo]: dir })); }} className="text-xs text-amber-800 hover:text-indigo-700 font-medium truncate max-w-[150px]">{d.nombre}</button>
                            <button type="button" onClick={() => { cpDeleteDireccion(d._id); mostrarNotificacion('Dirección eliminada', 'info'); }} className="text-gray-400 hover:text-red-400 ml-1"><X size={11} /></button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="grid grid-cols-2 gap-3">
                    <div className="col-span-2">
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Nombre / Razón Social *</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={cartaPorteForm[tipo].nombre} onChange={e => setCartaPorteForm(f => ({ ...f, [tipo]: { ...f[tipo], nombre: e.target.value } }))} placeholder="Ej: Empresa Ejemplo S.A. de C.V." />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">RFC *</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none font-mono" value={cartaPorteForm[tipo].rfc} onChange={e => setCartaPorteForm(f => ({ ...f, [tipo]: { ...f[tipo], rfc: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 13) } }))} placeholder="XAXX010101000" maxLength={13} />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Código Postal *</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={cartaPorteForm[tipo].cp} onChange={e => setCartaPorteForm(f => ({ ...f, [tipo]: { ...f[tipo], cp: e.target.value } }))} placeholder="Ej: 22000" maxLength={5} />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Calle</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={cartaPorteForm[tipo].calle} onChange={e => setCartaPorteForm(f => ({ ...f, [tipo]: { ...f[tipo], calle: e.target.value } }))} placeholder="Ej: Av. Revolución" />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Número</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={cartaPorteForm[tipo].numero} onChange={e => setCartaPorteForm(f => ({ ...f, [tipo]: { ...f[tipo], numero: e.target.value } }))} placeholder="Ej: 1234" />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Colonia</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={cartaPorteForm[tipo].colonia} onChange={e => setCartaPorteForm(f => ({ ...f, [tipo]: { ...f[tipo], colonia: e.target.value } }))} placeholder="Ej: Centro" />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Municipio</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={cartaPorteForm[tipo].municipio} onChange={e => setCartaPorteForm(f => ({ ...f, [tipo]: { ...f[tipo], municipio: e.target.value } }))} placeholder="Ej: Tijuana" />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Estado</label>
                      <select className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none" value={cartaPorteForm[tipo].estado} onChange={e => setCartaPorteForm(f => ({ ...f, [tipo]: { ...f[tipo], estado: e.target.value } }))}>
                        <option value="">Selecciona...</option>
                        {ESTADOS.map(e => <option key={e} value={e}>{e}</option>)}
                      </select>
                    </div>
                  </div>
                </div>
              ))}

              {/* ── Vehículo y Operador ── */}
              <div className="border border-indigo-100 rounded-xl p-4 bg-indigo-50/40">
                <p className="text-xs font-black text-indigo-700 uppercase tracking-wide mb-3 flex items-center gap-1.5">
                  🚛 Vehículo y Operador <span className="text-gray-400 font-normal normal-case tracking-normal">(opcional — para Carta Porte SAT)</span>
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Operador */}
                  <div className="space-y-2">
                    <p className="text-xs font-bold text-gray-600 uppercase tracking-wide">Operador</p>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Nombre del chofer</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none"
                        value={cartaPorteForm.operador?.nombre || ''} onChange={e => setCartaPorteForm(f => ({ ...f, operador: { ...f.operador, nombre: e.target.value } }))}
                        placeholder="Ej: Jesús Valenzuela Morales" />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Licencia federal</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none font-mono"
                        value={cartaPorteForm.operador?.licencia || ''} onChange={e => setCartaPorteForm(f => ({ ...f, operador: { ...f.operador, licencia: e.target.value.toUpperCase() } }))}
                        placeholder="LF-2847193-BC" />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">CURP <span className="text-gray-400 font-normal">(opcional)</span></label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none font-mono"
                        value={cartaPorteForm.operador?.curp || ''} onChange={e => setCartaPorteForm(f => ({ ...f, operador: { ...f.operador, curp: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 18) } }))}
                        placeholder="VAMJ870314HBCLRS09" maxLength={18} />
                    </div>
                  </div>
                  {/* Vehículo */}
                  <div className="space-y-2">
                    <p className="text-xs font-bold text-gray-600 uppercase tracking-wide">Vehículo</p>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Placas</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none font-mono"
                        value={cartaPorteForm.vehiculo?.placas || ''} onChange={e => setCartaPorteForm(f => ({ ...f, vehiculo: { ...f.vehiculo, placas: e.target.value.toUpperCase() } }))}
                        placeholder="BC-483-RGA" />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Configuración vehicular</label>
                      <select className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none"
                        value={cartaPorteForm.vehiculo?.configuracion || ''} onChange={e => setCartaPorteForm(f => ({ ...f, vehiculo: { ...f.vehiculo, configuracion: e.target.value } }))}>
                        <option value="">Selecciona...</option>
                        <option value="T3S3">T3S3 — Tractocamión con semirremolque 3 ejes</option>
                        <option value="T3S2">T3S2 — Tractocamión con semirremolque 2 ejes</option>
                        <option value="C3">C3 — Camión 3 ejes (torton)</option>
                        <option value="C2">C2 — Camión 2 ejes (rabón)</option>
                        <option value="VL">VL — Vehículo ligero</option>
                        <option value="Otro">Otro</option>
                      </select>
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Marca / Modelo</label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none"
                        value={cartaPorteForm.vehiculo?.descripcion || ''} onChange={e => setCartaPorteForm(f => ({ ...f, vehiculo: { ...f.vehiculo, descripcion: e.target.value } }))}
                        placeholder="Ej: Kenworth T680 2022" />
                    </div>
                    <div>
                      <label className="text-xs font-semibold text-gray-600 mb-1 block">Número de remolque <span className="text-gray-400 font-normal">(opcional)</span></label>
                      <input className="w-full border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-400 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none font-mono"
                        value={cartaPorteForm.vehiculo?.numeroRemolque || ''} onChange={e => setCartaPorteForm(f => ({ ...f, vehiculo: { ...f.vehiculo, numeroRemolque: e.target.value.toUpperCase() } }))}
                        placeholder="SR-2847-MXL" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="sticky bottom-0 bg-white border-t px-6 py-4 flex justify-end gap-3 rounded-b-2xl">
              <button onClick={() => setModalCartaPorte(null)} className="px-5 py-2.5 border border-gray-300 rounded-xl bg-white text-gray-600 hover:bg-gray-50 font-medium text-sm">Cancelar</button>
              <button
                disabled={guardandoCartaPorte || !cartaPorteForm.mercancias.every(m => m.descripcion) || !cartaPorteForm.remitente.nombre || !cartaPorteForm.remitente.rfc || !cartaPorteForm.destinatario.nombre || !cartaPorteForm.destinatario.rfc}
                onClick={async () => {
                  setGuardandoCartaPorte(true);
                  try {
                    await apiGuardarCartaPorte(modalCartaPorte.viajeId, cartaPorteForm);
                    recargar();
                    setModalCartaPorte(null);
                    mostrarNotificacion('Datos de Carta Porte guardados correctamente', 'success');
                  } catch (e) {
                    mostrarNotificacion(e.message || 'Error al guardar', 'error');
                  } finally {
                    setGuardandoCartaPorte(false);
                  }
                }}
                className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-semibold text-sm flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {guardandoCartaPorte ? <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> Guardando...</> : <><FileText size={16} /> Guardar Carta Porte</>}
              </button>
            </div>
          </div>
        </div>
        );
      })()}

      {/* ===== LIGHTBOX FOTO INCIDENCIA ===== */}
      {fotoLightbox && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[2000] p-4"
          onClick={() => setFotoLightbox(null)}
        >
          <button
            className="absolute top-4 right-4 text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-80"
            onClick={() => setFotoLightbox(null)}
          >
            <X size={24} />
          </button>
          <img
            src={fotoLightbox}
            alt="Evidencia incidencia"
            className="max-w-full max-h-full rounded-xl shadow-2xl object-contain"
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}

      {/* ── Modal: Confirmar Cancelación de Solicitud ── */}
      {modalCancelarSolicitud && (() => {
        const { sol } = modalCancelarSolicitud;
        const tieneCotizaciones = (sol.cotizaciones?.length ?? 0) > 0;
        return (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1200] p-4">
            <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl">
              <div className="px-6 pt-6 pb-4">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center shrink-0">
                    <Trash2 size={20} className="text-red-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800">¿Cancelar esta solicitud?</h3>
                    <p className="text-gray-500 text-sm">{sol.origen} → {sol.destino}</p>
                  </div>
                </div>

                {tieneCotizaciones && (
                  <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 mb-4 flex items-start gap-2">
                    <AlertCircle size={16} className="text-amber-500 shrink-0 mt-0.5" />
                    <p className="text-amber-700 text-sm">
                      Esta solicitud tiene <strong>{sol.cotizaciones.length} cotización(es)</strong> de transportistas. Se les notificará automáticamente.
                    </p>
                  </div>
                )}

                <div className="mb-5">
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                    Motivo de cancelación <span className="font-normal text-gray-400">(opcional)</span>
                  </label>
                  <select
                    value={motivoCancelacion}
                    onChange={e => { setMotivoCancelacion(e.target.value); setMotivoLibre(''); }}
                    className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm text-gray-700 focus:ring-2 focus:ring-red-400 outline-none mb-2"
                  >
                    <option value="">Selecciona un motivo...</option>
                    <option value="Ya no necesito el flete">Ya no necesito el flete</option>
                    <option value="Encontré otro transportista">Encontré otro transportista</option>
                    <option value="Las cotizaciones recibidas son muy altas">Las cotizaciones recibidas son muy altas</option>
                    <option value="Cambió la fecha de entrega">Cambió la fecha de entrega</option>
                    <option value="Error en los datos de la solicitud">Error en los datos de la solicitud</option>
                    <option value="otro">Otro motivo...</option>
                  </select>
                  {motivoCancelacion === 'otro' && (
                    <input
                      autoFocus
                      value={motivoLibre}
                      onChange={e => setMotivoLibre(e.target.value)}
                      placeholder="Describe el motivo..."
                      className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:ring-2 focus:ring-red-400 outline-none"
                    />
                  )}
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => { setModalCancelarSolicitud(null); setMotivoCancelacion(''); setMotivoLibre(''); }}
                    className="flex-1 py-2.5 border border-gray-200 rounded-xl text-gray-600 text-sm font-medium hover:bg-gray-50 transition"
                  >
                    Volver
                  </button>
                  <button
                    disabled={cancelando}
                    onClick={async () => {
                      setCancelando(true);
                      try {
                        const motivo = motivoCancelacion === 'otro' ? motivoLibre.trim() : motivoCancelacion;
                        await apiCancelarSolicitud(sol.id, motivo || null);
                        storeCancelarSolicitud(sol.id);
                        setModalCancelarSolicitud(null);
                        setMotivoCancelacion('');
                        setMotivoLibre('');
                        setExpandedSolicitud(null);
                        mostrarNotificacion('Solicitud cancelada correctamente.', 'info');
                      } catch (err) {
                        mostrarNotificacion(err.message || 'Error al cancelar la solicitud', 'error');
                      } finally {
                        setCancelando(false);
                      }
                    }}
                    className="flex-1 py-2.5 bg-red-600 hover:bg-red-500 text-white text-sm font-semibold rounded-xl disabled:opacity-50 transition flex items-center justify-center gap-2"
                  >
                    {cancelando
                      ? <><span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" /> Cancelando...</>
                      : <><Trash2 size={15} /> Sí, cancelar solicitud</>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Botón flotante: Nueva Solicitud — solo desktop ── */}
      {!['facturas', 'perfil'].includes(seccion) && (
        <button
          onClick={() => { setSeccion('solicitudes'); setSolicitudParaRepetir(null); setOrigenCoords(null); setDestinoCoords(null); setMostrarFormulario(true); }}
          className="fixed top-14 right-6 z-[900] hidden md:flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold px-4 py-2.5 rounded-xl shadow-lg shadow-blue-500/30 transition-all hover:scale-105 active:scale-95"
        >
          <Plus size={17} />
          <span>Nueva Solicitud</span>
        </button>
      )}

      {/* ── Barra de navegación inferior — solo móvil ── */}
      <div
        className="fixed bottom-0 left-0 right-0 z-[100] md:hidden bg-white border-t border-gray-200"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        <div className="flex items-end h-14">
          {/* Inicio */}
          <button
            onClick={() => setSeccion('dashboard')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors ${seccion === 'dashboard' ? 'text-blue-600' : 'text-gray-500'}`}
          >
            <Package size={20} />
            <span>Inicio</span>
          </button>

          {/* Solicitudes */}
          <button
            onClick={() => setSeccion('solicitudes')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors relative ${seccion === 'solicitudes' ? 'text-blue-600' : 'text-gray-500'}`}
          >
            <FileText size={20} />
            <span>Solicitudes</span>
            {misSolicitudes.filter(s => ['en_cotizacion', 'abierta'].includes(s.status)).length > 0 && (
              <span className="absolute top-2 right-4 w-4 h-4 bg-yellow-500 text-white text-[9px] rounded-full flex items-center justify-center font-bold">
                {misSolicitudes.filter(s => ['en_cotizacion', 'abierta'].includes(s.status)).length}
              </span>
            )}
          </button>

          {/* + Nueva Solicitud — botón central elevado */}
          <button
            onClick={() => { setSeccion('solicitudes'); setSolicitudParaRepetir(null); setOrigenCoords(null); setDestinoCoords(null); setMostrarFormulario(true); }}
            className="flex-1 flex flex-col items-center justify-end pb-1 gap-0.5"
          >
            <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center shadow-lg shadow-blue-500/40 -mt-5 mb-0.5">
              <Plus size={22} className="text-white" />
            </div>
            <span className="text-[10px] text-gray-500 font-medium">Nueva</span>
          </button>

          {/* Mis Viajes */}
          <button
            onClick={() => setSeccion('viajes')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors relative ${seccion === 'viajes' ? 'text-blue-600' : 'text-gray-500'}`}
          >
            <Truck size={20} />
            <span>Mis Viajes</span>
            {viajesActivos.length > 0 && (
              <span className="absolute top-2 right-4 w-4 h-4 bg-blue-500 text-white text-[9px] rounded-full flex items-center justify-center font-bold">
                {viajesActivos.length}
              </span>
            )}
          </button>

          {/* Pagos */}
          <button
            onClick={() => setSeccion('pagos')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors ${seccion === 'pagos' ? 'text-blue-600' : 'text-gray-500'}`}
          >
            <CreditCard size={20} />
            <span>Pagos</span>
          </button>
        </div>
      </div>

      <FeedbackButton pantalla={seccion} />

      {/* ── Modal: Reportar problema con un viaje ── */}
      {modalTicket && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[1300] p-4" onClick={() => setModalTicket(null)}>
          <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl" onClick={e => e.stopPropagation()}>
            <div className="px-6 pt-6 pb-4">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center shrink-0">
                  <AlertCircle size={20} className="text-red-600" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg">Reportar un problema</h3>
                  <p className="text-sm text-gray-500">{modalTicket.origen} → {modalTicket.destino}</p>
                </div>
              </div>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">Tipo de problema</label>
                  <select
                    value={ticketTipo}
                    onChange={e => setTicketTipo(e.target.value)}
                    className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
                  >
                    <option value="">Selecciona una opción...</option>
                    <option value="Problema con transportista">Problema con el transportista</option>
                    <option value="Pago no procesado">Pago no procesado o error en cobro</option>
                    <option value="Retraso en entrega">Retraso en la entrega</option>
                    <option value="Carga dañada o perdida">Carga dañada o perdida</option>
                    <option value="Viaje cancelado sin aviso">Viaje cancelado sin aviso</option>
                    <option value="Otro">Otro problema</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">Describe el problema</label>
                  <textarea
                    rows={4}
                    value={ticketDescripcion}
                    onChange={e => setTicketDescripcion(e.target.value)}
                    placeholder="Explica con detalle qué ocurrió para que podamos ayudarte..."
                    className="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
                  />
                </div>
              </div>
            </div>
            <div className="flex gap-3 px-6 pb-6">
              <button
                onClick={() => setModalTicket(null)}
                className="flex-1 px-4 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-medium text-sm hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                disabled={ticketEnviando || !ticketTipo || ticketDescripcion.trim().length < 10}
                onClick={async () => {
                  if (!ticketTipo || ticketDescripcion.trim().length < 10) return;
                  setTicketEnviando(true);
                  try {
                    const texto = `[TICKET - ${ticketTipo}] ${ticketDescripcion.trim()}`;
                    await apiEnviarMensaje({ viajeId: modalTicket.viajeId, texto, destinatarioRol: 'admin' });
                    const nuevosTickets = [...new Set([...viajesConTicket, modalTicket.viajeId])];
                    setViajesConTicket(nuevosTickets);
                    localStorage.setItem(_ticketsKey, JSON.stringify(nuevosTickets));
                    setModalTicket(null);
                    mostrarNotificacion('Tu reporte fue enviado. El equipo de soporte lo revisará pronto.', 'exito');
                  } catch {
                    mostrarNotificacion('Error al enviar el reporte. Intenta de nuevo.', 'error');
                  } finally {
                    setTicketEnviando(false);
                  }
                }}
                className="flex-1 px-4 py-2.5 rounded-xl bg-red-600 text-white font-semibold text-sm hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {ticketEnviando ? 'Enviando...' : 'Enviar reporte'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AppCliente;